/*
 * サブシステム名：配車
 * 機能名：D2標準配車管理
 */

import { mapGetters } from 'vuex'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import modals from '@/ddv2.library/modals'
import indexeddb from '@/ddv2.library/indexeddb'
import header from '@/ddv2.library/header'
// import message from '@/ddv2.library/messages'
// import date from '@/ddv2.library/date'
// import validators from '@/rahmen/validators'

import draggable from 'vuedraggable'
import vueSimpleContextMenu from 'vue-simple-context-menu'
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css'
import dayjs from 'dayjs'

import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import minMax from 'dayjs/plugin/minMax'

const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdDateBox = () => import('@/components/DdDateBox')
const DdSimpleTable = () => import('@/components/DdSimpleTable')
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCustomButton = () => import('@/components/DdCustomButton')
const DdSwitch = () => import('@/components/DdSwitch')
const DdDropDown = () => import('@/components/DdDropDown')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
// const DdHaishaJissekiDialog = () => import('@/components/DdHaishaJissekiDialog.vue')
const DdHaishaJuchuDialog = () => import('@/components/DdHaishaJuchuDialog.vue')
const DdHaishaSagyoEditDialog = () => import('@/components/DdHaishaSagyoEditDialog.vue')
const DdHaishaOrderFilterDialog = () => import('@/components/DdHaishaOrderFilterDialog')
const DdHaishaOrderSortDialog = () => import('@/components/DdHaishaOrderSortDialog')
const DdHaishaDriverFilterDialog = () => import('@/components/DdHaishaDriverFilterDialog')
const DdHaishaDriverSortDialog = () => import('@/components/DdHaishaDriverSortDialog')
const DdHaishaCarFilterDialog = () => import('@/components/DdHaishaCarFilterDialog')
const DdHaishaJissekiFilterDialog = () => import('@/components/DdHaishaJissekiFilterDialog')
const DdPackageHaishaCopyDialog = () => import('@/components/DdPackageHaishaCopyDialog')
const DdPackageTeikeiCourseSearchDialog = () => import('@/components/DdPackageTeikeiCourseSearchDialog')

dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(isBetween)
dayjs.extend(minMax)

// ---------------------------- 定数定義 ---------------------------------------
const USE_DATAINDEX = 0
const USE_DISPLAYINDEX = 1

// サーバをチェックする間隔 (msec)
// const SERVER_CHECK_TIME_MS = 3000000 // 1000 * 60 * 5 調査時邪魔なのでちょっと伸ばす
const SERVER_CHECK_TIME_MS = 300000 // 1000 * 60 * 5 (5min)
// 終了時間が入力されていないオーダのデフォルトの配送時間
const DEFUALT_ORDER_LENGTH = 60 // 60min (1時間)

// 右クリック貼り付けの時に優先される時間(true: チケットの時間:false グリッドの時間)
const IS_PRIORITY_ORDER_TIME_ON_CONTEXTMENU = true

const LOCK_ICON_TAG_ON = '<span class="v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--x-small black--text"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-lock theme--light"></i></span></span>'
const LOCK_ICON_TAG_OFF = '<span class="v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--x-small black--text"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-lock-off theme--light"></i></span></span>'
// ---------------------------- 定数定義 ---------------------------------------

export default {
  name: 'VdpHaishaKanri',
  mixins: [flowMixin],
  components: {
    // DdSubHeader,
    // DdSubTitle,
    // DdTextBox,
    DdDefaultButton,
    DdFooterButton,
    DdDateBox,
    DdSimpleTable,
    DdCheckbox,
    DdCustomButton,
    DdSwitch,
    // DdTimeBox,
    DdDropDown,
    // DdTextArea,
    DdCodeTextBox,
    // DdNumericBox,
    DdIconButtonWithTooltip,
    // DdDataTable,
    // DdRadioButton,
    // DdHaishaJissekiDialog,
    DdHaishaJuchuDialog,
    DdHaishaSagyoEditDialog,
    DdHaishaOrderFilterDialog,
    DdHaishaOrderSortDialog,
    DdHaishaDriverFilterDialog,
    DdHaishaDriverSortDialog,
    DdHaishaCarFilterDialog,
    DdHaishaJissekiFilterDialog,
    DdPackageHaishaCopyDialog,
    DdPackageTeikeiCourseSearchDialog,
    draggable,
    vueSimpleContextMenu
    // FullCalendar // make the <FullCalendar> tag available
  },
  data: function () {
    return {
      // 画面モード
      viewMode: 0, // デフォルト 0:車両 1:人員
      // 検索後かどうか
      afterSearch: false,
      // 画面表示制御
      tableHeightX: 400,
      // フォントサイズ定義
      sizeType: 0,

      // 権限モード
      modeKengen: 0,

      // サマリ表示
      showSummary: true,

      // チェックボックスで選択関連
      isUseCheckbox: false, // trueでデフォルト複数選択
      isSelectSingleOnly: false, // trueでチェックボックスで１こしか選べない
      isDriverMultiSelect: true, // trueでドライバーを複数選べる
      isUseLockIcon: true, // 受注チップの右端にロックアイコンを出すか

      // トレイ表示対象
      showAll: true, // trueで全て、falseで検索範囲内のみを対象 ※初期表示は全て表示

      // テスト環境用変数
      // debugChipCount: 500,
      isDebugging: true,
      isErrorToGo: false,

      // ページャ制御用変数
      usePager: false,
      page: 1,
      linesPerPage: 3,

      // D&D制御用
      isCopyMode: false,
      saveTicketId: null,

      // チケットドロワ用タブ制御
      tickettab: null,
      // orderDialogTab: null,

      // 初期表示用時間定義
      tableStartHourDisp: '6:00',
      // tableStartHour: 6, - computedへ
      rangeDisp: '24時間',
      rangeDispList: ['24時間', '48時間', '3日', '5日', '7日'],
      // hours: 24, -- computed
      hoursInterval: 1,

      // ダイアログ制御用変数
      // colorDialog: false,
      // autoplaningDialog: false,
      orderTicketEditDialog: false,
      sagyoTicketEditDialog: false,
      jissekiEditDialog: false,
      orderFilterDialog: false,
      orderSortDialog: false,
      driverFilterDialog: false,
      driverSortDialog: false,
      carFilterDialog: false,
      jissekiFilterDialog: false,
      haishaCopyDialog: false,
      addTeikeiDialog: false,
      editingGridRowIndex: -1,
      orderTicketReadOnlyMode: false,
      sagyoTicketReadOnlyMode: false,
      isRequiredHms: false,
      orderDialogTekiyoYmd: '',
      // サーバチェック用タイマ変数
      isRecommendReload: false,
      objTimer: null,
      isSaving: false, // 保存中のフラグ：保存処理中にサーバチェックをさせないため

      // 自動割り当てダイアログ用
      // apd: {
      //   autoMatchData: []
      // },
      // 検索条件
      conditions: {
        tekiyoYmd: '',
        tekiyoYmdInput: '',
        hourFlg: false,
        eigyoshoCd: '',
        // chakuti: '',
        endtime: '',
        // syasyu: '',
        // syain: '',
        // forceMany: false,
        // fullCalender: false,
        line1: false,
        haishaShashuSbt: null,
        haishahyoCd: null,
        sagyoYoteiYmdFrom: '',
        sagyoYoteiYmdTo: '',
        tableStartHourDisp: '6:00',
        rangeDisp: '24時間',
        haishaShashuSbtDisp: null,
        haishahyoCdDisp: null,
        eigyoshoCdDisp: null
      },
      csvSearchConditions: {
        tekiyoYmdInput: '',
        sagyoYoteiYmdFrom: '',
        sagyoYoteiYmdTo: '',
        haishahyoCd: '',
        eigyoshoCd: ''
      },
      // 受注ダイアログ用↓
      // diag: {
      //   dispJissekiKakunizumiFlg: '',
      //   eigyoshoId: '',
      //   jininId: '',
      //   shuroKbn: '',
      //   kosokuJikan: '',
      //   zangyoJikan: '',
      //   shinyaJikan: '',
      //   kinmuTeateKingaku1: '',
      //   kinmuTeateKingaku2: '',
      //   kinmuTeateKingaku3: '',
      //   kinmuTeateKingaku4: '',
      //   kinmuTeateKingaku5: '',
      //   jininId2: '',
      //   shuroKbn2: '',
      //   kosokuJikan2: '',
      //   zangyoJikan2: '',
      //   shinyaJikan2: '',
      //   kinmuTeateKingaku2_1: '',
      //   kinmuTeateKingaku2_2: '',
      //   kinmuTeateKingaku2_3: '',
      //   kinmuTeateKingaku2_4: '',
      //   kinmuTeateKingaku2_5: '',
      //   sharyoId: '',
      //   jishaSharyoSbt: '',
      //   hatsuchiOdoMater: '',
      //   chakuchiOdoMater: '',
      //   sokoKyori: '',
      //   jisshaKyori: '',
      //   kushaKyori: '',
      //   sosekisairyo: '',
      //   dispJisshaRitsu: ''
      // },
      // recTsukoryo: {},
      // recNenryo: {},
      // recHaisoMeisai: {},
      // datavalue: [],
      recOrderInfo: { /* ダイアログ用 */
      },
      recJissekiInfo: {}, /* ダイアログ用 */
      // haisoMeisaiListHeaders: [
      //   { text: 'ID', value: 'id', align: ' d-none' },
      //   { text: '', value: 'selectRow' },
      //   { text: '明細No', value: 'juchuMeisaiNo' },
      //   { text: '得意先', value: 'dispTokuisaki' },
      //   { text: '発地', value: 'dispHatsuchi' },
      //   { text: '発地日時', value: 'dispHatsuchiYmd' },
      //   { text: '着地', value: 'dispChakuchi' },
      //   { text: '着地日時', value: 'dispChakuchiYmd' },
      //   { text: '品名', value: 'dispHinmei' },
      //   { text: '数量', value: 'juchuSuryo', align: 'right' },
      //   { text: '重量', value: 'juchuJuryo', align: 'right' },
      //   { text: '操作', value: 'actions', sortable: false, width: '20px' }
      // ],
      // nenryohiListHeaders: [
      //   { text: 'ID', value: 'id', align: ' d-none' },
      //   { text: '', value: 'selectRow' },
      //   { text: 'No', value: 'nenryohiNo' },
      //   { text: '車両経費No', value: 'sharyoKeihiNo' },
      //   { text: '給油所', value: 'wTorihikisakiCdNm' },
      //   { text: '燃料名', value: 'wFuelKbnNm' },
      //   { text: '給油量', value: 'suryo', align: 'right' },
      //   { text: '単価', value: 'keihiTanka', align: 'right' },
      //   { text: '金額', value: 'keihiKingaku', align: 'right' },
      //   { text: '支払方法', value: 'wShiharaiKbnNm' },
      //   { text: 'カード番号', value: 'tekiyo4' },
      //   { text: '操作', value: 'actions', sortable: false, width: '20px' }
      // ],
      // tsukoryoListHeaders: [
      //   { text: 'ID', value: 'id', align: ' d-none' },
      //   { text: '', value: 'selectRow' },
      //   { text: 'No', value: 'tsukoryoNo' },
      //   { text: '車両経費No', value: 'sharyoKeihiNo' },
      //   { text: '入口料金所', value: 'tekiyo1' },
      //   { text: '出口料金所', value: 'tekiyo2' },
      //   { text: '回数', value: 'suryo', align: 'right' },
      //   { text: '金額', value: 'keihiKingaku', align: 'right' },
      //   { text: '支払方法', value: 'wShiharaiKbnNm' },
      //   { text: 'カード番号', value: 'tekiyo4' },
      //   { text: '操作', value: 'actions', sortable: false, width: '20px' }
      // ],
      // filteredHaisoMeisaiListRows: [],
      // nenryohiRows: [],
      // tsukoryoRows: [],
      isNotOrderNew: false,
      // 受注ダイアログ用↑
      // 各種トランザクションデータ
      sagyoKeikaku: [], //  vw_c_d2plmd00200に対応
      keikakuSharyoList: [], // vw_c_mst_sharyoに対応
      keikakuJininList: [], // vw_c_mst_eigyosho_jinin_listに対応
      keikakuSagyoMeisai: [], // vw_c_d2plmd00201に対応
      keikakuSagyoMeisai2: [], // vw_c_d2plmd00102に対応
      tempSavedDataPlanFromIndexDb: [],
      tempSavedDataSagyoFromIndexDb: [],
      tempSavedDataWorkFromIndexDb: [],
      // order: [],
      // works: [], // とりあえず残す
      // dr: [],
      // sharyo: [],
      recCar: [],
      recDriver: [],

      // 伸び縮み関連変数
      onStereching: false,
      clonedObject: null,
      orgObject: null,
      // 画面ピクセル制御用
      widthOfHours: [],
      widthOfLineHeader: [0, 0, 0, 0, 0, 0],
      // チケットエリア表示切替用
      ticketVisibleFlag: true,
      // チケットドロワー再表示制御用
      orderRedrawFlag: true,
      driverRedrawFlag: true,
      carRedrawFlag: true,
      worksRedrawFlag: true,
      // 右クリック用定義
      readonlyArea: [],
      isDisplayHover: false,
      isThisItemKakutei: false,
      orderTicketContextMenuEmpty: [],
      ticketItemsShowDetail: {
        name: '詳細表示',
        slug: 'showDetail'
      },
      ticketItemsReturnTray: {
        name: 'トレイに戻す',
        slug: 'returnTray'
      },
      ticketItemsShowDatailReadonly: {
        name: '詳細表示',
        slug: 'showDetailReadonly'
      },
      ticketItemsToLock: {
        name: '確定',
        slug: 'toLock',
        class: 'contextmenuseletedlock'
      },
      ticketItemsToUnLock: {
        name: '確定',
        slug: 'toUnLock',
        class: 'contextmenuseletedlock'
      },
      ticketItemsToLockAll: {
        name: 'この車両のチップを全確定',
        slug: 'toLockAll'
      },
      ticketItemsToUnLockAll: {
        name: 'この車両のチップを全確定解除',
        slug: 'toUnLockAll'
      },
      ticketItemsDeleteTicket: {
        name: 'チップを削除',
        slug: 'deleteChip'
      },
      ticketItemsToCopyMode: {
        name: 'コピーモード',
        slug: 'selectCopyMode',
        class: 'contextmenuseleted'
      },
      TicketContextMenuContextEmpty: [],
      orderTicketContextMenuContext: [
        {
          name: '詳細表示',
          slug: 'showDetail'
        },
        {
          name: 'トレイに戻す',
          slug: 'returnTray'
        }
      ],
      orderTicketReadonlyContextMenuContext: [
        {
          name: '詳細表示',
          slug: 'showDetailReadonly'
        }
      ],
      // TicketContextMenuContext: [
      //   {
      //     name: 'トレイに戻す',
      //     slug: 'returnTray'
      //   },
      //   {
      //     name: 'コピーモード',
      //     slug: 'selectCopyMode',
      //     class: 'contextmenuseleted'
      //   }
      // ],
      // TicketContextMenuContext2: [
      //   {
      //     name: 'チップを削除',
      //     slug: 'deleteChip'
      //   },
      //   {
      //     name: 'コピーモード',
      //     slug: 'selectCopyMode',
      //     class: 'contextmenuseleted'
      //   }
      // ],
      // fieldContextMenu: [
      //   {
      //     name: '受注追加',
      //     slug: 'newOrder'
      //   },
      //   {
      //     name: '作業追加',
      //     slug: 'newWork'
      //   }
      // ],
      // fieldContextMenuAddPaste: [
      //   {
      //     name: '選択した受注作業を割付',
      //     slug: 'pasteOrder'
      //   },
      //   {
      //     name: '受注追加',
      //     slug: 'newOrder'
      //   },
      //   {
      //     name: '作業追加',
      //     slug: 'newWork'
      //   }
      // ],
      // fieldContextMenu2: [
      //   {
      //     name: '作業追加',
      //     slug: 'newWork'
      //   }
      // ],
      // fieldContextMenu2AddPaste: [
      //   {
      //     name: '選択した受注作業を割付',
      //     slug: 'pasteOrder'
      //   },
      //   {
      //     name: '作業追加',
      //     slug: 'newWork'
      //   }
      // ],
      contextMenuContextEmpty: [],
      contextMenuContextEmpty2: [],
      contextMenuContextEmpty3: [],
      ticketItemsDefaultDriver: {
        name: '既定の乗務員を割付',
        slug: 'defaultDriver'
      },
      ticketItemsPasteOrder: {
        name: '選択した受注作業を割付',
        slug: 'pasteOrder'
      },
      ticketItemsPasteDriver: {
        name: '選択した乗務員を乗務員に割付',
        slug: 'pasteDriver'
      },
      ticketItemsPasteSubDriver: {
        name: '選択した乗務員を同乗者に割付',
        slug: 'pasteSubDriver'
      },
      ticketItemsPasteDriver2: {
        name: '選択した乗務員を割付',
        slug: 'pasteDriver'
      },
      ticketItemsPasteDriverNo1: {
        name: '選択した1番の乗務員を割付',
        slug: 'pasteDriver'
      },
      ticketItemsPasteDriverNo1onCar: {
        name: '選択した1番の乗務員を乗務員に割付',
        slug: 'pasteDriver'
      },
      ticketItemsPasteSubDriverNo1onCar: {
        name: '選択した1番の乗務員を同乗者に割付',
        slug: 'pasteSubDriver'
      },
      ticketItemsPasteDriverSeq: {
        name: '選択した乗務員を空いている乗務員にここから順番に割付',
        slug: 'pasteSeqDriver'
      },
      ticketItemsNewWork: {
        name: '作業追加',
        slug: 'newWork'
      },
      ticketItemsNewOrder: {
        name: '受注追加',
        slug: 'newOrder'
      },
      // carTicketContextMenuContext: [
      //   {
      //     name: '既定の乗務員を割付け',
      //     slug: 'defaultDriver'
      //   }
      // ],
      // carTicketContextMenuAddPaste1: [
      //   {
      //     name: '選択した受注作業を割付',
      //     slug: 'pasteOrder'
      //   }
      // ],
      // carTicketContextMenuAddPaste2: [
      //   {
      //     name: '選択した受注作業を割付',
      //     slug: 'pasteOrder'
      //   },
      //   {
      //     name: '既定の乗務員を割付け',
      //     slug: 'defaultDriver'
      //   }
      // ],
      trayOrderTicketContextMenu: [
        {
          name: '全選択解除',
          slug: 'deselectAll'
        }
      ],
      // フィルター定義 －－ここから－－
      orderFilterConditions: {
        ninushiCd: '',
        ninushiNm: '',
        hatsuchiCd: '',
        hatsuchiNm: '',
        hatsuchiFromHms: '',
        hatsuchiToHms: '',
        chakuchiCd: '',
        chakuchiNm: '',
        chakuchiFromHms: '',
        chakuchiToHms: '',
        freeWord: '',
        juchuEigyoshoCd: '',
        juchuEigyoshoNm: '',
        sagyoEigyoshoCd: '',
        sagyoEigyoshoNm: '',
        unkoYmd: null,
        chumonNo: ''
      },
      driverFilterConditions: {
        jininCd: '',
        jininNm: '',
        eigyoshoCd: '',
        eigyoshoNm: '',
        isOnlyJomuin: true
      },
      carFilterConditions: {
        sharyoCd: '',
        jidoshaHyojiNm: '',
        shashuSbt: '',
        eigyoshoCd: '',
        eigyoshoNm: '',
        onDriver: 0,
        onYosha: 0
      },
      jissekiFilterConditions: [],
      // フィルター定義 －－ここまで－－

      // 並び替え定義 －－ここから－－
      orderSortArgs: {
        orderSortKey1: 'asc',
        orderSortKey2: 'asc',
        orderSortKey3: 'asc',
        orderSortKeyValue1: '',
        orderSortKeyValue2: '',
        orderSortKeyValue3: ''
      },
      orderSortList: [
        { value: 'ninushiCd', text: '取引先コード' },
        { value: 'ninushiNm', text: '取引先名称' },
        { value: 'hatsuchiCd', text: '積地コード' },
        { value: 'hatsuchiNm', text: '積地名称' },
        { value: 'hatsuchiHms', text: '積時刻' },
        { value: 'chakuchiCd', text: '卸地コード' },
        { value: 'chakuchiNm', text: '卸地名称' },
        { value: 'chakuchiHms', text: '卸時刻' }
      ],
      driverSortArgs: {
        driverSortKey1: 'asc',
        driverSortKey2: 'asc',
        driverSortKey3: 'asc',
        driverSortKeyValue1: '',
        driverSortKeyValue2: '',
        driverSortKeyValue3: ''
      },
      driverSortList: [
        { value: 'jininCd', text: '人員コード' },
        { value: 'jininNm', text: '氏名' },
        { value: 'eigyoshoCd', text: '所属営業所コード' },
        { value: 'eigyoshoNm', text: '所属営業所名称' }
      ],
      carSortKey1: 'asc',
      carSortKey2: 'asc',
      carSortKey3: 'asc',
      carSortList: [
        { value: 'sharyoNo', text: '車両番号' },
        { value: 'jishaHyojiNm', text: '車両名称' },
        { value: 'shashuSbt', text: '車種種別' },
        { value: 'eigyoshoCd', text: '管理営業所コード' },
        { value: 'eigyoshoNm', text: '管理営業所名称' },
        { value: 'sharyoGroupSbt1', text: '車両グループ種別１' },
        { value: 'sharyoGroupSbt2', text: '車両グループ種別２' },
        { value: 'sharyoGroupSbt3', text: '車両グループ種別３' },
        { value: 'sharyoGroupSbt4', text: '車両グループ種別４' },
        { value: 'sharyoGroupSbt5', text: '車両グループ種別５' }
      ],
      // 並び替え定義 －－ここまで－－

      // 配車複写定義 －－ここから－－
      haishaCopyConditions: {
        fromHaisyaYmd: '',
        mstHaishahyoId: '',
        startHM: ''
      },
      // 配車複写定義 －－ここまで－－
      // 定型一括追加定義 －－ここから－－
      teikeiCopyConditions: {
        startHM: ''
      },
      // 配車複写定義 －－ここまで－－

      // フッターボタン制御定義
      isCsvDownloader: false,
      // isFooterBtnDisable: false, -- comutedへ
      // マスタ用ヘッダ定義（dd-code-text-box用)
      headersEigyoshoList: header.mstEigyoshoHeaders,
      mstEigyoshoHeaders: header.mstEigyoshoHeaders,
      mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
      mstJininHeaders: header.mstJininHeaders,
      mstSharyoHeaders: header.vwCMstSharyoHeaders,
      mstHinmeiHeaders: header.mstHinmeiHeaders,
      mstHacchakuchiHeaders: header.mstHacchakuchiHeaders
    }
  },
  watch: {
    linesPerPage: function (newLinesPerPage, oldLinesPerPage) {
      this.page = 1
    },
    page: function (newPage, oldPage) {
      this.onChangePageData(newPage, oldPage)
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyosho: 'users/eigyoshoCd',
      currentKaishaCode: 'users/currentKaishaCode',
      haishahyoList: 'DDMasters/mstHaishahyo',
      haishahyoSharyoList: 'DDMasters/vwCMstHaishahyoSharyo',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      teikeiCourseList: 'DDMasters/vwCD2mstd0460',
      tempStoredDataPlan: 'tempData/getvwcd2plmd00200',
      tempStoredDataSagyo: 'tempData/getvwcd2plmd00201',
      tempStoredDataWork: 'tempData/getvwcd2plmd00102',
      systemConfigList: 'DDMasters/msysSystemConfig',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    // hours () {
    //   if (this.conditions.hourFlg) {
    //     return 48
    //   } else {
    //     return 24
    //   }
    // },
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredEigyoshoListExcludes99 () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' && elem.eigyoshoCd !== '99'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    // 人員マスタフィルター --> ここから
    filteredVwcMstJinin () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    // filteredJishaJininList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.filteredVwcMstJinin.filter((t) => {
    //     return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.eigyoshoKbn !== '03'
    //   })
    // },
    // filteredYoshaJininList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.filteredVwcMstJinin.filter((t) => {
    //     return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.eigyoshoKbn === '03'
    //   })
    // },
    // 人員マスタフィルター <-- ここまで
    // 営業所マスタフィルター --> ここから
    // filteredEigyoshoList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.eigyoshoList.map((elem) => {
    //     elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
    //     elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
    //     return elem
    //   }).filter(function (elem) {
    //     return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
    //   })
    // },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // filteredMstTokuisakiList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.filteredMstTorihikisaki.filter((t) => {
    //     return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
    //   })
    // },
    // filteredMstHacchusakiList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.filteredMstTorihikisaki.filter((t) => {
    //     return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
    //   })
    // },
    // filteredMstShiiresakiList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.filteredMstTorihikisaki.filter((t) => {
    //     return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.shiiresakiFlg === true
    //   })
    // },
    // 取引先マスタフィルター <-- ここまで
    // 車両マスタフィルター --> ここから
    // filteredMstSharyo () {
    //   return this.sharyoList.map((elem) => {
    //     elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
    //     elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
    //     return elem
    //   })
    // },
    // filteredMstSharyoList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.filteredMstSharyo.filter((t) => {
    //     return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === false
    //   })
    // },
    // filteredMstYoshaSharyoList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.filteredMstSharyo.filter((t) => {
    //     return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
    //   })
    // },
    // 車両マスタフィルター <-- ここまで
    // 品名マスタフィルター --> ここから
    // filteredHinmeiList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.hinmeiList.map((elem) => {
    //     elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
    //     elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
    //     return elem
    //   }).filter(function (elem) {
    //     return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
    //   })
    // },
    // 品名マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    // filteredHacchakuchiList () {
    //   const target = filter.dateFormatter(new Date())
    //   return this.hacchakuchiList.map((elem) => {
    //     elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
    //     elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
    //     return elem
    //   }).filter(function (elem) {
    //     return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
    //   })
    // },
    // 発着地マスタフィルター <-- ここまで
    // 就労区分フィルター
    // filteredShuroKbnList () {
    //   return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF999')
    // },
    // 配車車種種別フィルター
    filteredHaishaSharyoShubetsList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN033')
    },
    // 配車表フィルター
    filteredHaishaHyoList () {
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = this.haishahyoList.map(elem => {
        return {
          value: elem.haishahyoCd,
          text: `${elem.haishahyoCd}:${elem.haishahyoNm}`
        }
      })
      return defArray.concat(resultArray)
    },
    // 定型コースフィルター
    filteredTeikeiCourseList () {
      return this.teikeiCourseList.map((elem) => {
        if (!elem.teikeiCourseNm) { elem.teikeiCourseNm = '' }
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiCd + ' : ' + elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiCd + ' : ' + elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiCd + ' : ' + elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiCd + ' : ' + elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Cd + ' : ' + elem.keiyuchiId1Nm : elem.keiyuchiId1Biko
        elem.keiyuchiId2Disp = elem.keiyuchiId2 ? elem.keiyuchiId2Cd + ' : ' + elem.keiyuchiId2Nm : elem.keiyuchiId2Biko
        elem.keiyuchiId3Disp = elem.keiyuchiId3 ? elem.keiyuchiId3Cd + ' : ' + elem.keiyuchiId3Nm : elem.keiyuchiId3Biko
        elem.keiyuchiId4Disp = elem.keiyuchiId4 ? elem.keiyuchiId4Cd + ' : ' + elem.keiyuchiId4Nm : elem.keiyuchiId4Biko
        elem.keiyuchiId5Disp = elem.keiyuchiId5 ? elem.keiyuchiId5Cd + ' : ' + elem.keiyuchiId5Nm : elem.keiyuchiId5Biko
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + ' km' : null
        elem.yoteiSagyoJikanDisp = elem.yoteiSagyoJikan ? filter.minToIntervalTimeFormatter(elem.yoteiSagyoJikan) : null
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.hokanKingaku) { elem.hokanKingaku = filter.numericFormatter(elem.hokanKingaku) }
        if (elem.niekiKingaku) { elem.niekiKingaku = filter.numericFormatter(elem.niekiKingaku) }
        if (elem.nenryoSurcharge) { elem.nenryoSurcharge = filter.numericFormatter(elem.nenryoSurcharge) }
        if (elem.tsumikomiKingaku) { elem.tsumikomiKingaku = filter.numericFormatter(elem.tsumikomiKingaku) }
        if (elem.torioroshiKingaku) { elem.torioroshiKingaku = filter.numericFormatter(elem.torioroshiKingaku) }
        elem.taikiJikanDisp = elem.taikiJikan ? filter.minToIntervalTimeFormatter(elem.taikiJikan) : null
        if (elem.taikiJikanTanka) { elem.taikiJikanTanka = filter.numericFormatter(elem.taikiJikanTanka) }
        if (elem.taikiJikanKingaku) { elem.taikiJikanKingaku = filter.numericFormatter(elem.taikiJikanKingaku) }
        if (elem.futaiGyomuKingaku) { elem.futaiGyomuKingaku = filter.numericFormatter(elem.futaiGyomuKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.tatekaekinHikazei) { elem.tatekaekinHikazei = filter.numericFormatter(elem.tatekaekinHikazei) }
        elem.warimashiTaishoJikanDisp = elem.warimashiTaishoJikan ? filter.minToIntervalTimeFormatter(elem.warimashiTaishoJikan) : null
        if (elem.warimashiJikanTanka) { elem.warimashiJikanTanka = filter.numericFormatter(elem.warimashiJikanTanka) }
        elem.warimashiTaishoKyoriDisp = elem.warimashiTaishoKyori ? filter.numericFormatter(elem.warimashiTaishoKyori) + ' km' : null
        if (elem.warimashiKyoriTanka) { elem.warimashiKyoriTanka = filter.numericFormatter(elem.warimashiKyoriTanka) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.sagyoinTeateKingaku1) { elem.sagyoinTeateKingaku1 = filter.numericFormatter(elem.sagyoinTeateKingaku1) }
        if (elem.sharyoKeihiHiwayEtc) { elem.sharyoKeihiHiwayEtc = filter.numericFormatter(elem.sharyoKeihiHiwayEtc) }
        if (elem.sharyoKeihiHiwayGenkin) { elem.sharyoKeihiHiwayGenkin = filter.numericFormatter(elem.sharyoKeihiHiwayGenkin) }
        if (elem.sharyoKeihiFerry) { elem.sharyoKeihiFerry = filter.numericFormatter(elem.sharyoKeihiFerry) }
        return elem
      }).sort((a, b) => {
        if (a.teikeiCourseNo < b.teikeiCourseNo) { return -1 }
        if (a.teikeiCourseNo > b.teikeiCourseNo) { return 1 }
        return 0
      })
    },
    // // 車種フィルター
    // filteredSharyoShubetsList () {
    //   return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    // },
    // // 燃料区分フィルター
    // filteredNenryoKubunList () {
    //   return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF053')
    // },
    // // 支払種別フィルター
    // filteredShiharaiShubetsList () {
    //   return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT021')
    // },
    // // 往復種別フィルター
    // filteredOhfukuShubetsList () {
    //   return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    // },
    // // 運賃計算方法区分フィルター
    // filteredUnchinKeisanKbnList () {
    //   return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN025')
    // },
    // // 単位区分フィルター
    // filteredUnitKbnList () {
    //   return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    // },
    // // 課税区分
    // filteredKazeiKbnList () {
    //   return this.sbtListFilterForDropDownItem(this.kubunList, 'SFF059')
    // },
    // // 端数処理区分
    // filteredHasuKeisanKbnList () {
    //   return this.sbtListFilterForDropDownItem(this.kubunList, 'SFF060')
    // },
    filterdHours () {
      return [8, 12, 24, 48, 72, 96]
    },
    filterdStartHour () {
      // return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
      var hourArray = ['0:00']
      for (let h = 1; h < 24; h++) {
        hourArray.push(String(h) + ':00')
      }
      return hourArray
    },
    filterdLines () {
      return [30, 50, 100, 500]
    },
    filterdPages () {
      const self = this
      // if (this.usePager) {
      //   return [1]
      // }
      if (this.viewMode === 0) {
        var cars = self.keikakuSharyoList.filter(function (elem) {
          return self.isCarSearchCheck(elem)
        })
        var totallines = cars.length
      } else {
        totallines = this.keikakuJininList.length
      }
      // var totallines = this.viewMode === 0 ? this.keikakuSharyoList.length : this.keikakuJininList.length
      var pages = Math.floor(totallines / this.linesPerPage) + 1
      return Array.from(new Array(pages)).map((v, i) => i + 1)
    },
    /**
     * 車両別画面の表示データ
     * 車両ID,車両の一行目(masterFlgがオン),車両の一行目と同じ乗務員,乗務員ID順に表示する
     **/
    filteredRows () {
      const self = this

      var cars = self.keikakuSharyoList.filter(function (elem) {
        // 適用期間内の車両しか行には表示しない
        if (!self.tekiyoYmdDayjs.isBetween(elem.tekiyoStartYmd, elem.tekiyoEndYmd, 'day', '[]')) {
          return false
        }
        return self.isCarSearchCheck(elem)
      })

      if (this.usePager) {
        var pageSharyo = cars.slice((this.page - 1) * this.linesPerPage, (this.page - 1) * this.linesPerPage + this.linesPerPage)
        cars = self.recCar.filter((e) => {
          return pageSharyo.some((et) => {
            return e.car.id === et.id
          })
        }).filter((e) => {
          return self.isJissekiFilterCheck(e)
        })
      } else {
        pageSharyo = cars
        cars = self.recCar.filter((e) => {
          return pageSharyo.some((et) => {
            return e.car.id === et.id
          })
        }).filter((e) => {
          return self.isJissekiFilterCheck(e)
        })
      }

      var carCountList = []
      cars.forEach((e) => {
        if (carCountList[e.car.id] === undefined) {
          carCountList[e.car.id] = 1
        } else {
          carCountList[e.car.id]++
        }
      })
      cars = cars.filter((e) => {
        // ・実績がある（上記の条件を分けるため：乗務員だけでは確定できない）
        // ・受注や作業が、見えるところに乗っていない
        // ・該当車両に別に行がある
        // この条件に当てはま行は表示しない
        if (carCountList[e.car.id] === 1) {
          // carCountList[e.car.id] = 0
          return true
        }
        // carCountList[e.car.id]--
        if (e.jissekiStatus === '0') {
          return true
        }
        const validOrder = e.orderD.filter((eo) => {
          return eo.chakuchiDayjs.isAfter(self.tekiyoYmdDayjs) && eo.hatsuchiDayjs.isBefore(self.tekiyoYmdDayjs.add(self.hours, 'h'))
        })
        if (validOrder.length === 0) {
          carCountList[e.car.id]--
          console.log('nodisplay all orders', e.orderD)
          return false
        }
        return true
      })

      return cars.sort(function (a, b) {
        if (a.car.hyojiOrder < b.car.hyojiOrder) {
          return -1
        } else if (a.car.hyojiOrder > b.car.hyojiOrder) {
          return 1
        } else if (a.car.id < b.car.id) {
          return -1
        } else if (a.car.id > b.car.id) {
          return 1
        } else if (self.isWorksLine(a.orderD) && !self.isWorksLine(b.orderD)) {
          return 1
        } else if (!self.isWorksLine(a.orderD) && self.isWorksLine(b.orderD)) {
          return -1
        }
        // 20220401s
        // if (a.masterFlg && !b.masterFlg) {
        //   return -1
        // } else if (!a.masterFlg && b.masterFlg) {
        //   return 1
        // } else {
        //   const hm1 = self.hasMaster(a.driver, a.subDriver, a.car, self.recCar)
        //   const hm2 = self.hasMaster(b.driver, b.subDriver, b.car, self.recCar)
        //   if (hm1 !== hm2) {
        //     if (hm1) {
        //       return -1
        //     }
        //     if (hm2) {
        //       return 1
        //     }
        //   }
        //   const hm3 = self.hasMasterDriverOnly(a.driver, a.car, self.recCar)
        //   const hm4 = self.hasMasterDriverOnly(b.driver, b.car, self.recCar)
        //   if (hm3 !== hm4) {
        //     if (hm3) {
        //       return -1
        //     }
        //     if (hm4) {
        //       return 1
        //     }
        //   }
        // }
        // 20220401e
        if (self.isValidDriver(a.driver) && !self.isValidDriver(b.driver)) {
          return -1
        } else if (!self.isValidDriver(a.driver) && self.isValidDriver(b.driver)) {
          return 1
        } else if (!self.isValidDriver(a.driver) && !self.isValidDriver(b.driver)) {
          // return 0 sub driver も
        } else if (a.driver.id < b.driver.id) {
          return -1
        } else if (a.driver.id > b.driver.id) {
          return 1
        }
        if (self.isValidDriver(a.subDriver) && !self.isValidDriver(b.subDriver)) {
          return -1
        } else if (!self.isValidDriver(a.subDriver) && self.isValidDriver(b.subDriver)) {
          return 1
        } else if (!self.isValidDriver(a.subDriver) && !self.isValidDriver(b.subDriver)) {
          // return 0 sub driver も
        } else if (a.subDriver.id < b.subDriver.id) {
          return -1
        } else if (a.subDriver.id > b.subDriver.id) {
          return 1
        }

        if (a.isEqualUnkouYmdAndTekiyoYmd !== b.isEqualUnkouYmdAndTekiyoYmd) {
          if (a.isEqualUnkouYmdAndTekiyoYmd) {
            return -1
          } else {
            return 1
          }
        }
        if (a.jomuinKakuteiFlg && !b.jomuinKakuteiFlg) {
          return -1
        } else if (!a.jomuinKakuteiFlg && b.jomuinKakuteiFlg) {
          return 1
        } else if (a.dojoshaKakuteiFlg && !b.dojoshaKakuteiFlg) {
          return -1
        } else if (!a.dojoshaKakuteiFlg && b.dojoshaKakuteiFlg) {
          return 1
        }

        if (a.orderD && a.orderD.length > 0 && (!b.orderD || b.orderD.length === 0)) {
          return 1
        } else if ((!a.orderD || a.orderD.length === 0) && (b.orderD && b.orderD.length > 0)) {
          return -1
        } else if (a.orderD && a.orderD.length > 0 && b.orderD && b.orderD.length > 0) {
          const t = a.orderD[0].hatsuchiDayjs.isSame(b.orderD[0].hatsuchiDayjs)
          if (t) {
            return 0
          } else {
            return a.orderD[0].hatsuchiDayjs.isAfter(b.orderD[0].hatsuchiDayjs) ? 1 : -1
          }
        }
        return 0
      })
    },
    filteredRows2 () {
      const self = this
      console.log('filteredrows2', self.recDriver)

      var drivers = self.keikakuJininList.filter(function (elem) {
        if (self.conditions.eigyoshoCd) {
          if (self.conditions.eigyoshoCd !== elem.eigyoshoCd) {
            return false
          }
        }
        // 適用期間内の乗務員しか行には表示しない
        if (!self.tekiyoYmdDayjs.isBetween(elem.tekiyoStartYmd, elem.tekiyoEndYmd, 'day', '[]')) {
          return false
        }
        return self.isDriverSearchCheck(elem)
      })

      if (this.usePager) {
        var pageDriver = drivers.slice((this.page - 1) * this.linesPerPage, (this.page - 1) * this.linesPerPage + this.linesPerPage)
        drivers = self.recDriver.filter((e) => {
          return pageDriver.some((et) => {
            return e.driver.id === et.id
          })
        })
      } else {
        pageDriver = drivers
        drivers = self.recDriver.filter((e) => {
          return pageDriver.some((et) => {
            return e.driver.id === et.id
          })
        })
      }

      return drivers.sort(function (a, b) {
        const r = self.funcDriverSort(a.driver, b.driver)
        if (r !== 0) {
          return r
        }
        if (a.driver.hyojiOrder < b.driver.hyojiOrder) {
          return -1
        } else if (a.driver.hyojiOrder > b.driver.hyojiOrder) {
          return 1
        } else if (a.driver.id < b.driver.id) {
          return -1
        } else if (a.driver.id > b.driver.id) {
          return 1
        } else if (self.isWorksLine(a.orderD) && !self.isWorksLine(b.orderD)) {
          return 1
        } else if (!self.isWorksLine(a.orderD) && self.isWorksLine(b.orderD)) {
          return -1
          // 20220401
        // } else if (a.masterFlg && !b.masterFlg) {
        //   return -1
        // } else if (!a.masterFlg && b.masterFlg) {
        //   return 1
        } else {
          // if (self.hasMaster(a.driver, a.subDriver, a.car, self.recDriver)) {
          //   return -1
          // }
          // if (self.hasMaster(b.driver, b.subDriver, b.car, self.recDriver)) {
          //   return 1
          // }
          // 20220401
          // const hm1 = self.hasMasterDriverOnly(a.driver, a.car, self.recCar)
          // const hm2 = self.hasMasterDriverOnly(b.driver, b.car, self.recCar)
          // if (hm1 !== hm2) {
          //   if (hm1) {
          //     return -1
          //   }
          //   if (hm2) {
          //     return 1
          //   }
          // }
        }
        // if (a.jomuinKakuteiFlg && !b.jomuinKakuteiFlg) {
        //   return -1
        // } else if (!a.jomuinKakuteiFlg && b.jomuinKakuteiFlg) {
        //   return 1
        // } else if (a.dojoshaKakuteiFlg && !b.dojoshaKakuteiFlg) {
        //   return -1
        // } else if (!a.dojoshaKakuteiFlg && b.dojoshaKakuteiFlg) {
        //   return 1
        // }
        const acarvalid = self.isValidCar(a.car)
        const bcarvalid = self.isValidCar(b.car)
        if (acarvalid && !bcarvalid) {
          return -1
        } else if (!acarvalid && bcarvalid) {
          return 1
        } else if (!acarvalid && !bcarvalid) {
          return 0
        } else if (a.car.id < b.car.id) {
          return -1
        } else if (a.car.id > b.car.id) {
          return 1
        }
        return 0
      })
    },
    // 受注フィルター
    filteredOrders () {
      const self = this
      return this.keikakuSagyoMeisai.filter(function (elem) {
        if (elem.delFlg === true) {
          return false
        }
        // 表示対象の絞り込み
        if (!self.showAll && self.afterSearch) {
          if (elem.hatsuchiHms) {
            if (!elem.hatsuchiDayjs.isBetween(self.tekiyoYmdDayjs, self.tekiyoYmdDayjs.add(self.hours, 'h'), 'h', '[]')) {
              return false
            }
          } else {
            if (!elem.hatsuchiDayjs.isBetween(self.tekiyoYmdDayjs, self.tekiyoYmdDayjs.add(self.hours, 'h'), 'd', '[]')) {
              return false
            }
          }
        }
        // console.log(elem.isOnTray)
        if (elem.isOnTray === undefined) {
          elem.isOnTray = true
        }
        return elem.isOnTray === true && self.isOrderSearchCheck(elem)
      }).sort((elem1, elem2) => {
        return self.sortOrder(elem1, elem2)
      })
    },
    // 受注フィルターアイコン切替
    isOrderFiltered () {
      if (this.orderFilterConditions.ninushiCd ||
        this.orderFilterConditions.ninushiNm ||
        this.orderFilterConditions.hatsuchiCd ||
        this.orderFilterConditions.hatsuchiNm ||
        this.orderFilterConditions.hatsuchiFromHms ||
        this.orderFilterConditions.hatsuchiToHms ||
        this.orderFilterConditions.chakuchiCd ||
        this.orderFilterConditions.chakuchiNm ||
        this.orderFilterConditions.chakuchiFromHms ||
        this.orderFilterConditions.chakuchiToHms ||
        this.orderFilterConditions.juchuEigyoshoCd ||
        this.orderFilterConditions.juchuEigyoshoNm ||
        this.orderFilterConditions.sagyoEigyoshoCd ||
        this.orderFilterConditions.sagyoEigyoshoNm ||
        this.orderFilterConditions.unkoYmd ||
        this.orderFilterConditions.freeWord ||
        this.orderFilterConditions.chumonNo) {
        return true
      } else {
        return false
      }
    },
    // 受注ソートアイコン切替
    isOrderSorted () {
      if (this.orderSortArgs.orderSortKeyValue1 ||
        this.orderSortArgs.orderSortKeyValue2 ||
        this.orderSortArgs.orderSortKeyValue3) {
        return true
      } else {
        return false
      }
    },
    // 乗務員フィルター
    filteredDrs () {
      const self = this
      return self.keikakuJininList.filter(function (elem) {
        if (self.conditions.eigyoshoCd) {
          if (self.conditions.eigyoshoCd !== elem.eigyoshoCd) {
            return false
          }
        }
        // 適用期間内の乗務員しかトレイには表示しない
        if (!self.tekiyoYmdDayjs.isBetween(elem.tekiyoStartYmd, elem.tekiyoEndYmd, 'day', '[]')) {
          return false
        }
        return elem.isOnTray === true && self.isDriverSearchCheck(elem)
      }).sort((elem1, elem2) => {
        return self.funcDriverSort(elem1, elem2)
      })
    },
    // 乗務員フィルターアイコン切替
    isDriverFiltered () {
      if (this.driverFilterConditions.jininCd ||
        this.driverFilterConditions.jininNm ||
        this.driverFilterConditions.eigyoshoCd ||
        this.driverFilterConditions.eigyoshoNm ||
        this.driverFilterConditions.isOnlyJomuin === true) {
        return true
      } else {
        return false
      }
    },
    // 乗務員ソートアイコン切替
    isDriverSorted () {
      if (this.driverSortArgs.driverSortKeyValue1 ||
        this.driverSortArgs.driverSortKeyValue2 ||
        this.driverSortArgs.driverSortKeyValue3) {
        return true
      } else {
        return false
      }
    },
    // 車両情報フィルター
    filteredCars () {
      return this.keikakuSharyoList.filter(function (elem) {
        // 適用期間内の車両しか行には表示しない
        if (!self.tekiyoYmdDayjs.isBetween(elem.tekiyoStartYmd, elem.tekiyoEndYmd, 'day', '[]')) {
          return false
        }
        return elem.isOnTray === true
      })
    },
    // 車両情報フィルターアイコン切替
    isCarFiltered () {
      if (this.carFilterConditions.sharyoCd ||
        this.carFilterConditions.jidoshaHyojiNm ||
        this.carFilterConditions.shashuSbt ||
        this.carFilterConditions.eigyoshoCd ||
        this.carFilterConditions.eigyoshoNm ||
        this.carFilterConditions.onDriver !== 0 ||
        this.carFilterConditions.onYosha !== 0) {
        return true
      } else {
        return false
      }
    },
    filteredWorks () {
      return this.keikakuSagyoMeisai2.filter(function (elem) {
        return elem.isOnTray === true && elem.delFlg === false
      })
    },
    // filteredDrivers4DD () {
    //   const resultArray = this.keikakuJininList.filter((e) => {
    //     return this.conditions.eigyoshoCd === e.eigyoshoCd
    //   }).map(elem => {
    //     return {
    //       value: elem.id,
    //       text: `${elem.jininCd}:${elem.jininNmSei}${elem.jininNmMei ?? ''}`
    //     }
    //   })
    //   return resultArray
    // },
    filteredCars4DD () {
      const resultArray = this.keikakuSharyoList.map(elem => {
        return {
          value: elem.id,
          text: `${elem.sharyoNo}:${elem.jidoshaHyojiNm}`
        }
      })
      return resultArray
    },
    tekiyoYmdDayjs () {
      return dayjs(this.conditions.tekiyoYmd).add(this.tableStartHour, 'hour')
    },
    isFooterBtnDisable () {
      if (this.viewMode === 0) {
        return false
      } else {
        return true
      }
    },
    tableStartHour: function () {
      if (this.tableStartHourDisp) {
        return Number(String(this.tableStartHourDisp).replace(':00', ''))
      } else {
        return 6
      }
    },
    hours: function () {
      if (this.rangeDisp) {
        if (this.rangeDisp === '24時間') {
          this.hoursInterval = 1
          return 24
        } else if (this.rangeDisp === '48時間') {
          this.hoursInterval = 1
          return 48
        } else if (this.rangeDisp === '3日') {
          this.hoursInterval = 6
          return 72
        } else if (this.rangeDisp === '5日') {
          this.hoursInterval = 6
          return 120
        } else if (this.rangeDisp === '7日') {
          this.hoursInterval = 6
          return 168
        } else {
          this.hoursInterval = 1
          return 24
        }
      }
    },
    strechAreaStyle () {
      if (this.sizeType === -1 && this.conditions.line1) {
        var m = 0
      } else {
        m = 2
      }
      return {
        '--grid-height': this.calcChipHeight(this.conditions.line1) + 'px',
        '--lock-icon-margin-top': m + 'px'
      }
    },
    contextMenuStyle () {
      if (this.isCopyMode) {
        var bl = '#007aff'
        var cl = 'white'
        var ck = ''
      } else {
        bl = '#ecf0f1'
        cl = 'inherit'
        ck = 'none'
      }
      if (this.isThisItemKakutei) {
        var bl2 = '#007aff'
        var cl2 = 'white'
        var ck2 = ''
      } else {
        bl2 = '#ecf0f1'
        cl2 = 'inherit'
        ck2 = 'none'
      }
      return {
        '--is-copy-mode-backcolor': bl,
        '--is-copy-mode-color': cl,
        '--is-copy-mode-chars': ck,
        '--is-locked-backcolor': bl2,
        '--is-locked-color': cl2,
        '--is-locked-chars': ck2
      }
    },
    tableWidthStyle () {
      const bgc = 'white'
      const bgch = '#eeeeee'
      return {
        '--width-of-1': this.widthOfLineHeader[0] + 'px',
        '--width-of-2': this.widthOfLineHeader[1] + 'px',
        '--width-of-3': this.widthOfLineHeader[2] + 'px',
        '--width-of-4': this.widthOfLineHeader[3] + 'px',
        '--backcolor': bgc,
        '--backcolor-hover': bgch
      }
    },
    checkboxScaleStyle () {
      var range = 1.2
      var width = 115
      var checkboxleft = 100
      var checkboxtop = 0
      var numbertop = 3
      var numberleft = 40
      var numbersize = 36
      if (this.sizeType === 1) {
        range = 1.5
        width = 140
        checkboxleft = 120
        checkboxtop = 2
        numbertop = 8
        numberleft = 48
        numbersize = 36
      } else if (this.sizeType === -1) {
        range = 1.0
        width = 90
        checkboxleft = 76
        numbertop = 2
        numberleft = 28
        numbersize = 30
      }
      return {
        '--range-of-checkbox': range,
        '--driver-chip-width': width + 'px',
        '--driver-checkbox-left': checkboxleft + 'px',
        '--driver-checkbox-top': checkboxtop + 'px',
        '--driver-number-left': numberleft + 'px',
        '--driver-number-top': numbertop + 'px',
        '--driver-number-size': numbersize + 'px'
      }
    },
    isJissekiFilterOn () {
      if (!this.jissekiFilterConditions || !Array.isArray(this.jissekiFilterConditions) || this.jissekiFilterConditions.length === 0) {
        return false
      }
      const r = this.jissekiFilterConditions.filter((e) => {
        return e.value === true
      })
      if (r.length === 0 || r.length === this.jissekiFilterConditions.length) {
        return false
      }
      return true
    },
    isReadonlyKengen () {
      if (this.modeKengen === 0) {
        return true
      }
      return false
    },
    useInitialize () {
      // const r = this.systemConfigList.find((e) => {
      //   return e.configName === 'haisha_initialize_use_yn'
      // })
      const r = indexeddb.getSystemConfig(this.currentKaishaCode, this.systemConfigList, 'haisha_initialize_use_yn')
      if (r) {
        if (Number(r.configValue1) === 1) {
          return true
        }
      }
      return false
    },
    useTempSave () {
      // const r = this.systemConfigList.find((e) => {
      //   return e.configName === 'haisha_temporary_save_use_yn'
      // })
      const r = indexeddb.getSystemConfig(this.currentKaishaCode, this.systemConfigList, 'haisha_temporary_save_use_yn')
      if (r) {
        if (Number(r.configValue1) === 1) {
          return true
        }
      }
      return false
    },
    selectionWay () {
      // const r = this.systemConfigList.find((e) => {
      //   return e.configName === 'haisha_default_select_mode'
      // })
      const r = indexeddb.getSystemConfig(this.currentKaishaCode, this.systemConfigList, 'haisha_default_select_mode')
      if (r) {
        if (Number(r.configValue1) === 1) {
          return true
        } else {
          return false
        }
      }
      return true
    },
    badgeText () {
      // const r = this.systemConfigList.find((e) => {
      //   return e.configName === 'haisha_copied_badge_text'
      // })
      const r = indexeddb.getSystemConfig(this.currentKaishaCode, this.systemConfigList, 'haisha_copied_badge_text')
      if (r) {
        return r.configValue1
      }
      return 'C'
    },
    useSearchOnLoad () {
      // const r = this.systemConfigList.find((e) => {
      //   return e.configName === 'haisha_initial_search_yn'
      // })
      const r = indexeddb.getSystemConfig(this.currentKaishaCode, this.systemConfigList, 'haisha_initial_search_yn')
      if (r) {
        if (Number(r.configValue1) === 1) {
          return true
        }
      }
      return false
    },
    allocatedDrivers () {
      return this.keikakuJininList.filter((x) => { return x.isOnTray === false }).length
    },
    allcatedOrders () {
      return this.keikakuSagyoMeisai.filter((x) => { return x.isOnTray === false }).length
    },
    totalOrders () {
      return this.filteredOrders.length + this.allcatedOrders
    },
    allcatedWorks () {
      return this.keikakuSagyoMeisai2.filter((x) => { return x.isOnTray === false }).length
    },
    totalWorks () {
      return this.filteredWorks.length + this.allcatedWorks
    },
    allcatedCars () {
      const self = this
      return this.keikakuSharyoList.filter((x) => {
        const t = self.recCar.find(xx => {
          if (xx.car.id !== x.id) {
            return false
          }
          if (xx.orderD.length > 0) {
            return true
          }
          // if (self.isWorksLine(xx.orderD)) {
          //   return true
          // }
          // if (x.hacchusakiFlg) {
          //   if (xx.orderD.length > 0) {
          //     return true
          //   }
          // } else if (self.isValidDriver(xx.driver)) {
          //   return true
          // }
          return false
        })
        if (t) {
          return true
        }
        return false
      }).length
    },
    totalPlans () {
      let count = 0
      var i
      for (i = 0; i < this.recCar.length; i++) {
        if (!this.isSkipTRDiffJissekionSharyo(i, this.recCar)) {
          count++
        }
      }
      return count
    },
    allocatedPlans () {
      let count = 0
      var i
      for (i = 0; i < this.recCar.length; i++) {
        if (!this.isSkipTRDiffJissekionSharyo(i, this.recCar)) {
          if (this.recCar[i].jissekiStatus === '9') {
            count++
          }
        }
      }
      return count
    }
  },
  created () {
    console.log('created')
  },
  mounted () {
    const self = this
    console.log('mounted')
    this.sizeType = 0
    self.Effects.loadStart()
    this.initialize()
    console.log('mounted af')
    const checkInterval = function () {
      if (self.isRecommendReload === false && self.afterSearch && self.isSaving === false) {
        self.checkServerUpdated()
      }
    }
    // 5分に一回更新があるかチェックする
    // this.objTimer = setInterval(checkInterval, 1000 * 60 * 5)
    this.objTimer = setInterval(checkInterval, SERVER_CHECK_TIME_MS)
  },
  destroyed: function () {
    clearInterval(this.objTimer)
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    onResize (p) {
      const otherHeight = this.calcHeightWithoutTables() + 0 // 24はpadding分 ※paddingをzeroにした為、0に変更
      const footerHeight = (this.ticketVisibleFlag ? 240 : 96)
      // console.log('★resize height', p, otherHeight, footerHeight, this.$vuetify.breakpoint.height)
      this.tableHeightX = this.$vuetify.breakpoint.height - otherHeight - footerHeight - p.headerHeight - p.messageHeight - 20
      this.calcWidthLineHeader()
    },
    // #region DDV2いつもの
    getCloneTargetMethod: function () {
      return {
        sagyoKeikaku: this.sagyoKeikaku,
        keikakuSharyoList: this.keikakuSharyoList,
        keikakuJininList: this.keikakuJininList,
        keikakuSagyoMeisai: this.keikakuSagyoMeisai,
        keikakuSagyoMeisai2: this.keikakuSagyoMeisai2,
        // order: this.order,
        // works: this.works,
        // dr: this.dr,
        // sharyo: this.sharyo,
        conditions: this.conditions,
        orderFilterConditions: this.orderFilterConditions,
        orderSortArgs: this.orderSortArgs,
        driverFilterConditions: this.driverFilterConditions,
        driverSortArgs: this.driverSortArgs,
        carFilterConditions: this.carFilterConditions,
        afterSearch: this.afterSearch
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'msthaishahyo', 'vwcmsthaishahyosharyo', 'vwcmstsharyo', 'msthinmei', 'msthacchakuchi', 'msyskubun', 'mstshubetsu', 'msyssystemconfig', 'vwcd2mstd0460'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          const today = dayjs()
          return new Promise(resolve => {
            // 初期条件は日付のみとする
            self.conditions.tekiyoYmdInput = today.format('YYYY/MM/DD')
            self.conditions.eigyoshoCdDisp = self.userEigyoshoCd
            // self.conditions.eigyoshoId = self.getEigyoshoId(self.usersEigyosho)
            if (self.useSearchOnLoad) {
              // 起動時に検索を実行する
              self.loadJuchu()
            } else {
              self.afterSearch = false
              self.Effects.loadComplete()
            }
            this.isUseCheckbox = self.selectionWay

            // 表示対象を検索範囲のみに切り替え
            self.showAll = false
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.conditions || {}
            self.search().then(() => {
              resolve()
            })
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      if (this.afterSearch === true && this.hasUpdateDats()) {
        const parm = ['検索']
        modals.showConfirm('PLMQ0001', '', '', parm).then((ok) => {
          if (ok) {
            self.isRecommendReload = false
            self.conditions.tekiyoYmd = self.conditions.tekiyoYmdInput
            self.tableStartHourDisp = self.conditions.tableStartHourDisp
            self.rangeDisp = self.conditions.rangeDisp

            // self.conditions.sagyoYoteiYmdFrom = self.tekiyoYmdDayjs.toString()
            // self.conditions.sagyoYoteiYmdTo = self.tekiyoYmdDayjs.add(this.hours, 'h').toString() // tz('Asia/Tokyo')
            self.conditions.sagyoYoteiYmdFrom = self.tekiyoYmdDayjs.format('YYYY/MM/DD HH:mm:ss')
            self.conditions.sagyoYoteiYmdTo = self.tekiyoYmdDayjs.add(this.hours, 'h').format('YYYY/MM/DD HH:mm:ss')
            self.conditions.haishaShashuSbt = self.conditions.haishaShashuSbtDisp
            self.conditions.haishahyoCd = self.conditions.haishahyoCdDisp
            self.conditions.eigyoshoCd = self.conditions.eigyoshoCdDisp
            this.searchExec(false)
          }
        })
      } else {
        self.isRecommendReload = false
        self.conditions.tekiyoYmd = self.conditions.tekiyoYmdInput
        self.tableStartHourDisp = self.conditions.tableStartHourDisp
        self.rangeDisp = self.conditions.rangeDisp

        // self.conditions.sagyoYoteiYmdFrom = self.tekiyoYmdDayjs.toString()
        // self.conditions.sagyoYoteiYmdTo = self.tekiyoYmdDayjs.add(this.hours, 'h').toString() // tz('Asia/Tokyo')
        self.conditions.sagyoYoteiYmdFrom = self.tekiyoYmdDayjs.format('YYYY/MM/DD HH:mm:ss')
        self.conditions.sagyoYoteiYmdTo = self.tekiyoYmdDayjs.add(this.hours, 'h').format('YYYY/MM/DD HH:mm:ss')
        self.conditions.haishaShashuSbt = self.conditions.haishaShashuSbtDisp
        self.conditions.haishahyoCd = self.conditions.haishahyoCdDisp
        self.conditions.eigyoshoCd = self.conditions.eigyoshoCdDisp
        this.searchExec(false)
      }
    },
    searchExec (isReload = false, isCheckOnly = false) {
      const self = this
      const opt = {
        // 作業計画取得
        searchRequestPromise1: function () {
          // 100には検索条件の営業所は渡さない
          var parm100 = { ...self.conditions }
          delete parm100.eigyoshoCd
          delete parm100.eigyoshoId
          return new Promise((resolve, reject) => {
            self.HttpClient.post('/api/v1/VwCD2plmd00200/Search', parm100)
              .then((data) => {
                resolve(data)
              }).catch((e) => {
                reject(e)
              })
          })
        },
        // 車両情報取得
        searchRequestPromise2: function () {
          return new Promise((resolve, reject) => {
            self.HttpClient.post('/api/v1/vwCMstHaishahyoSharyo/Search', self.conditions)
              .then((data) => {
                resolve(data)
              }).catch((e) => {
                reject(e)
              })
          })
        },
        // 受注（作業明細）情報取得
        searchRequestPromise3: function () {
          return new Promise((resolve, reject) => {
            self.HttpClient.post('/api/v1/VwCD2plmd00201/Search', self.conditions)
              .then((data) => {
                resolve(data)
              }).catch((e) => {
                reject(e)
              })
          })
        },
        // 人員情報取得
        searchRequestPromise4: function () {
          return new Promise((resolve, reject) => {
            var parm = { ...self.conditions }
            delete parm.eigyoshoId
            delete parm.eigyoshoCd
            self.HttpClient.post('/api/v1/VwCMstEigyoshoJininList/Search', parm)
              .then((data) => {
                resolve(data)
              }).catch((e) => {
                reject(e)
              })
          })
        },
        // WORKS
        searchRequestPromise5: function () {
          return new Promise((resolve, reject) => {
            // const cond = {
            //   kaishaCd: '0010'
            // }
            self.HttpClient.post('/api/v1/VwCD2plmd00102/Search', self.conditions) // , self.conditions -- nullと比べているので
              .then((data) => {
                resolve(data)
              }).catch((e) => {
                reject(e)
              })
          })
        },
        // indexedDB
        searchRequestPromise6: function () {
          return new Promise((resolve, reject) => {
            self.$store.dispatch('tempData/loadDatas', 'temp_vwcd2plmd00200').then(() => {
              console.log('vwcd2plmd00200 from indexdb')
              resolve(self.tempStoredDataPlan)
            }).catch((e) => {
              console.log('no data error', e)
              resolve(null)
            })
          })
        },
        // indexedDB
        searchRequestPromise7: function () {
          return new Promise((resolve, reject) => {
            self.$store.dispatch('tempData/loadDatas', 'temp_vwcd2plmd00201').then(() => {
              console.log('vwcd2plmd00201 from indexdb')
              resolve(self.tempStoredDataSagyo)
            }).catch((e) => {
              console.log('no data error', e)
              resolve(null)
            })
          })
        },
        // indexedDB
        searchRequestPromise8: function () {
          return new Promise((resolve, reject) => {
            self.$store.dispatch('tempData/loadDatas', 'temp_vwcd2plmd00102').then(() => {
              console.log('vwcd2plmd00102 from indexdb')
              resolve(self.tempStoredDataWork)
            }).catch((e) => {
              console.log('no data error', e)
              resolve(null)
            })
          })
        },
        searchResultPromise1: function (data) {
          return new Promise((resolve, reject) => {
            console.log('searchResultPromise1')
            self._setMessages(data).then(() => {
              if (data.isValid) {
                if (!self.isErrorToGo) {
                  const sk = data.payload ?? []
                  if (isReload) {
                    sk.forEach((e) => {
                      var matched = self.sagyoKeikaku.find((es) => {
                        return es.id === e.id
                      })
                      if (matched) {
                        if (matched.updateFlg === false) {
                          // 日付が新しくて更新フラグの立ってない計画はサーバので上書き
                          const rec = self.shapePlanData(e)
                          if (dayjs(matched.updDateI).isBefore(dayjs(rec.updDateI))) {
                            if (isCheckOnly) {
                              self.isRecommendReload = true
                            } else {
                              Object.assign(matched, rec)
                            }
                          }
                        }
                      } else {
                        if (e.delFlg === false) {
                          if (isCheckOnly) {
                            self.isRecommendReload = true
                          } else {
                            // 新しいデータ
                            e = self.shapePlanData(e)
                            self.sagyoKeikaku.push(e)
                          }
                        }
                      }
                    })
                  } else {
                    self.sagyoKeikaku = sk.filter((e) => {
                      return e.delFlg !== true
                    }).map((e) => {
                      return self.shapePlanData(e)
                    })
                  }
                }
                resolve()
              } else {
                console.log('catch reject! promise1')
                reject(new Error('promise1'))
                // throw new Error('promise1')
              }
            })
          })
        },
        searchResultPromise2: function (data) {
          return new Promise((resolve, reject) => {
            console.log('searchResultPromise2')
            self._setMessages(data).then(() => {
              if (data.isValid) {
                if (!self.isErrorToGo) {
                  const sl = data.payload ?? []
                  if (isReload) {
                    sl.forEach((e) => {
                      const matched = self.keikakuSharyoList.find((ee) => {
                        return ee.id === e.mstSharyoId
                      })
                      if (matched) {
                        if (dayjs(matched.updDate).isBefore(dayjs(e.updDate))) {
                          if (isCheckOnly) {
                            self.isRecommendReload = true
                          } else {
                            // 車両を更新
                            e.id = e.mstSharyoId
                            // e.masterFlg = true
                            e.isOnTray = true
                            e.jomuinId = self.getJininId(e.jomuinCd)
                            Object.assign(matched, e)
                          }
                        }
                      } else {
                        if (isCheckOnly) {
                          self.isRecommendReload = true
                        } else {
                          e.id = e.mstSharyoId
                          // e.masterFlg = true
                          e.isOnTray = true
                          e.jomuinId = self.getJininId(e.jomuinCd)
                          // e.color = self.getSharyoColorFromId(e.id) // TODO vw_c_mst_haishahyo_sharyoにcolorが入るまでのつなぎ
                          self.keikakuSharyoList.push(e)
                        }
                      }
                    })
                  } else {
                    self.keikakuSharyoList = sl.filter((e) => {
                      return e.delFlg !== true
                    }).map((e) => {
                      e.id = e.mstSharyoId
                      // e.masterFlg = true
                      e.isOnTray = true
                      e.jomuinId = self.getJininId(e.jomuinCd)
                      // e.color = self.getSharyoColorFromId(e.id) // TODO vw_c_mst_haishahyo_sharyoにcolorが入るまでのつなぎ
                      return e
                    })
                  }
                }
              } else {
                reject(new Error('promise2'))
              }
            })
            resolve()
          })
        },
        searchResultPromise3: function (data) {
          return new Promise((resolve, reject) => {
            console.log('searchResultPromise3')
            self._setMessages(data).then(() => {
              if (data.isValid) {
                if (!self.isErrorToGo) {
                  const sm = data.payload ?? []
                  if (isReload) {
                    sm.forEach((e) => {
                      const jt = self.shapeJyuchuData(e)
                      const matched = self.keikakuSagyoMeisai.find((ee) => {
                        return ee.id === e.id
                      })
                      if (matched) {
                        if (!matched.updateFlg) {
                          if (dayjs(matched.updDateI).isBefore(dayjs(jt.updDateI))) {
                            if (isCheckOnly) {
                              self.isRecommendReload = true
                            } else {
                              Object.assign(matched, jt)
                            }
                          }
                        }
                      } else {
                        if (jt.delFlg === false) {
                          if (isCheckOnly) {
                            self.isRecommendReload = true
                          } else {
                            self.keikakuSagyoMeisai.push(jt)
                          }
                        }
                      }
                    })
                  } else {
                    self.keikakuSagyoMeisai = sm.filter((e) => {
                      return e.delFlg !== true
                    }).map((e) => {
                      return self.shapeJyuchuData(e)
                    })
                  }
                }
              } else {
                reject(new Error('promise3'))
              }
            })
            resolve()
          })
        },
        searchResultPromise4: function (data) {
          return new Promise((resolve, reject) => {
            console.log('searchResultPromise4')
            self._setMessages(data).then(() => {
              if (data.isValid) {
                if (!self.isErrorToGo) {
                  const jl = data.payload ?? []
                  if (isReload) {
                    jl.forEach((e) => {
                      const matched = self.keikakuJininList.find((ee) => {
                        return ee.id === e.id
                      })
                      if (matched) {
                        if (dayjs(matched.updDate).isBefore(dayjs(e.updDate))) {
                          if (isCheckOnly) {
                            self.isRecommendReload = true
                          } else {
                            e.jininNm = e.jininNmSei + (e.jininNmMei ? ' ' + e.jininNmMei : '')
                            e.eigyoshoNm = self.getEigyoshoNmFromCd(e.eigyoshoCd)
                            // e.masterFlg = true
                            e.isOnTray = true
                            e.isSelected = false
                            e.selectionNumber = 0
                            Object.assign(matched, e)
                          }
                        }
                      } else {
                        if (isCheckOnly) {
                          self.isRecommendReload = true
                        } else {
                          e.jininNm = e.jininNmSei + (e.jininNmMei ? ' ' + e.jininNmMei : '')
                          e.eigyoshoNm = self.getEigyoshoNmFromCd(e.eigyoshoCd)
                          // e.masterFlg = true
                          e.isOnTray = true
                          e.isSelected = false
                          e.selectionNumber = 0
                          self.keikakuJininList.push(e)
                        }
                      }
                    })
                  } else {
                    self.keikakuJininList = jl.filter((e) => {
                      return e.delFlg !== true
                    }).map((e) => {
                      e.jininNm = e.jininNmSei + (e.jininNmMei ? ' ' + e.jininNmMei : '')
                      e.eigyoshoNm = self.getEigyoshoNmFromCd(e.eigyoshoCd)
                      // e.masterFlg = true
                      e.isOnTray = true
                      e.isSelected = false
                      e.selectionNumber = 0
                      return e
                    })
                    self.redrawDriverTray()
                  }
                }
              } else {
                reject(new Error('promise4'))
              }
            })
            resolve()
          })
        },
        searchResultPromise5: function (data) {
          return new Promise((resolve, reject) => {
            console.log('searchResultPromise5')
            self._setMessages(data).then(() => {
              if (data.isValid) {
                if (!self.isErrorToGo) {
                  const km2 = data.payload ?? []
                  if (isReload) {
                    km2.forEach((e) => {
                      const sg = self.shapeSagyoData(e)
                      const matched = self.keikakuSagyoMeisai2.find((ee) => {
                        return ee.id === e.id
                      })
                      if (matched) {
                        if (dayjs(matched.updDateI).isBefore(dayjs(sg.updDateI))) {
                          if (isCheckOnly) {
                            self.isRecommendReload = true
                          } else {
                            Object.assign(matched, sg)
                          }
                        }
                      } else {
                        if (sg.delFlg === false) {
                          if (isCheckOnly) {
                            self.isRecommendReload = true
                          } else {
                            self.keikakuSagyoMeisai2.push(sg)
                          }
                        }
                      }
                    })
                  } else {
                    self.keikakuSagyoMeisai2 = km2.filter((e) => {
                      return e.delFlg !== true
                    }).map((e) => {
                      const x = self.shapeSagyoData(e)
                      return x
                    })
                  }
                }
              } else {
                reject(new Error('promise5'))
              }
            })
            resolve()
          })
        },
        searchResultPromise6: function (data) {
          console.log('indexeddb data ', data)
          return new Promise((resolve, reject) => {
            if (!isReload) {
              self.tempSavedDataPlanFromIndexDb = data
            }
            resolve()
          })
        },
        searchResultPromise7: function (data) {
          console.log('indexeddb data ', data)
          return new Promise((resolve, reject) => {
            if (!isReload) {
              self.tempSavedDataSagyoFromIndexDb = data
            }
            resolve()
          })
        },
        searchResultPromise8: function (data) {
          console.log('indexeddb data ', data)
          return new Promise((resolve, reject) => {
            if (!isReload) {
              self.tempSavedDataWorkFromIndexDb = data
            }
            resolve()
          })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      // flowmixinのsearchを拡張
      if (!isCheckOnly) {
        const isValid = self._validateSearchProcess()
        if (!isValid) { return }

        self.Effects.loadStart()

        // SummaryMessage初期化
        self.clearSummaryMessage()
      }

      const param = {
        kinoId: self.currentKinoId,
        obj: opt.getSavedInputMethod()
      }
      self.$store.dispatch('DDMasters/registerSavedInput', param).then(() => {
        const arrayRequestPromise = [
          opt.searchRequestPromise1(),
          opt.searchRequestPromise2(),
          opt.searchRequestPromise3(),
          opt.searchRequestPromise4(),
          opt.searchRequestPromise5(),
          opt.searchRequestPromise6(),
          opt.searchRequestPromise7(),
          opt.searchRequestPromise8()
        ]
        Promise.all(arrayRequestPromise)
          .then((results) => {
            return opt.searchResultPromise1(results[0]
            ).then(() => opt.searchResultPromise2(results[1])
            ).then(() => {
              return opt.searchResultPromise3(results[2])
            }).then(() => {
              return opt.searchResultPromise4(results[3])
            }).then(() => {
              return opt.searchResultPromise5(results[4])
            }).then(() => {
              return opt.searchResultPromise6(results[5])
            }).then(() => {
              return opt.searchResultPromise7(results[6])
            }).then(() => {
              return opt.searchResultPromise8(results[7])
            }).then(() => {
              if (!isCheckOnly) {
                console.log('http request finished')
                const cache = {
                  rows: self.rows,
                  conditions: self.conditions
                }
                self.saveToChache(cache)
                if (!isReload) {
                  // indexeddbから読んだデータをsagyoKeikakuにマージする
                  self.mergeSagyoKeikakuFromIndexedDb()
                }
                this.createCarRecords()
                if (self.viewMode === 0) {
                  this.recDriver = []
                } else {
                  // this.storeOrderInfoFromScreenSharyo()
                  this.createDriverRecords()
                }
                console.log('created  car')
              }
              return Promise.resolve()
            })
          }).then(() => {
            if (!isCheckOnly) {
              console.log('created  car end')

              this.afterSearch = true
              self.Effects.loadComplete()
            }
          }).catch((e) => {
            if (!isCheckOnly) {
              console.log('catch', e)
              self.afterSearch = false
              self.Effects.loadComplete()
            }
          })
      })
    },
    loadJuchu: function (isUpdateOnly = false) {
      const self = this
      const opt = {
        // 受注（作業明細）情報取得
        searchRequestPromise3: function () {
          return new Promise((resolve, reject) => {
            const parm = { haishaShashuSbt: '-1' }
            self.HttpClient.post('/api/v1/VwCD2plmd00201/Search', parm)
              .then((data) => {
                resolve(data)
              }).catch((e) => {
                reject(e)
              })
          })
        },
        // WORKS
        searchRequestPromise5: function () {
          return new Promise((resolve, reject) => {
            // const cond = {
            //   kaishaCd: '0010'
            // }
            self.HttpClient.post('/api/v1/VwCD2plmd00102/Search', self.conditions) // , self.conditions -- nullと比べているので
              .then((data) => {
                resolve(data)
              }).catch((e) => {
                reject(e)
              })
          })
        },
        searchResultPromise3: function (data) {
          return new Promise((resolve, reject) => {
            console.log('searchResultPromise3')
            self._setMessages(data).then(() => {
              if (data.isValid) {
                if (isUpdateOnly === false) {
                  const sm = data.payload
                  self.keikakuSagyoMeisai = sm.filter((e) => {
                    if (!e.sagyoYoteiYmd) {
                      return true
                    }
                    return false
                  }).map((e) => {
                    return self.shapeJyuchuData(e)
                  })
                } else {
                  // 受注のデータの再読み込み：現在あるデータは変更しない
                  const sm = data.payload
                  sm.forEach((e) => {
                    if (!e.sagyoYoteiYmd) {
                      // トレイだけなので配置されているデータに追加はないはず
                      const vt = self.keikakuSagyoMeisai.find((ex) => {
                        return e.id === ex.id
                      })
                      if (!vt) {
                        self.keikakuSagyoMeisai.push(self.shapeJyuchuData(e))
                      }
                    }
                  })
                }
              } else {
                reject(new Error('promise3'))
              }
            })
            resolve()
          })
        },
        searchResultPromise5: function (data) {
          return new Promise((resolve, reject) => {
            console.log('searchResultPromise5')
            self._setMessages(data).then(() => {
              if (data.isValid) {
                if (isUpdateOnly === false) {
                  self.keikakuSagyoMeisai2 = data.payload
                  self.keikakuSagyoMeisai2 = self.keikakuSagyoMeisai2.filter((e) => {
                    if (!e.sagyoYoteiYmd) {
                      return true
                    }
                    return false
                  }).map((e) => {
                    return self.shapeSagyoData(e)
                  })
                } else {
                  // 受注のデータの再読み込み：現在あるデータは変更しない
                  const sm = data.payload
                  sm.forEach((e) => {
                    // トレイだけなので配置されているデータに追加はないはず
                    const vt = self.keikakuSagyoMeisai2.find((ex) => {
                      return e.id === ex.id
                    })
                    if (!vt) {
                      self.keikakuSagyoMeisai2.push(self.shapeSagyoData(e))
                    }
                  })
                }
              } else {
                reject(new Error('promise5'))
              }
            })
            resolve()
          })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      // flowmixinのsearchを拡張

      self.Effects.loadStart()

      // SummaryMessage初期化
      self.clearSummaryMessage()
      self.conditions.tekiyoYmd = self.conditions.tekiyoYmdInput
      self.tableStartHourDisp = self.conditions.tableStartHourDisp
      self.rangeDisp = self.conditions.rangeDisp

      // self.conditions.sagyoYoteiYmdFrom = self.tekiyoYmdDayjs.toString()
      // self.conditions.sagyoYoteiYmdTo = self.tekiyoYmdDayjs.add(this.hours, 'h').toString() // tz('Asia/Tokyo')
      self.conditions.sagyoYoteiYmdFrom = self.tekiyoYmdDayjs.format('YYYY/MM/DD')
      self.conditions.sagyoYoteiYmdTo = self.tekiyoYmdDayjs.add(this.hours, 'h').format('YYYY/MM/DD')

      const arrayRequestPromise = [
        opt.searchRequestPromise3(),
        opt.searchRequestPromise5()
      ]
      Promise.all(arrayRequestPromise)
        .then((results) => {
          return opt.searchResultPromise3(results[0])
            .then(() => opt.searchResultPromise5(results[1]))
            .then(() => {
              console.log('http request finished')
              // const cache = {
              //   rows: self.rows,
              //   conditions: self.conditions
              // }
              // self.saveToChache(cache)
              // if (self.viewMode === 0) {
              //   this.createCarRecords()
              // } else {
              //   this.createDriverRecords()
              // }
              console.log('created  car')
              return Promise.resolve()
            }).then(() => {
              console.log('created  car end')
              if (!isUpdateOnly) {
                this.afterSearch = false
              }
              self.Effects.loadComplete()
            }).catch((e) => {
              console.log('catch', e)
              if (!isUpdateOnly) {
                self.afterSearch = false
              }
              self.Effects.loadComplete()
            })
        })
    },
    searchValidate () {
      return true
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      modals.showConfirm('COMQ0006').then((ok) => {
        if (ok) {
          this.Effects.loadStart()
          this.clear()
        }
      })
    },
    /**
     * キャンセルボタンクリック
     * @param {*} e
     */
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            if (self.useSearchOnLoad) {
              self.loadJuchu()
            } else {
              self.sagyoKeikaku = []
              self.keikakuSagyoMeisai = []
              self.keikakuSagyoMeisai2 = []
              self.afterSearch = false
            }
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    dataClear () {
      this.afterSearch = false
    },
    /**
     * 一時保存ボタンクリック
     * @param {*} e
     */
    onTempSaveButtonClick: function (e) {
      const self = this
      console.log('onTempSaveButtonClick', e)
      // まず画面の情報を保存する
      if (this.viewMode === 0) {
        this.storeOrderInfoFromScreenSharyo(this.page)
      } else {
        this.storeOrderInfoFromScreenDriver(this.page)
      }
      // 検索条件外のデータはここでマージしなおす-> 一応useFlg === falseをconcatで対処
      // 保存された情報のうち更新フラグの立っているものをindexdbに保存
      const nowDate = (new Date()).toJSON()
      var toSave = self.sagyoKeikaku.filter((e) => {
        return e.updateFlg === true && (e.id > 0 || e.delFlg === false)
      }).map((e) => {
        e.updDateI = nowDate
        return e
      })
      if (self.tempSavedDataPlanFromIndexDb && self.tempSavedDataPlanFromIndexDb.length > 0) {
        toSave = toSave.concat(self.tempSavedDataPlanFromIndexDb.filter((e) => {
          return e.useFlg === false && (e.id > 0 || e.delFlg === false)
        }))
      }
      this.$store.dispatch('tempData/saveDatas', { tbName: 'temp_vwcd2plmd00200', tempData: toSave }).then(() => {
        toSave = self.keikakuSagyoMeisai.filter((e) => {
          return e.updateFlg === true && e.delFlg === false
        }).map((e) => {
          e.updDateI = nowDate
          return e
        })
        this.$store.dispatch('tempData/saveDatas', { tbName: 'temp_vwcd2plmd00201', tempData: toSave }).then(() => {
          toSave = self.keikakuSagyoMeisai2.filter((e) => {
            return e.updateFlg === true && e.delFlg === false
          }).map((e) => {
            e.updDateI = nowDate
            return e
          })
          this.$store.dispatch('tempData/saveDatas', { tbName: 'temp_vwcd2plmd00102', tempData: toSave }).then(() => {
            modals.showAlert('COMI0001')
          })
        })
      })
    },
    /**
     * 保存ボタンクリック
     * @param {*} e
     */
    onSaveButtonClick: function (e) {
      console.log('onSaveButtonClick', e)
      this.isSaving = true
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            // indexedDBからsaveしたものを削除する
            if (self.tempSavedDataPlanFromIndexDb && self.tempSavedDataPlanFromIndexDb.length > 0) {
              var saveList = self.sagyoKeikaku.filter((e) => {
                return e.updateFlg === true
              })
              var toSave = self.tempSavedDataPlanFromIndexDb.filter((e) => {
                const r = saveList.find((ex) => {
                  return ex.id === e.id
                })
                // 同じIDのものは削除する
                if (r || e.useFlg === false) {
                  return false
                }
                return true
              })
              toSave = toSave.concat(self.tempSavedDataPlanFromIndexDb.filter((e) => {
                return e.useFlg === false
              }))
            }
            this.$store.dispatch('tempData/saveDatas', { tbName: 'temp_vwcd2plmd00200', tempData: toSave }).then(() => {
              if (self.tempSavedDataSagyoFromIndexDb && self.tempSavedDataSagyoFromIndexDb.length > 0) {
                toSave = self.tempSavedDataSagyoFromIndexDb.filter((e) => {
                  return e.updateFlg !== true && e.delFlg === false
                })
              } else {
                toSave = []
              }
              this.$store.dispatch('tempData/saveDatas', { tbName: 'temp_vwcd2plmd00201', tempData: toSave }).then(() => {
                if (self.tempSavedDataWorkFromIndexDb && self.tempSavedDataWorkFromIndexDb.length > 0) {
                  toSave = self.tempSavedDataWorkFromIndexDb.filter((e) => {
                    return e.updateFlg !== true && e.delFlg === false
                  })
                } else {
                  toSave = []
                }
                this.$store.dispatch('tempData/saveDatas', { tbName: 'temp_vwcd2plmd00102', tempData: toSave }).then(() => {
                  self.isRecommendReload = false
                  self.conditions.sagyoYoteiYmdFrom = self.tekiyoYmdDayjs.format('YYYY/MM/DD HH:mm:ss')
                  self.conditions.sagyoYoteiYmdTo = self.tekiyoYmdDayjs.add(this.hours, 'h').format('YYYY/MM/DD HH:mm:ss')
                  self.searchExec(false)
                  self.isSaving = false
                  // resolve()
                })
              })
            })
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }

      this.register(opt)
    },
    /**
     * 画面切り替えボタンクリック
     **/
    onChangeViewButtonClick: function () {
      if (this.viewMode === 0) {
        this.storeOrderInfoFromScreenSharyo(this.page)
        this.page = 1
        this.viewMode = 1
        this.createDriverRecords()
        this.tickettab = 'workstab'
        console.log('screen change to driver mode')
      } else {
        this.storeOrderInfoFromScreenDriver(this.page)
        this.page = 1
        this.viewMode = 0
        this.createCarRecords()
      }
      this.deselectAll()
    },
    onAllClearButtonClick: function () {
      const self = this
      // 全部消すのは確定したやつとかも消えてしまうので、行から消す
      // keikakuKakuteiFlgなくなってしまったので、全部消すでもいいような
      modals.showConfirm('COMQ0006').then((ok) => {
        if (ok) {
          // if (this.viewMode === 0) {
          //   this.storeOrderInfoFromScreenSharyo()
          //   this.createDriverRecords()
          // }
          // this.filteredRows2.forEach((e) => {
          //   if (!e.keikakuKakuteiFlg && !(e.jissekiStatus === '9' || e.jissekiStatus === '1')) {
          //     if (e.orderD && Array.isArray(e.orderD)) {
          //       e.orderD.forEach((ed) => {
          //         ed.isOnTray = true
          //       })
          //       e.orderD = []
          //     }
          //     e.car = null
          //   }
          // })
          // this.storeOrderInfoFromScreenDriver()
          this.storeOrderInfoFromScreenSharyo()
          this.createCarRecords()

          this.filteredRows.forEach((e) => {
            if (!e.keikakuKakuteiFlg && !(e.jissekiStatus === '9' || e.jissekiStatus === '1')) {
              // if (e.orderD && Array.isArray(e.orderD)) {
              //   e.orderD.forEach((ed) => {
              //     ed.isOnTray = true
              //   })
              //   e.orderD = []
              // }
              // e.driver = null
              // e.subDriver = null
              // 20220407 配車表の範囲内の発時刻の受注などのみ初期化を行う
              if (e.orderD && Array.isArray(e.orderD)) {
                e.orderD = e.orderD.filter((ex) => {
                  // 削除する -- hatsudayjsが検索条件の範囲のもの以外を返すそれ以外は削除される
                  const ret = (ex.hatsuchiDayjs.isBetween(self.tekiyoYmdDayjs, self.tekiyoYmdDayjs.add(self.hours, 'h'), null, '[]'))
                  if (ret) {
                    ex.isOnTray = true
                    ex.kakuteiFlg = false
                    e.updateFlg = true
                  }
                  return !ret
                })
                if (e.orderD.length === 0) {
                  e.driver = null
                  e.subDriver = null
                  e.jomuinKakuteiFlg = false
                  e.dojoshaKakuteiFlg = false
                }
              }
            }
          })
          this.storeOrderInfoFromScreenSharyo()
          this.viewMode = 0
          this.createCarRecords()
        }
      })
    },
    registerPromise: function () {
      const self = this
      // まず画面の情報を保存する
      if (this.viewMode === 0) {
        this.storeOrderInfoFromScreenSharyo(this.page)
      } else {
        this.storeOrderInfoFromScreenDriver(this.page)
      }
      const sk = this.sagyoKeikaku.filter((e) => {
        return e.updateFlg === true || (e.delFlg === true && e.id > 0)
        // return e.updateFlg === true || ((e.delFlg === true && e.id > 0) && e.delFlg !== true)
      })
      var meisaiList = []
      var sagyoList = []
      sk.forEach((e) => {
        meisaiList = meisaiList.concat(e.trSagyoMeisaiIdArrayList)
        sagyoList = sagyoList.concat(e.trSagyoMeisaiId2ArrayList)
        const sa = this.getSagyoMeisaiFromSagyoMeisaiIdList(e.trSagyoMeisaiIdArrayList, e.trSagyoMeisaiId2ArrayList)
        // e.sagyoYoteiStartYmd = self.getSagyoMeisaiMinDate(sa, e.sagyoYoteiYmd)
        // e.sagyoYoteiEndYmd = self.getSagyoMeisaiMaxDate(sa, e.sagyoYoteiYmd)
        e.sagyoYoteiStartYmd = self.getSagyoMeisaiMinDate(sa, dayjs(e.sagyoYoteiYmd).add(this.tableStartHour, 'hour').format('YYYY/MM/DD HH:mm:ss'))
        e.sagyoYoteiEndYmd = self.getSagyoMeisaiMaxDate(sa, dayjs(e.sagyoYoteiYmd).add(this.tableStartHour, 'hour').format('YYYY/MM/DD HH:mm:ss'))
      })
      const sm = this.keikakuSagyoMeisai.filter((e) => {
        return (e.updateFlg === true || meisaiList.indexOf(e.id) !== -1) && e.delFlg !== true
      })
      const ss = this.keikakuSagyoMeisai2.filter((e) => {
        return (e.updateFlg === true || sagyoList.indexOf(e.id) !== -1) && e.delFlg !== true
      })
      var saveData = {
        vwCD2plmd00200: sk,
        vwCD2plmd00201: sm,
        vwCD2plmd00102: ss
      }
      console.log('posting save data', saveData)
      if (sk && sk.length > 0) {
        var f = this.HttpClient.post('/api/v1/VwCD2plmd00200/Register', saveData)
      } else {
        this.sagyoKeikaku.forEach((e) => {
          e.updateFlg = false
        })
        this.recCar.forEach((e) => {
          e.updateFlg = false
        })
        this.recDriver.forEach((e) => {
          e.updateFlg = false
        })
        f = new Promise((resolve) => { resolve({ summaryMessage: null, invalidList: null }) })
      }
      return f
    },
    registerValidate () {
      const self = this
      var msgid = ''
      // TODO画面でのチェックを行う・・・
      // 同一の車両に、同一の確定と非確定の乗務員を混在させることはできません
      if (this.viewMode === 0) {
        const ca = this.recCar.map((e) => {
          return e.car.id
        })
        var carList = [...new Set(ca)]
        carList.forEach((e) => {
          const percarList = this.recCar.filter((ex) => {
            return ex.car.id === e
          }).filter((ex) => {
            return (self.isValidDriver(ex.driver) || self.isValidDriver(ex.subDriver)) && ex.isEqualUnkouYmdAndTekiyoYmd === true
          })
          // 車ごとの乗務員のリストを作成
          const driverList = [...new Set(percarList.map((em) => { return em.driver ? em.driver.id ?? -1 : -1 }))]
          driverList.forEach((ed) => {
            // この乗務員の行一覧を取り出す
            const perdriverList = percarList.filter((ee) => {
              return (ed === -1 && !self.isValidDriver(ee.driver)) || (self.isValidDriver(ee.driver) && ee.driver.id === ed)
            })
            if (ed !== -1) {
              const fxdrivercount = perdriverList.filter((eg) => {
                return eg.jomuinKakuteiFlg
              }).length
              const nfxdrivercount = perdriverList.filter((eg) => {
                return !eg.jomuinKakuteiFlg
              }).length
              if (fxdrivercount > 0 && nfxdrivercount > 0) {
                msgid = 'PLME0004'
              }
            }
            // 乗務員ごとの同乗者の一覧を作成
            const subdriverList = [...new Set(perdriverList.filter((em) => { return self.isValidDriver(em.subDriver) }).map((em) => { return em.subDriver.id }))]
            subdriverList.forEach((ei) => {
              // この同乗者の行一覧を取り出す
              const persubdriverList = perdriverList.filter((eh) => {
                return self.isValidDriver(eh.subDriver) && eh.subDriver.id === ei
              })
              const fxdrivercount = persubdriverList.filter((eg) => {
                return eg.dojoshaKakuteiFlg
              }).length
              const nfxdrivercount = persubdriverList.filter((eg) => {
                return !eg.dojoshaKakuteiFlg
              }).length
              if (fxdrivercount > 0 && nfxdrivercount > 0) {
                msgid = 'PLME0004'
              }
            })
          })
        })
      }
      if (msgid === '') {
        return true
      } else {
        // this.setInvalidSummaryMessage(msgid)
        console.warn('配車 未確定と確定が混在しています')
        return true
      }
    },
    /**
     * 計画確定フラグ使わなくなったので呼ばれないと思う
     * */
    onClickFixed (item, index) {
      if (this.isReadonlyKengen || (this.viewMode === 0 && this.isReadonlyFixed(item))) {
        return
      }
      var emsg = ''
      console.log(' fixed !', item, index)
      if (item.keikakuKakuteiFlg) {
        if (this.viewMode === 0) {
          if (!this.isValidDriver(item.driver) && !this.isWorksLine(item.orderD) && !this.isYousha(item)) {
            emsg = 'PLME0001'
          } else if (!(item.orderD && Array.isArray(item.orderD) && item.orderD.length > 0)) {
            emsg = 'PLME0002'
          }
          if (emsg !== '') {
            const p = modals.showAlert(emsg, '', 'error', ['乗務員', ''])
            p.then(() => {
              // なにかやることあれば
              item.keikakuKakuteiFlg = false
              // this.recCar[this.getCarDataIndexFromLineID(item.id)].keikakuKakuteiFlg = false
            })
          } else {
            item.updateFlg = true
          }
        } else {
          if (!this.isValidCar(item.car) && !this.isWorksLine(item.orderD)) {
            emsg = 'PLME0001'
          } else if (!(item.orderD && Array.isArray(item.orderD) && item.orderD.length > 0)) {
            emsg = 'PLME0002'
          }
          if (emsg !== '') {
            const p = modals.showAlert(emsg, '', 'error', ['車両', ''])
            p.then(() => {
              // なにかやることあれば
              item.keikakuKakuteiFlg = false
            })
          } else {
            item.updateFlg = true
          }
        }
      }
      if (emsg !== '') {
        return
      }
      var lines = this.getRowDataAsSameList(item, true)
      lines.forEach((e) => {
        e.updateFlg = true
        e.keikakuKakuteiFlg = item.keikakuKakuteiFlg
      })
    },
    isReadonlyFixed (item) {
      return item.jissekiStatus === '9'
    },
    onMultiSelectButtonClick (e) {
      this.deselectAll()
      this.isUseCheckbox = !this.isUseCheckbox
    },
    onSelectCheckBoxClicked (item) {
      if (this.isSelectSingleOnly && item.isSelected) {
        this.deselectAll()
        item.isSelected = true
      }
    },
    onDriverSelectCheckBoxClicked (item) {
      if (this.isSelectSingleOnly || this.isDriverMultiSelect === false) {
        if (item.isSelected) {
          this.deselectAllDrivers()
          item.isSelected = true
        }
      } else {
        if (item.isSelected) {
          item.isSelected = true
          item.selectionNumber = this.getMaxSelctionNumber() + 1
        } else {
          // 番号の振りなおし
          this.deselect1Drivers(item)
        }
      }
    },
    // #endregion
    // #region 配車画面 表制御
    /**
     * グリッドに表示する時間をindexから生成する
     **/
    calcTimeFromIndex: function (n) {
      var t = (n - 1) * this.hoursInterval + (this.tableStartHour)
      if (t >= 24) {
        t = t % 24
      }
      return String(t) + ':00'
    },
    // #region 配車画面 表制御 車両別
    countAllColumns () {
      if (this.viewMode === 0) {
        return 3 + (this.hours / this.hoursInterval)
      } else {
        return 1 + (this.hours / this.hoursInterval)
      }
    },
    /**
     * 車両別画面で前の行と同じ車両であればtrue
     * trタグの出力の可否のために使用する
     * @param {integer} rowIndex
     * @returns {boolean} true:同じ車両
     */
    isSkipTRonSharyo (rowIndex) {
      if (rowIndex === 0) {
        return false
      }
      if (this.filteredRows[rowIndex].car.id === this.filteredRows[rowIndex - 1].car.id) {
        return true
      }
      return false
    },
    /**
     * 車両別画面で前の行と同じ車両、ドライバであればtrue
     * trタグの出力の可否のために使用する
     * @param {integer} rowIndex
     * @returns {boolean} true:同じ車両で同じドライバ
     */
    isSkipTRDiffDriveronSharyo (rowIndex, rows = this.filteredRows) {
      if (rowIndex === 0) {
        return false
      }
      var ret = false
      if (rows[rowIndex].car.id === rows[rowIndex - 1].car.id) {
        if (this.compareSameDriver(rows[rowIndex].driver, rows[rowIndex - 1].driver)) {
          ret = true
        }
        if (ret === true) {
          if (this.isWorksLine(rows[rowIndex].orderD) === this.isWorksLine(rows[rowIndex - 1].orderD)) {
          } else {
            ret = false
          }
        }
        if (ret === true) {
          if (rows[rowIndex].jomuinKakuteiFlg !== rows[rowIndex - 1].jomuinKakuteiFlg) {
            ret = false
          }
        }
      }
      return ret
    },
    /**
     * 車両別画面で前の行と同じ車両、ドライバであればtrue
     * trタグの出力の可否のために使用する
     * @param {integer} rowIndex
     * @returns {boolean} true:同じ車両で同じドライバ
     */
    isSkipTRDiffSubDriveronSharyo (rowIndex, rows = this.filteredRows) {
      var rt = false
      if (rowIndex === 0) {
        return false
      }
      if (this.isSkipTRDiffDriveronSharyo(rowIndex, rows) === true) {
        if (this.compareSameDriver(rows[rowIndex].subDriver, rows[rowIndex - 1].subDriver)) {
          rt = true
        }
        if (rt === true) {
          if (this.isWorksLine(rows[rowIndex].orderD) !== this.isWorksLine(rows[rowIndex - 1].orderD)) {
            rt = false
          }
        }
        if (rt === true) {
          if (rows[rowIndex].dojoshaKakuteiFlg !== rows[rowIndex - 1].dojoshaKakuteiFlg) {
            rt = false
          }
        }
      }
      return rt
    },
    isSkipTRDiffJissekionSharyo (rowIndex, rows = this.filteredRows) {
      var rt = false
      if (rowIndex === 0) {
        return false
      }
      if (this.isSkipTRDiffSubDriveronSharyo(rowIndex, rows) === true) {
        rt = true
        if (rows[rowIndex].isEqualUnkouYmdAndTekiyoYmd !== rows[rowIndex - 1].isEqualUnkouYmdAndTekiyoYmd) {
          rt = false
        }
      }
      return rt
    },
    /**
     * 車両別画面で同じ車両が何個続くかを計算する
     * trタグのrowspan出力のために使用する
     * @param {integer} rowIndex
     * @returns {integer} 続く行数
     */
    countSameRowsonSharyo (rowIndex) {
      var i
      for (i = 1; (i + rowIndex) < this.filteredRows.length; i++) {
        if (this.filteredRows[rowIndex].car.id !== this.filteredRows[rowIndex + i].car.id) {
          break
        }
      }
      return i
    },
    countSameRowsDiffDriveronSharyo (rowIndex) {
      var i
      for (i = 1; (i + rowIndex) < this.filteredRows.length; i++) {
        if (this.filteredRows[rowIndex].car.id !== this.filteredRows[rowIndex + i].car.id) {
          break
        }
        if (!this.compareSameDriver(this.filteredRows[rowIndex].driver, this.filteredRows[rowIndex + i].driver)) {
          break
        }
        if (this.isWorksLine(this.filteredRows[rowIndex].orderD) !== this.isWorksLine(this.filteredRows[rowIndex + i].orderD)) {
          break
        }
        if (this.filteredRows[rowIndex].jomuinKakuteiFlg !== this.filteredRows[rowIndex + i].jomuinKakuteiFlg) {
          break
        }
      }
      return i
    },
    isWorksLine (orderD) {
      if (orderD.find((e) => {
        return e.isWork
      })) {
        return true
      }
      return false
    },
    isYousha (item) {
      if (item.car && item.car.hacchusakiFlg) {
        return true
      }
      return false
    },
    countSameRowsDiffSubDriveronSharyo (rowIndex) {
      var i
      for (i = 1; (i + rowIndex) < this.filteredRows.length; i++) {
        if (this.filteredRows[rowIndex].car.id !== this.filteredRows[rowIndex + i].car.id) {
          break
        }
        if (!this.compareSameDriver(this.filteredRows[rowIndex].driver, this.filteredRows[rowIndex + i].driver)) {
          break
        }
        if (!this.compareSameDriver(this.filteredRows[rowIndex].subDriver, this.filteredRows[rowIndex + i].subDriver)) {
          break
        }
        if (this.isWorksLine(this.filteredRows[rowIndex].orderD) !== this.isWorksLine(this.filteredRows[rowIndex + i].orderD)) {
          break
        }
        if (this.filteredRows[rowIndex].jomuinKakuteiFlg !== this.filteredRows[rowIndex + i].jomuinKakuteiFlg) {
          break
        }
        if (this.filteredRows[rowIndex].dojoshaKakuteiFlg !== this.filteredRows[rowIndex + i].dojoshaKakuteiFlg) {
          break
        }
      }
      return i
    },
    countSameRowsDiffJissekionSharyo (rowIndex) {
      var i
      for (i = 1; (i + rowIndex) < this.filteredRows.length; i++) {
        if (this.filteredRows[rowIndex].car.id !== this.filteredRows[rowIndex + i].car.id) {
          break
        }
        if (!this.compareSameDriver(this.filteredRows[rowIndex].driver, this.filteredRows[rowIndex + i].driver)) {
          break
        }
        if (!this.compareSameDriver(this.filteredRows[rowIndex].subDriver, this.filteredRows[rowIndex + i].subDriver)) {
          break
        }
        if (this.isWorksLine(this.filteredRows[rowIndex].orderD) !== this.isWorksLine(this.filteredRows[rowIndex + i].orderD)) {
          break
        }
        if (this.filteredRows[rowIndex].jomuinKakuteiFlg !== this.filteredRows[rowIndex + i].jomuinKakuteiFlg) {
          break
        }
        if (this.filteredRows[rowIndex].dojoshaKakuteiFlg !== this.filteredRows[rowIndex + i].dojoshaKakuteiFlg) {
          break
        }
        if (this.filteredRows[rowIndex].isEqualUnkouYmdAndTekiyoYmd !== this.filteredRows[rowIndex + i].isEqualUnkouYmdAndTekiyoYmd) {
          break
        }
      }
      return i
    },
    isSameRowSharyo (r1, r2) {
      if (this.isValidCar(r1.car) && this.isValidCar(r2.car)) {
        if (r1.car.id === r2.car.id) {

        } else {
          return false
        }
      } else if (!this.isValidCar(r1.car) && !this.isValidCar(r2.car)) {
      } else {
        return false
      }
      if (!this.compareSameDriver(r1.driver, r2.driver)) {
        return false
      }
      if (!this.compareSameDriver(r1.subDriver, r2.subDriver)) {
        return false
      }
      if (this.isWorksLine(r1.orderD) !== this.isWorksLine(r2.orderD)) {
        return false
      }
      if (r1.jomuinKakuteiFlg !== r2.jomuinKakuteiFlg) {
        return false
      }
      if (r1.dojoshaKakuteiFlg !== r2.dojoshaKakuteiFlg) {
        return false
      }
      return true
    },
    borderEraseSharyo (index, retStr) {
      var ueraseFlg = false
      var leraseFlg = false
      const thisRow = this.filteredRows[index]
      if (index !== 0) {
        const prevRow = this.filteredRows[index - 1]
        if (this.isSameRowSharyo(thisRow, prevRow)) {
          ueraseFlg = true
        }
      }
      if (index !== this.filteredRows.length - 1) {
        const nextRow = this.filteredRows[index + 1]
        if (this.isSameRowSharyo(thisRow, nextRow)) {
          leraseFlg = true
        }
      }
      if (ueraseFlg) {
        retStr += 'border-top: hidden !important;'
      }
      if (leraseFlg) {
        retStr += 'border-bottom: hidden !important;'
      }
      // console.log(retStr)
      return retStr
    },
    borderEraseDriver (index, retStr) {
      var ueraseFlg = false
      var leraseFlg = false
      if (index !== 0) {
        if (this.isValidCar(this.filteredRows2[index].car) && this.isValidCar(this.filteredRows2[index - 1].car)) {
          if (this.filteredRows2[index].driver.id === this.filteredRows2[index - 1].driver.id && this.filteredRows2[index].car.id === this.filteredRows2[index - 1].car.id) {
            ueraseFlg = true
          }
        } else if (!this.isValidCar(this.filteredRows2[index].car) && !this.isValidCar(this.filteredRows2[index - 1].car)) {
          if (this.filteredRows2[index].driver.id === this.filteredRows2[index - 1].driver.id) {
            ueraseFlg = true
          }
        }
      }
      if (index !== this.filteredRows2.length - 1) {
        if (this.isValidCar(this.filteredRows2[index].car) && this.isValidCar(this.filteredRows2[index + 1].car)) {
          if (this.filteredRows2[index].car.id === this.filteredRows2[index + 1].car.id && this.filteredRows2[index].driver.id === this.filteredRows2[index + 1].driver.id) {
            leraseFlg = true
          }
        } else if (!this.isValidCar(this.filteredRows2[index].car) && !this.isValidCar(this.filteredRows2[index + 1].car)) {
          if (this.filteredRows2[index].driver.id === this.filteredRows2[index + 1].driver.id) {
            leraseFlg = true
          }
        }
      }
      if (ueraseFlg) {
        retStr += 'border-top: hidden !important;'
      }
      if (leraseFlg) {
        retStr += 'border-bottom: hidden !important;'
      }
      // console.log(retStr)
      return retStr
    },
    // #endregion
    // #region 配車画面 表制御 ドライバ別
    isSkipTRonDriver (rowIndex) {
      if (rowIndex === 0) {
        return false
      }
      if (this.filteredRows2[rowIndex].driver.id === this.filteredRows2[rowIndex - 1].driver.id) {
        return true
      }
      return false
    },
    isSkipTRDiffCaronDriver (rowIndex) {
      if (rowIndex === 0) {
        return false
      }
      var ret = false
      if (this.filteredRows2[rowIndex].driver.id === this.filteredRows2[rowIndex - 1].driver.id) {
        if (this.isValidCar(this.filteredRows2[rowIndex].car) && this.isValidCar(this.filteredRows2[rowIndex - 1].car) && this.filteredRows2[rowIndex].car.id === this.filteredRows2[rowIndex - 1].car.id) {
          ret = true
        } else if (!this.isValidCar(this.filteredRows2[rowIndex].car) && !this.isValidCar(this.filteredRows2[rowIndex - 1].car)) {
          ret = true
        }
      }
      if (ret === true) {
        if (this.isWorksLine(this.filteredRows2[rowIndex].orderD) === this.isWorksLine(this.filteredRows2[rowIndex - 1].orderD)) {
        } else {
          ret = false
        }
      }
      return ret
    },
    countSameRowsonDriver (rowIndex) {
      var i
      for (i = 1; (i + rowIndex) < this.filteredRows2.length; i++) {
        if (this.filteredRows2[rowIndex].driver.id !== this.filteredRows2[rowIndex + i].driver.id) {
          break
        }
      }
      return i
    },
    countSameRowsDiffDriveronDriver (rowIndex) {
      var i
      for (i = 1; (i + rowIndex) < this.filteredRows2.length; i++) {
        if (this.filteredRows2[rowIndex].driver.id !== this.filteredRows2[rowIndex + i].driver.id) {
          break
        }
        const f1 = this.isValidCar(this.filteredRows2[rowIndex].car)
        const f2 = this.isValidCar(this.filteredRows2[rowIndex + i].car)
        if ((!f1 && f2) || (f1 && !f2)) {
          break
        }
        if (f1 && f2 && this.filteredRows2[rowIndex].car.id !== this.filteredRows2[rowIndex + i].car.id) {
          break
        }
        if (this.isWorksLine(this.filteredRows2[rowIndex].orderD) !== this.isWorksLine(this.filteredRows2[rowIndex + i].orderD)) {
          break
        }
      }
      return i
    },
    isSkipTDonSharyo: function (orderInfo, index) {
      // const isBetween = require('dayjs/plugin/isBetween')
      // dayjs.extend(isBetween)
      const self = this

      const nt = this.tekiyoYmdDayjs.clone().add((index - 1) * this.hoursInterval, 'hour')

      var skipflag = false

      if (orderInfo) {
        if (Array.isArray(orderInfo)) {
          orderInfo.forEach(function (ele) {
            var hhx = ele.hatsuchiDayjs.clone()
            var chx = ele.chakuchiDayjs.clone()
            hhx.minute(0)
            hhx = self.adjustStartTimeByInterval(hhx)
            if (chx.minute() > 0) {
              chx = chx.hour(chx.hour() + 1)
              chx = chx.minute(0)
            }
            if (nt.isBetween(hhx, chx)) {
              if (nt.isSame(hhx)) {
                // 最初のカラムなのでskipしない
              } if (index === 1) {
                // 最初のカラムでもっと前にはじまってるやつなのでskipしない
              } else {
                skipflag = true
              }
            }
          })
        }
      }
      return skipflag
    },
    isSkipTDonDriver: function (itemRow, index) {
      const self = this

      // var orderInfo = this.getOrderFromDriverId(itemRow.driver.id)
      var orderInfo = itemRow.orderD
      // return isSkipTDonSharyoと同じだがとりあえず
      const nt = this.tekiyoYmdDayjs.clone().add((index - 1) * this.hoursInterval, 'hour')

      var skipflag = false

      if (orderInfo) {
        if (Array.isArray(orderInfo)) {
          orderInfo.forEach(function (ele) {
            var hhx = ele.hatsuchiDayjs.clone()
            var chx = ele.chakuchiDayjs.clone()
            hhx.minute(0)
            hhx = self.adjustStartTimeByInterval(hhx)
            if (chx.minute() > 0) {
              chx = chx.hour(chx.hour() + 1)
              chx = chx.minute(0)
            }
            // console.log('nt,hhx,chx', nt, hhx, chx)
            var r = nt.isBetween(hhx, chx)
            // console.log('is beetween ', r)
            if (r) {
              // console.log('same nt,hhx,chx', nt, hhx, chx)
              if (nt.isSame(hhx)) {
                // 最初のカラムなのでskipしない
              } if (index === 1) {
                // 最初のカラムでもっと前にはじまってるやつなのでskipしない
              } else {
                // console.log('skip -- same nt,hhx,chx', nt, hhx, chx)
                skipflag = true
              }
            }
          })
        }
      }
      return skipflag
    },
    isStartTDonSharyo: function (orderInfo, index) {
      // console.log('isStartTDonSharyo')
      if (!Array.isArray(orderInfo) || orderInfo.length === 0) {
        return false
      }
      const ele = this.getOrderFromTimeIndexAndOrderArray(index, orderInfo)
      if (ele === undefined) {
        return false
      } else {
        return true
      }
    },
    isStartTDonDriver: function (orderInfo, index) {
      // 車両と同じ
      const ele = this.getOrderFromTimeIndexAndOrderArray(index, orderInfo)
      if (ele === undefined) {
        return false
      } else {
        return true
      }
    },
    countHoursonSharyo: function (orderInfo, index) {
      const ele = this.getOrderFromTimeIndexAndOrderArray(index, orderInfo)
      var hhx = ele.hatsuchiDayjs.clone()
      var chx = ele.chakuchiDayjs.clone()

      // hhx = hhx.minute(0)
      hhx = this.adjustStartTimeByInterval(hhx, true)
      chx = this.adjustEndTimeByInterval(chx, true)

      // if (chx.minute() > 0) {
      //   chx = chx.hour(chx.hour() + 1)
      //   chx = chx.minute(0)
      // }
      var dif = chx.diff(hhx, 'hour')
      dif = Math.ceil(dif / this.hoursInterval)
      if (this.tekiyoYmdDayjs.isAfter(hhx)) {
        dif = dif - Math.ceil(this.tekiyoYmdDayjs.diff(hhx, 'h') / this.hoursInterval)
      }
      return dif
    },
    countHoursonDriver: function (orderInfo, index) {
      // console.log('count hour', orderInfo, index)
      // 車両と同じ
      const ele = this.getOrderFromTimeIndexAndOrderArray(index, orderInfo)
      if (!ele) {
        console.log('★err', orderInfo, index, ele)
      }
      var hhx = ele.hatsuchiDayjs.clone()
      var chx = ele.chakuchiDayjs.clone()

      // hhx = hhx.minute(0)
      hhx = this.adjustStartTimeByInterval(hhx, true)
      chx = this.adjustEndTimeByInterval(chx, true)
      // if (chx.minute() > 0) {
      //   chx = chx.hour(chx.hour() + 1)
      //   chx = chx.minute(0)
      // }
      var dif = chx.diff(hhx, 'hour')
      dif = Math.ceil(dif / this.hoursInterval)
      if (this.tekiyoYmdDayjs.isAfter(hhx)) {
        dif = dif - Math.ceil(this.tekiyoYmdDayjs.diff(hhx, 'h') / this.hoursInterval)
      }

      return dif
    },
    // #endregion
    // getOrderTicketId: function (item, index) {
    //   const ele = this.getOrderByTimeIndexFromOrderArray(index, item.orderD)
    //   if (ele === undefined) {
    //     return ''
    //   }
    //   return ele.id
    // },
    getOrderIdFromDisplayRowAndTimeIndex: function (itemRow, index) {
      const ele = this.getOrderFromTimeIndexAndOrderArray(index, itemRow.orderD)
      if (ele === undefined) {
        return ''
      }
      return ele.id
    },
    getOrderIdFromDisplayRowAndTimeIndexS: function (itemRow, index) {
      const ele = this.getOrderFromTimeIndexAndOrderArray(index, itemRow.orderD)
      if (ele === undefined) {
        return ''
      }
      if (ele.mainDriverId === itemRow.driver.id) {
        return ele.id + 'm'
      }
      return ele.id + 's'
    },
    isWorkFromDisplayRowAndTimeIndex: function (itemRow, index) {
      const ele = this.getOrderFromTimeIndexAndOrderArray(index, itemRow.orderD)
      if (ele === undefined) {
        return false
      }
      return ele.isWork
    },
    drawOrderTicket: function (orderInfo, index) {
      const ele = this.getOrderFromTimeIndexAndOrderArray(index, orderInfo)
      if (ele === undefined) {
        return ''
      }
      // const flg = '正'
      // s += `<span aria-atomic="true" aria-label="バッジ" aria-live="polite" role="status" class="v-badge__badge red" style="margin-top: -12px;">${flg}</span>`

      return this.drawOrderTicketUseItem(ele)
    },
    drawOrderTicketWithBadge: function (orderInfo, index, item) {
      // itemはFiltersRows2の1行
      const ele = this.getOrderFromTimeIndexAndOrderArray(index, orderInfo)
      if (ele === undefined) {
        return ''
      }
      var data = this.drawOrderTicketUseItem(ele)
      var flg
      if (ele.isWork) {
        return data
      }
      if (ele.mainDriverId === item.driver.id) {
        flg = '乗'
      } else {
        flg = '同'
      }
      if (this.conditions.line1) {
        var top = -9
      } else {
        top = -18
      }
      data = `<span aria-atomic="true" aria-label="バッジ" aria-live="polite" role="status" class="v-badge__badge green" style="margin-top: 3px;margin-left: -28px;margin-bottom:-5px; position: relative; top: ${top}px;left: 14px">${flg}</span>` + data
      return data
    },
    onClickLockButton (e) {
      console.log(e)
    },
    /**
     * オーダーチケットの形はここで共通的に設定する
     * @param {orderStructure} order
     * @returns {string} HTMLなオーダーチケット
     */
    drawOrderTicketUseItem (order) {
      // const sanitizer = new Sanitizer()
      const sanitizer = {
        sanitize: function (str) {
          return String(str).replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
        }
      }
      var lockIcon = ''
      if (!order.isOnTray) {
        if (order.kakuteiFlg) {
          lockIcon = LOCK_ICON_TAG_ON
        } else {
          lockIcon = LOCK_ICON_TAG_OFF
        }
      }
      if (order.isWork) {
        return this.drawWorksTicketUseItem(order, lockIcon)
      }
      // オーダーチケットの形はここで共通的に設定できる
      const dayStr1 = order.hatsuchiDayjs.format('M/D') + ' '
      var dayStr2
      if (order.hatsuchiDayjs.isSame(order.chakuchiDayjs, 'd')) {
        dayStr2 = ''
      } else {
        dayStr2 = order.chakuchiDayjs.format('M/D') + ' '
      }
      // var dayStr
      // if (order.chakuchiYmd) {
      //   var days = dayjs(order.chakuchiYmd).diff(dayjs(order.hatsuchiYmd), 'day', false)
      //   if (days === 0 || !days) {
      //     daysStr = ''
      //   } else if (Number(days) === 1) {
      //     daysStr = '翌'
      //   } else {
      //     daysStr = days + '日後'
      //   }
      // } else {
      //   daysStr = ''
      // }
      // var daysStr2 = ''
      // if (order.hatsuchiYmd && order.isOnTray !== true) {
      //   if (!order.hatsuchiDayjs.isSame(this.tekiyoYmdDayjs, 'd')) {
      //     daysStr2 = order.hatsuchiDayjs.format('MM/DD') + ' '
      //   }
      // }
      var widthSize1 = 18
      // var widthSize2 = 32
      // var widthSize3 = 30
      if (this.sizeType === -1) {
        widthSize1 = 16
        // widthSize2 = 22
        // widthSize3 = 22
      } else if (this.sizeType === 1) {
        widthSize1 = 24
        // widthSize2 = 38
        // widthSize3 = 36
      }
      if (order.isOnTray) {
        var heightSize = this.calcChipHeight()
      } else {
        heightSize = this.calcChipHeight(this.conditions.line1)
      }
      const fontClassName = this.fontSizeClass()
      var sfix
      var efix
      var sClr
      var eClr
      if (order.startLockFlg || order.shujitsuFlg) {
        sfix = 'bold'
        sClr = 'red'
      } else {
        sfix = 'normal'
        sClr = 'black'
      }
      if (order.endLockFlg) {
        efix = 'bold'
        eClr = 'red'
      } else {
        efix = 'normal'
        eClr = 'black'
      }
      // const tokuisakiNm = this.getTorihikisakiNmFromId(order.tokuisakiId)
      var chakuchiHms
      var hatsuchiHms
      // if (order.hatsuchiHms) {
      //   hatsuchiHms = order.hatsuchiHms.substring(0, 5)
      // } else {
      //   hatsuchiHms = ''
      // }
      // if (order.chakuchiHms) {
      //   chakuchiHms = order.chakuchiHms.substring(0, 5)
      // } else {
      //   chakuchiHms = ''
      // }
      if (order.hatsuchiHms) {
        hatsuchiHms = order.hatsuchiDayjs.format('H:mm')
      } else {
        hatsuchiHms = ''
      }
      if (order.chakuchiHms) {
        chakuchiHms = order.chakuchiDayjs.format('H:mm')
      } else {
        chakuchiHms = ''
      }
      var hatsuchiNm
      var chakuchiNm
      if (order.keiyakuHojoKbn === '2' && order.hatsuchiId === null) {
        hatsuchiNm = order.hatsuchiBiko ?? ''
      } else {
        hatsuchiNm = order.hatsuchiNm
      }
      if (order.keiyakuHojoKbn === '2' && order.chakuchiId === null) {
        chakuchiNm = order.chakuchiBiko ?? ''
      } else {
        chakuchiNm = order.chakuchiNm
      }
      var s = ''
      if (this.conditions.line1 && order.isOnTray !== true) {
        // s += `<div style="width:${widthSize1}px;display:inline-block;background:${order.hatsuchiColor};" data-id="${order.id}">`
        // s += `${order.hatsuchiNm}</div>`
        // s += `<div style="width:calc(100% - ${widthSize2}px);display:inline-block;background:${order.chakuchiColor};color:${this.blackOrWhite(order.chakuchiColor)}" data-id="${order.id}">`
        // s += `<span>${order.juchuNo}</span>&nbsp;<span style="font-weight: ${fix}" >${order.hatsuchiHms.substring(0, 5)}～${daysStr}${order.chakuchiHms.substring(0, 5)}</span>`
        // s += `<span>【${order.tokuisakiNm}】 → ${order.chakuchiNm}</span></div>`

        s += `<div class="${fontClassName}" style="width:${widthSize1}px;height:${heightSize}px;display:inline-block;background:${order.hatsuchiColor};" data-id="${order.id}"></div><div`
        // s += ``
        s += `  class="${fontClassName}" style="vertical-align: top;min-width:${widthSize1}px;width:calc(100% - ${widthSize1}px);display:inline-block;background:${order.chakuchiColor};" data-id="${order.id}">`
        s += `<span>${lockIcon}${sanitizer.sanitize(order.ninushiNm)}【${sanitizer.sanitize(order.kamotsuKbnNm)}】 (${order.seikyuShashuSbtNm}) ${dayStr1}</span>`
        if (order.shujitsuFlg) {
          s += `<span style="font-weight: ${sfix};color: ${sClr}">終日&nbsp;${sanitizer.sanitize(hatsuchiNm)} → `
          s += `${sanitizer.sanitize(chakuchiNm)}`
        } else {
          s += `<span style="font-weight: ${sfix};color: ${sClr}">${hatsuchiHms} ${sanitizer.sanitize(hatsuchiNm)}</span> → <span style="font-weight: ${efix};color: ${eClr}">${dayStr2}${chakuchiHms}`
          s += ` ${sanitizer.sanitize(chakuchiNm)}`
        }
        if (order.chumonNo && order.chumonNo.length > 0) {
          s += `(${sanitizer.sanitize(order.chumonNo)})`
        }
        s += '</span></div>'
      } else {
        s += `<div class="${fontClassName}" style="width:${widthSize1}px;height:${heightSize}px;display:inline-block;background:${order.hatsuchiColor};writing-mode: vertical-rl;text-align:center;" data-id="${order.id}">`
        s += `${order.kamotsuKbnNm}</div>`
        s += `<div class="${fontClassName}" style="vertical-align: top;min-width:${widthSize1}px;width:calc(100% - ${widthSize1}px);display:inline-block;background:${order.chakuchiColor};" data-id="${order.id}">`
        s += `<span>${lockIcon}${sanitizer.sanitize(order.ninushiNm)}</span> (${order.seikyuShashuSbtNm}) ${dayStr1}<br />`
        if (order.shujitsuFlg) {
          s += `<span style="font-weight: ${sfix};color: ${sClr}">終日&nbsp;${sanitizer.sanitize(hatsuchiNm)} → `
          s += `${sanitizer.sanitize(chakuchiNm)}</span>`
        } else {
          s += `<span style="font-weight: ${sfix};color: ${sClr}">${hatsuchiHms} ${sanitizer.sanitize(hatsuchiNm)}</span> → <span style="font-weight: ${efix};color: ${eClr}">${dayStr2}${chakuchiHms}`
          s += ` ${sanitizer.sanitize(chakuchiNm)}</span>`
        }
        if (order.chumonNo && order.chumonNo.length > 0) {
          s += `<br />${sanitizer.sanitize(order.chumonNo)}`
        }
        s += '</span></div>'
      }

      return s
    },
    drawDrTicketUseItem: function (item, icon = '') {
      // const sanitizer = new Sanitizer()
      const sanitizer = {
        sanitize: function (str) {
          return String(str).replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
        }
      }
      if (item.color) {
        var bkg = ` style="color:${this.blackOrWhite(item.color)}"`
      } else {
        bkg = ''
      }
      var ret
      // ドライバーチケットの形はここで共通的に設定できる
      if (this.conditions.line1 && (item.isOnTray !== true || this.viewMode === 1)) {
        ret = `${icon}<span ${bkg}>【${sanitizer.sanitize(item.jininNm)}】</span>`
      } else {
        ret = `${icon}<span ${bkg}>${sanitizer.sanitize(item.jininNm)}</span><br/><span ${bkg}>${sanitizer.sanitize(item.shanaiBiko1 ?? '')}&nbsp;</span>`
      }
      if (item.isOnTray && item.isSelected && item.selectionNumber > 0 && this.isDriverMultiSelect) {
        ret = ret + `<div class="selctionNumber" style="${this.listObject(this.checkboxScaleStyle)}">${item.selectionNumber}</div>`
      }
      return ret
    },
    drawDrTicketUseItemWithBadge: function (item, row, mod, icon) {
      const self = this
      // ドライバーチケットの形はここで共通的に設定できる
      const x = this.getSameDriverAndCar(row, this.recCar, null, true, mod)
      // const xf = x.find((e) => {
      //   return (mod === 'main' && e.driver.masterFlg === true) || (mod === 'sub' && e.subDriver.masterFlg === true)
      // })
      const countDriver = this.getCountDriver(row, this.recCar, null, mod)
      if (x.length < countDriver) {
        var xf = false
      } else {
        xf = true
      }
      if (xf) {
        if (this.sagyoKeikaku.find(e => {
          if (e.jomuinId === item.id || e.dojoshaId === item.id) {
            if (self.keikakuSharyoList.find((ex) => {
              return ex.id === e.sharyoId
            })) {
              return false
            }
            return true
          }
          return false
        })) {
          xf = false
        }
      }
      var data = ''
      // if (!item.masterFlg) {
      if (!xf) {
        const flg = this.badgeText
        if (this.conditions.line1) {
          var top = -9
        } else {
          top = -8
        }
        data = `<span aria-atomic="true" aria-label="バッジ" aria-live="polite" role="status" class="v-badge__badge blue" style="margin-top: 3px;margin-left: -14px;margin-bottom:-5px; position: relative; top: ${top}px;left: 8px">${flg}</span>`
      }

      return data + this.drawDrTicketUseItem(item, icon)
    },
    drawDrTicketUseItemWithLockIcon: function (item, row, mod) {
      if (!item.isOnTray) {
        if ((mod === 'main' && row.jomuinKakuteiFlg) || (mod === 'sub' && row.dojoshaKakuteiFlg)) {
          var lockIcon = LOCK_ICON_TAG_ON
        } else {
          lockIcon = LOCK_ICON_TAG_OFF
        }
      }
      return this.drawDrTicketUseItemWithBadge(item, row, mod, lockIcon)
    },
    // drawCarTicket: function (item) {
    //   var car = this.getCarFromCarid(item)
    //   return this.drawCarTicketUseItem(car)
    // },
    drawCarTicketUseItem: function (item) {
      // const sanitizer = new Sanitizer()
      const sanitizer = {
        sanitize: function (str) {
          return String(str).replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
        }
      }
      // ドライバーチケットの形はここで共通的に設定できる
      var disp = ''
      if (item.hacchusakiFlg) {
        // 発注先名は不要らしい
        // youshaNm = '【' + item.hacchusakiNm + '】'
        disp = `【${item.jidoshaHyojiNm}】`
      } else {
        disp = item.jidoshaHyojiNm
      }
      if (item.shashuSbtNm) {
        disp = sanitizer.sanitize(disp) + `(${item.shashuSbtNm})`
      }
      if (item.color) {
        var bkg = ` style="color:${this.blackOrWhite(item.color)}"`
      } else {
        bkg = ''
      }
      if (this.conditions.line1) {
        // return `<span>${item.torokuNo}</span><span>${youshaNm}【${item.jidoshaHyojiNm}】</span>`
        return `<span ${bkg}>${sanitizer.sanitize(item.torokuNo)}</span><span ${bkg}>${disp}</span>`
      } else {
        // return `<span>${item.torokuNo}</span><br/><span>${youshaNm}${item.jidoshaHyojiNm}</span>`
        return `<span ${bkg}>${sanitizer.sanitize(item.torokuNo)}</span><br/><span ${bkg}>${disp}</span>`
      }
    },
    drawWorksTicketUseItem: function (order, icon = '') {
      // const sanitizer = new Sanitizer()
      const sanitizer = {
        sanitize: function (str) {
          return String(str).replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
        }
      }
      // console.log('works ticket draw', order)
      // オーダーチケットの形はここで共通的に設定できる
      // var days = dayjs(order.endYmd).diff(dayjs(order.startYmd), 'day', false)
      const dayStr1 = order.hatsuchiDayjs.format('M/D') + ' '
      // var dayStr2
      // if (order.hatsuchiDayjs.isSame(order.chakuchiDayjs, 'd')) {
      //   dayStr2 = ''
      // } else {
      //   dayStr2 = order.chakuchiDayjs.format('MM/DD') + ' '
      // }
      // var daysStr
      // if (order.endYmd) {
      //   if (days === 0 || !days) {
      //     daysStr = ''
      //   } else if (Number(days) === 1) {
      //     daysStr = '翌'
      //   } else {
      //     daysStr = days + '日後'
      //   }
      // } else {
      //   daysStr = ''
      // }
      var widthSize1 = 18
      var widthSize2 = 32
      var widthSize3 = 30
      if (this.sizeType === -1) {
        widthSize1 = 16
        widthSize2 = 22
        widthSize3 = 22
      } else if (this.sizeType === 1) {
        widthSize1 = 24
        widthSize2 = 38
        widthSize3 = 36
      }
      if (order.isOnTray) {
        var heightSize = this.calcChipHeight()
      } else {
        heightSize = this.calcChipHeight(this.conditions.line1)
      }
      const fontClassName = this.fontSizeClass()
      var sfix
      var efix
      var sClr
      var eClr
      if (order.startLockFlg || order.shujitsuFlg) {
        sfix = 'bold'
        sClr = 'red'
      } else {
        sfix = 'normal'
        sClr = 'black'
      }
      if (order.endLockFlg) {
        efix = 'bold'
        eClr = 'red'
      } else {
        efix = 'normal'
        eClr = 'black'
      }
      var endHms
      var startHms
      // if (order.startHms) {
      //   startHms = order.startHms.substring(0, 5)
      // } else {
      //   startHms = ''
      // }
      // if (order.endHms) {
      //   endHms = order.endHms.substring(0, 5)
      // } else {
      //   endHms = ''
      // }
      if (order.startHms) {
        startHms = order.hatsuchiDayjs.format('H:mm')
      } else {
        startHms = ''
      }
      if (order.endHms) {
        endHms = order.chakuchiDayjs.format('H:mm')
      } else {
        endHms = ''
      }
      // const tokuisakiNm = this.getTorihikisakiNmFromId(order.tokuisakiId)
      var s = ''
      if (this.conditions.line1 && order.isOnTray !== true) {
        // s += `<div style="width:${widthSize1}px;display:inline-block;background:${order.hatsuchiColor};" data-id="${order.id}">`
        // s += `${order.hatsuchiNm}</div>`
        // s += `<div style="width:calc(100% - ${widthSize2}px);display:inline-block;background:${order.chakuchiColor};color:${this.blackOrWhite(order.chakuchiColor)}" data-id="${order.id}">`
        // s += `<span>${order.juchuNo}</span>&nbsp;<span style="font-weight: ${fix}" >${order.hatsuchiHms.substring(0, 5)}～${daysStr}${order.chakuchiHms.substring(0, 5)}</span>`
        // s += `<span>【${order.tokuisakiNm}】 → ${order.chakuchiNm}</span></div>`

        s += `<div class="${fontClassName}" style="vertical-align: top;width:${widthSize1}px;height:${heightSize}px;display:inline-block;" data-id="${order.id}"></div><div`
        // s += ``
        s += `  class="${fontClassName}" style="vertical-align: top;min-width:${widthSize2}px;width:calc(100% - ${widthSize2}px);display:inline-block;" data-id="${order.id}">${icon}`
        if (order.shujitsuFlg) {
          s += `<span style="font-weight: ${sfix};color: ${sClr}">終日&nbsp;`
        } else {
          s += `<span style="font-weight: ${sfix};color: ${sClr}">${dayStr1}${startHms}</span> → <span style="font-weight: ${efix};color: ${eClr}">${endHms}`
        }
        s += `【${sanitizer.sanitize(order.sagyoMeisaiBiko ?? '')}】</div>`
      } else {
        if (order.isOnTray === true) {
          s += `<div class="${fontClassName}" style="vertical-align: top;min-width:${widthSize3}px;width:100%;display:inline-block;" data-id="${order.id}">`
          s += `${icon}<span>${sanitizer.sanitize(order.sagyoMeisaiBiko ?? '')} ${dayStr1}</span><!-- <span style="float:right"><input type="checkbox"></span> --></br>`
          if (order.shujitsuFlg) {
            s += `<span style="font-weight: ${sfix};color: ${sClr}">終日&nbsp;`
          } else {
            s += `<span style="font-weight: ${sfix};color: ${sClr}">${startHms}</span> → <span style="font-weight: ${efix};color: ${eClr}">${endHms}`
          }
          s += '</div>'
        } else {
          s += `<div class="${fontClassName}" style="vertical-align: top;min-width:${widthSize3}px;width:calc(100% - ${widthSize3}px);display:inline-block;" data-id="${order.id}">`
          s += `${icon}<span>${sanitizer.sanitize(order.sagyoMeisaiBiko ?? '')} ${dayStr1}</span></br>`
          if (order.shujitsuFlg) {
            s += `<span style="font-weight: ${sfix};color: ${sClr}">終日&nbsp;`
          } else {
            s += `<span style="font-weight: ${sfix};color: ${sClr}">${startHms}</span> → <span style="font-weight: ${efix};color: ${eClr}">${endHms}`
          }
          s += '</div>'
        }
      }

      return s
      // // /* eslint no-debugger: "warn" */
      // // debugger
      // // ドライバーチケットの形はここで共通的に設定できる
      // const fontClassName = this.fontSizeClass()
      // if (this.conditions.line1 && isFromTray === false) {
      //   return `<span class="${fontClassName}">${item.sagyoNo}</span><span class="${fontClassName}">【${item.sagyoTitle}】</span>`
      // } else {
      //   return `<span class="${fontClassName}">${item.sagyoNo}</span><br/><span class="${fontClassName}">${item.sagyoTitle}</span>`
      // }
    },
    drawOrderTicketBeforeModMin: function (orderInfo, index) {
      // 幅はafterで計算する
      return '&nbsp;'
    },
    drawOrderTicketAfterModMin: function (orderInfo, rowindex, columnindex) {
      // DOMができるのを待つ
      this.$nextTick().then(() => {
        // 分の余り分の空白を表示
        var ret = this.getOrderFromTimeIndexAndOrderArray(columnindex, orderInfo)
        const width = this.getMinWidthPx(ret.hatsuchiDayjs, columnindex)
        const fullTime = this.hoursInterval * 60 // 1セルあたりの時間(分)
        const columnindex2 = Math.ceil(ret.chakuchiDayjs.diff(this.tekiyoYmdDayjs, 'minute', false) / fullTime)
        const width2 = this.getMinWidthPx(ret.chakuchiDayjs, columnindex2)

        // console.log('id:' + ret.id, 'hatsuchiHms:' + ret.hatsuchiHms, width, 'rowindex' + rowindex, 'columnindex' + columnindex)

        // ドラッグエリアのサイズを設定
        var xele = document.getElementById('dragOrderArea' + ret.id)
        xele.style.minWidth = '60px'
        if (width.minPx + width2.minModPx !== 0) {
          xele.style.width = 'calc( 100% - ' + (width.minPx + width2.minModPx - 2) + 'px)'
        } else {
          xele.style.width = '100%'
        }

        // 出力場所調整
        if (width.minPx < 3) {
          xele.style.position = ''
          xele.style.left = ''
        } else {
          xele.style.position = 'relative'
          xele.style.left = width.minPx + 'px'
        }
      })
      return '&nbsp;'
    },
    drawOrderTicketAfterModMinonDriver: function (orderInfo, rowindex, columnindex) {
      // DOMができるのを待つ
      this.$nextTick().then(() => {
        // 分の余り分の空白を表示
        var ret = this.getOrderFromTimeIndexAndOrderArray(columnindex, orderInfo)
        const width = this.getMinWidthPx(ret.hatsuchiDayjs, columnindex)
        const fullTime = this.hoursInterval * 60 // 1セルあたりの時間(分)
        const columnindex2 = Math.ceil(ret.chakuchiDayjs.diff(this.tekiyoYmdDayjs, 'minute', false) / fullTime)
        const width2 = this.getMinWidthPx(ret.chakuchiDayjs, columnindex2)

        // console.log('id:' + ret.id, 'hatsuchiHms:' + ret.hatsuchiHms, width, 'rowindex' + rowindex, 'columnindex' + columnindex)

        // ドラッグエリアのサイズを設定
        if (this.viewMode === 0) {
          var key = ret.id
        } else {
          if (ret.isWorks || this.filteredRows2[rowindex].driver.id === ret.mainDriverId) {
            key = ret.id + 'm'
          } else {
            key = ret.id + 's'
          }
        }
        var xele = document.getElementById('dragOrderArea' + key)
        if (!xele) {
          console.log('null element')
        } else {
          if (width.minPx + width2.minModPx !== 0) {
            xele.style.width = 'calc( 100% - ' + (width.minPx + width2.minModPx - 2) + 'px)'
          // } else {
          //   xele.style.width = '100%'
          }
          // 出力場所調整
          if (width.minPx < 3) {
            xele.style.position = ''
            xele.style.left = ''
          } else {
            xele.style.position = 'relative'
            xele.style.left = width.minPx + 'px'
          }
        }
      })
      return '&nbsp;'
    },
    formatYmdAndUser (ymd, user) {
      if (ymd) {
        if (this.conditions.line1) {
          return `【${user}】${ymd.format('YYYY/MM/DD HH:mm')}`
        } else {
          return `${user}<br/>${ymd.format('YYYY/MM/DD HH:mm')}`
        }
      } else {
        return ''
      }
    },
    isEnableJisseki (item) {
      const self = this
      if (item.updateFlg === false && item.orderD && item.orderD.length > 0) {
        if (this.isYousha(item) || (this.isValidDriver(item.driver) && item.jomuinKakuteiFlg)) {
          if (this.isYousha(item) || this.isWorksLine(item.orderD) || !this.isValidDriver(item.subDriver) || item.dojoshaKakuteiFlg) {
            const r = item.orderD.find((e) => {
              // return self.tekiyoYmdDayjs.isSame(e.hatsuchiDayjs, 'd') && e.kakuteiFlg
              return self.tekiyoYmdDayjs.isSame(dayjs(e.sagyoYmd), 'd') && e.kakuteiFlg
            })
            if (r && item.isEqualUnkouYmdAndTekiyoYmd) {
              return true
            }
          }
        }
      }
      return false
    },
    // #endregion
    // #region ドラッギング回り
    checkMoveOrder: function (evt, originalEvent) {
      console.log('check draggable', originalEvent)
      if (this.onStereching) {
        return false
      }
      return true
    },
    checkMoveDr: function (evt, originalEvent) {
      console.log('check draggable', originalEvent)
      if (this.onStereching) {
        return false
      }
      return true
    },
    checkMoveCar: function (evt, originalEvent) {
      console.log('check draggable', originalEvent)
      if (this.onStereching) {
        return false
      }
      return true
    },
    onEndWorksDrag (originalEvent) {
      console.log('WORKS DROPED')
      if (this.viewMode !== 0) {
        return this.onEndWorksDragOnDriverScreen(originalEvent)
      }
      const self = this
      console.log('★onEnd', originalEvent) // originalEventは イベントを取得できる

      // 場所を探る
      var fromPos = this.getPostionTrayOrGrid(originalEvent.from)
      var toPos = this.getPostionTrayOrGrid(originalEvent.to)

      if (fromPos === 'tray' && toPos === 'tray') {
        // トレイ同士の交換は何もしない
        this.redrawWorksTray()
        return
      }
      // 持っていかれたWORKSのID
      var fromID
      if (fromPos === 'tray') {
        fromID = originalEvent.from.dataset.id
        if (fromID === undefined) {
          // なぜか枠を持っていくことがある
          // その場合はcloneをみる
          fromID = originalEvent.clone.dataset.id
        }
      } else {
        fromID = self.getDataIdFromChilds(originalEvent.from)
      }
      var toID
      if (toPos === 'tray') {
        toID = undefined
      } else {
        toID = self.getDataIdFromChilds(originalEvent.to)
      }
      // 持って行った行の車両の配列のindex
      var fromSharyoIndex = this.getDisplayIndexFromElement(originalEvent.from)
      var toSharyoIndex = this.getDisplayIndexFromElement(originalEvent.to)
      if (fromSharyoIndex !== null) {
        var fromDataIndex = this.getCarDataIndexFromLineID(this.filteredRows[fromSharyoIndex].id)
      }
      if (toSharyoIndex !== null) {
        var toDataIndex = this.getCarDataIndexFromLineID(this.filteredRows[toSharyoIndex].id)
      }

      console.log('dragging works from:to', fromPos, toPos)
      console.log('works ticket id from:to', fromID, toID)
      console.log('sharyo id from:to', fromSharyoIndex, toSharyoIndex)
      console.log('DOM Edit before', this.dr, this.filteredRows)

      const fromTicket = this.getOrderFromOrderID(this.saveTicketId)

      if (this.checkKakuteiLine(fromPos, toPos, fromSharyoIndex, toSharyoIndex)) {
        return
      }
      if (toPos === 'grid') {
        // if (fromTicket.startLockFlg === false && fromTicket.endLockFlg === false) {
        // 時間固定でないオーダの場合、ドロップされた時間にチケットの
        // 時間を書き換える
        const toHour = this.getHourGridPos(originalEvent.to)
        if (toHour === null) return
        this.setStartHourWorksTicket(fromTicket, toHour)
        // }
      }

      // tray から grid (空)に
      if (fromPos === 'tray' && toPos === 'grid') {
        console.log('now putted works', this.filteredRows[toSharyoIndex].id)
        // まずはシンプルに入れ込んでみる
        // var hitWork = this.getWorkFromWorkID(fromID)
        this.setOrderOnTray(fromTicket, false)

        this.addToGridFromTrayWork(fromTicket, this.recCar[toDataIndex].id)
      } else if (fromPos === 'grid' && toPos === 'grid') {
        // gridからgridへ
        if (fromSharyoIndex === toSharyoIndex) {
          if (fromTicket.startLockFlg === true || fromTicket.endLockFlg === true) {
            // 同じ行へのD&Dはredrawのみ行う
            this.redrawSharyo1Line(toDataIndex, true)
            return
          } else {
            var putSameLine = true
          }
        } else {
          putSameLine = false
        }
        // var fromTicket = this.getOrderFromOrderID(this.saveTicketId)
        var saveInsertId = this.recCar[toDataIndex].id
        // this.removeWork(fromTicket, this.filteredRows[fromSharyoIndex].id)
        // this.addToGridFromTrayWork(fromTicket, saveInsertId, 1)
        this.returnToTrayWork(fromTicket, this.recCar[fromDataIndex].id, putSameLine)
        if (putSameLine === true) {
          // 同じ行にD&Dの場合に上のreturnTrayOrderで行はreloadされているので
          // 再度idを取得する
          saveInsertId = this.recCar[toDataIndex].id
        }
        this.addToGridFromTrayWork(fromTicket, saveInsertId)
      } else if (fromPos === 'grid' && toPos === 'tray') {
        // fromTicket = this.getOrderFromOrderID(this.saveTicketId)
        // this.removeWork(fromTicket, this.filteredRows[fromSharyoIndex].id)
        this.returnToTrayWork(fromTicket, this.recCar[fromDataIndex].id)

        this.setOrderOnTray(fromTicket, true)
        this.redrawWorksTray()
        this.redrawOrderTray()
        console.log('grid swap ', this.filteredRows, this.order, this.filteredOrders)
      }
    },
    onEndWorksDragOnDriverScreen (originalEvent) {
      console.log('WORKS DROPED')
      const self = this
      console.log('★onEnd', originalEvent) // originalEventは イベントを取得できる

      // 場所を探る
      var fromPos = this.getPostionTrayOrGrid(originalEvent.from)
      var toPos = this.getPostionTrayOrGrid(originalEvent.to)

      if (fromPos === 'tray' && toPos === 'tray') {
        // トレイ同士の交換は何もしない
        this.redrawWorksTray()
        return
      }
      // 持っていかれたWORKSのID
      var fromID
      if (fromPos === 'tray') {
        fromID = originalEvent.from.dataset.id
        if (fromID === undefined) {
          // なぜか枠を持っていくことがある
          // その場合はcloneをみる
          fromID = originalEvent.clone.dataset.id
        }
      } else {
        fromID = self.getDataIdFromChilds(originalEvent.from)
      }
      var toID
      if (toPos === 'tray') {
        toID = undefined
      } else {
        toID = self.getDataIdFromChilds(originalEvent.to)
      }
      // 持って行った行のドライバの配列のindex
      var fromDriverIndex = this.getDisplayIndexFromElement(originalEvent.from)
      var toDriverIndex = this.getDisplayIndexFromElement(originalEvent.to)
      if (fromDriverIndex !== null) {
        var fromDataIndex = this.getDriverDataIndexFromLineID(this.filteredRows2[fromDriverIndex].id)
      }
      if (toDriverIndex !== null) {
        var toDataIndex = this.getDriverDataIndexFromLineID(this.filteredRows2[toDriverIndex].id)
      }

      console.log('dragging works from:to', fromPos, toPos)
      console.log('works ticket id from:to', fromID, toID)
      console.log('sharyo id from:to', fromDriverIndex, toDriverIndex)
      console.log('DOM Edit before', this.dr, this.filteredRows)

      const fromTicket = this.getOrderFromOrderID(this.saveTicketId)
      if (this.checkKakuteiLine(fromPos, toPos, fromDriverIndex, toDriverIndex)) {
        return
      }

      if (toPos === 'grid') {
        // if (fromTicket.startLockFlg === false && fromTicket.endLockFlg === false) {
        // 時間固定でないオーダの場合、ドロップされた時間にチケットの
        // 時間を書き換える
        const toHour = this.getHourGridPos(originalEvent.to)
        if (toHour === null) return
        this.setStartHourWorksTicket(fromTicket, toHour)
        // }
      }
      // tray から grid (空)に
      if (fromPos === 'tray' && toPos === 'grid') {
        console.log('now putted order', this.filteredRows2[toDriverIndex].id)
        // まずはシンプルに入れ込んでみる
        // var hitWork = this.getWorkFromWorkID(fromID)
        this.setOrderOnTray(fromTicket, false)

        this.addToGridFromTrayWork(fromTicket, this.recDriver[toDataIndex].id)
      } else if (fromPos === 'grid' && toPos === 'grid') {
        // gridからgridへ
        if (fromDriverIndex === toDriverIndex) {
          if (fromTicket.startLockFlg === true || fromTicket.endLockFlg === true) {
            // 同じ行へのD&Dはredrawのみ行う
            this.redrawDriver1Line(toDriverIndex)
            return
          } else {
            var putSameLine = true
          }
        } else {
          putSameLine = false
        }
        // var fromTicket = this.getOrderFromOrderID(this.saveTicketId)
        var saveInsertId = this.recDriver[toDataIndex].id
        // this.removeWork(fromTicket, this.filteredRows2[fromDriverIndex].id)
        this.returnToTrayWork(fromTicket, this.recDriver[fromDataIndex].id, putSameLine)
        if (putSameLine === true) {
          // 同じ行にD&Dの場合に上のreturnTrayOrderで行はreloadされているので
          // 再度idを取得する
          saveInsertId = this.filteredRows2[toDriverIndex].id
        }
        this.addToGridFromTrayWork(fromTicket, saveInsertId)
      } else if (fromPos === 'grid' && toPos === 'tray') {
        // fromTicket = this.getOrderFromOrderID(this.saveTicketId)
        // this.removeWork(fromTicket, this.filteredRows2[fromDriverIndex].id)
        this.returnToTrayWork(fromTicket, this.filteredRows2[fromDriverIndex].id)

        this.setOrderOnTray(fromTicket, true)
        this.redrawWorksTray()
      }
    },
    onEndOrderDragOnDriverScreen: function (originalEvent) {
      // オーダーのD&Dは乗務員別画面では使えない
      return this.onEndWorksDragOnDriverScreen(originalEvent)
    },
    onEndOrderDragOnCarScreen: function (originalEvent) {
      const self = this
      console.log('★onEnd', originalEvent) // originalEventは イベントを取得できる
      // 場所を探る
      var fromPos = this.getPostionTrayOrGrid(originalEvent.from)
      var toPos = this.getPostionTrayOrGrid(originalEvent.to)

      console.log('dragging driver from:to', fromPos, toPos)

      if (fromPos === 'tray' && toPos === 'tray') {
        // トレイ同士の交換は何もしない
        this.redrawOrderTray()
        return
      }
      // 持っていかれたオーダのチケットのID
      var fromID
      if (fromPos === 'tray') {
        fromID = originalEvent.from.dataset.id
      } else {
        fromID = self.getDataIdFromChilds(originalEvent.from)
      }
      var toID
      if (toPos === 'tray') {
        toID = undefined
      } else {
        toID = self.getDataIdFromChilds(originalEvent.to)
      }

      // 持って行った行の車両の配列のindex
      var fromSharyoIndex = this.getDisplayIndexFromElement(originalEvent.from)
      var toSharyoIndex = this.getDisplayIndexFromElement(originalEvent.to)
      if (fromSharyoIndex !== null) {
        var fromDataIndex = this.getCarDataIndexFromLineID(this.filteredRows[fromSharyoIndex].id)
      }
      if (toSharyoIndex !== null) {
        var toDataIndex = this.getCarDataIndexFromLineID(this.filteredRows[toSharyoIndex].id)
      }
      console.log('dragging order from:to', fromPos, toPos)
      console.log('order ticket id saveFrom:from:to', this.saveTicketId, fromID, toID)
      console.log('sharyo id from:to', fromSharyoIndex, toSharyoIndex)
      console.log('DOM Edit before', this.dr, this.filteredRows)

      const fromTicket = this.getOrderFromOrderID(this.saveTicketId)
      // -------------------- workのチケットの場合はワークドラッグ処理へ
      if (fromTicket.isWork) {
        return this.onEndWorksDrag(originalEvent)
      }
      if (this.checkKakuteiLine(fromPos, toPos, fromSharyoIndex, toSharyoIndex)) {
        return
      }
      if (toPos === 'grid') {
        // 時間固定でも日付はドロップした場所の日付に書き換える
        // if (fromTicket.startLockFlg === false && fromTicket.endLockFlg === false) {
        // 時間固定でないオーダの場合、ドロップされた時間にチケットの
        // 時間を書き換える
        const toHour = this.getHourGridPos(originalEvent.to)
        if (toHour === null) return
        this.setStartHourOrderTicket(fromTicket, toHour)
        // }
      }

      // tray から grid (空)に
      if (fromPos === 'tray' && toPos === 'grid') {
        this.setOrderOnTray(fromTicket, false)
        this.addToGridFromTrayOrder(fromTicket, this.recCar[toDataIndex].id)
      } else if (fromPos === 'grid' && toPos === 'grid') {
        // gridからgridへ
        console.log('now getted order', this.filteredRows[fromSharyoIndex].id)
        console.log('now putted order', this.filteredRows[toSharyoIndex].id)
        if (fromSharyoIndex === toSharyoIndex) {
          if (fromTicket.startLockFlg === true || fromTicket.endLockFlg === true) {
            // 同じ行へのD&Dはredrawのみ行う
            this.redrawSharyo1Line(toSharyoIndex)
            return
          } else {
            var putSameLine = true
          }
        } else {
          putSameLine = false
        }
        // fromTicket = this.getOrderFromOrderID(this.saveTicketId)
        var saveInsertId = this.recCar[toDataIndex].id
        console.log('moved order ticket info', fromTicket)
        // 便宜的にトレイに戻す
        this.returnToTrayOrder(fromTicket, this.recCar[fromDataIndex].id, putSameLine)
        if (putSameLine === true) {
          // 同じ行にD&Dの場合に上のreturnTrayOrderで行はreloadされているので
          // 再度idを取得する
          saveInsertId = this.recCar[toDataIndex].id
        }
        this.addToGridFromTrayOrder(fromTicket, saveInsertId)
      } else if (fromPos === 'grid' && toPos === 'tray') {
        this.returnToTrayOrder(fromTicket, this.recCar[fromDataIndex].id)

        this.setOrderOnTray(fromTicket, true)
        this.redrawOrderTray()
        this.redrawWorksTray()
        console.log('grid swap ', this.filteredRows, this.order, this.filteredOrders)
      }
    },
    /**
     * 確定チェックがされているかを調べる
     */
    checkKakuteiLine (fromPos, toPos, fromIndex, toIndex) {
      var checkFlg = false
      if (this.viewMode === 0) {
        if (fromPos === 'grid') {
          if (this.filteredRows[fromIndex].keikakuKakuteiFlg) {
            checkFlg = true
            this.redrawSharyo1Line(fromIndex)
          }
        }
        if (toPos === 'grid') {
          if (this.filteredRows[toIndex].keikakuKakuteiFlg) {
            if (!checkFlg) {
              checkFlg = true
              if (toIndex === fromIndex) {
                return checkFlg
              }
            }
            this.redrawSharyo1Line(toIndex)
          }
        }
      } else {
        if (fromPos === 'grid') {
          if (this.filteredRows2[fromIndex].keikakuKakuteiFlg) {
            checkFlg = true
            this.redrawDriver1Line(fromIndex)
          }
        }
        if (toPos === 'grid') {
          if (this.filteredRows2[toIndex].keikakuKakuteiFlg) {
            if (!checkFlg) {
              checkFlg = true
              if (toIndex === fromIndex) {
                return checkFlg
              }
            }
            this.redrawDriver1Line(toIndex)
          }
        }
      }
      return checkFlg
    },
    onChoose: function (originalEvent) {
      // const self = this
      console.log('★onCoose', originalEvent) // originalEventは イベントを取得できる
      var fromPos = this.getPostionTrayOrGrid(originalEvent.from)
      if (fromPos === 'tray') {
        // this.saveTicketId = originalEvent.from.dataset.id
        this.saveTicketId = this.getDataIdFromChilds(originalEvent.from)
      } else {
        // this.saveTicketId = this.getDataIdFromChilds(originalEvent.from)
        this.saveTicketId = originalEvent.from.dataset.id
      }
      console.log('★onCoose saved from ticket', this.saveTicketId) // originalEventは イベントを取得できる
    },
    onEndDriverDrag: function (originalEvent) {
      const self = this
      var copyMode = this.isCopyMode
      console.log('★onEnd', originalEvent) // originalEventは イベントを取得できる
      if (originalEvent.originalEvent.ctrlKey) {
        copyMode = true
      }

      // 場所を探る
      var fromPos = this.getPostionTrayOrGrid(originalEvent.from)
      var toPos = this.getPostionTrayOrGrid(originalEvent.to)

      if (fromPos === 'tray' && toPos === 'tray') {
        // トレイ同士の交換は何もしない
        this.redrawDriverTray()
        return
      }
      var toType = null
      var fromType = null
      if (toPos === 'grid') {
        toType = this.getDriverType(originalEvent.to)
      }
      if (fromPos === 'grid') {
        fromType = this.getDriverType(originalEvent.from)
      }
      // 持っていかれた人員のチケットのID
      var fromID
      if (fromPos === 'tray') {
        fromID = originalEvent.from.dataset.id
        if (fromID === undefined) {
          // なぜか枠を持っていくことがある
          // その場合はcloneをみる
          fromID = originalEvent.clone.dataset.id
        }
      } else {
        fromID = self.getDataIdFromChilds(originalEvent.from)
      }
      var toID
      if (toPos === 'tray') {
        toID = undefined
      } else {
        toID = self.getDataIdFromChilds(originalEvent.to)
      }
      // 持って行った行の車両の配列のindex
      var fromSharyoIndex = this.getDisplayIndexFromElement(originalEvent.from)
      var toSharyoIndex = this.getDisplayIndexFromElement(originalEvent.to)

      // 確定している乗務員は強制コピーモードとする
      if (fromPos === 'grid') {
        if (fromType === 'main') {
          if (this.filteredRows[fromSharyoIndex].jomuinKakuteiFlg) {
            copyMode = true
          }
        } else if (fromType === 'sub') {
          if (this.filteredRows[fromSharyoIndex].dojoshaKakuteiFlg) {
            copyMode = true
          }
        }
      }
      if (this.checkKakuteiLine(fromPos, toPos, fromSharyoIndex, toSharyoIndex)) {
        return
      }
      console.log('dragging driver from:to', fromPos, toPos)
      console.log('sharyo ticket id from:to', fromID, toID)
      console.log('sharyo id from:to', fromSharyoIndex, toSharyoIndex)
      console.log('DOM Edit before', this.dr, this.filteredRows)

      // tray から grid (空)に
      if (fromPos === 'tray' && toPos === 'grid') {
        console.log('now putted jomuin', this.filteredRows[toSharyoIndex].id)

        var hitDr2 = this.getDriverFromDriverID(fromID)

        this.addToGridFromTrayDriver(hitDr2, self.filteredRows[toSharyoIndex].id, copyMode, toType)
        this.redrawDriverTray()

        console.log('DOM Edited dr is', this.dr, this.filteredRows, this.recCar)
      } else if (fromPos === 'grid' && toPos === 'grid') {
        if (toSharyoIndex === fromSharyoIndex && fromType === toType) {
          // 同じ行の場合は何もしない
          return
        }
        if (!((toType === 'main' && this.isValidDriver(this.filteredRows[toSharyoIndex].driver)) ||
              (toType === 'sub' && this.isValidDriver(this.filteredRows[toSharyoIndex].subDriver)))) {
          // 先の乗務員が空の時
          // trayの検索
          var hitDrv = this.getDriverFromDriverID(toID)
          var toRowId = self.filteredRows[toSharyoIndex].id
          // var displayDriver = fromType === 'main' ? this.filteredRows[fromSharyoIndex].driver : this.filteredRows[fromSharyoIndex].subDriver

          if (!copyMode) {
            // if (displayDriver.masterFlg) {
            // if (this.isMasterDriverThisDriver(displayDriver) === 1) {
            //   // 便宜的にfromのドライバをトレイに戻す
            //   this.returnToTrayDriver(self.filteredRows[fromSharyoIndex].id, fromType, true, toRowId)
            // } else {
            //   if (fromType === 'main') {
            //     this.filteredRows[fromSharyoIndex].driver = {}
            //   } else {
            //     this.filteredRows[fromSharyoIndex].subDriver = {}
            //   }
            //   this.redrawSharyo1Line(fromSharyoIndex)
            // }
            this.returnToTrayDriver(self.filteredRows[fromSharyoIndex].id, fromType, true, toRowId)
          } else {
            // ドラッグで消えたチケットを書き直す
            this.redrawSharyo1Line(fromSharyoIndex)
          }
          toRowId = self.filteredRows[toSharyoIndex].id
          // その後追加
          this.addToGridFromTrayDriver(hitDrv, toRowId, copyMode, toType)
          this.setDriverOnTray(hitDrv, false)
          // this.filteredRows[toSharyoIndex].driver = hitDrv
          // this.filteredRows[fromSharyoIndex].driver = {}

          // this.redrawSharyo2Line(fromSharyoIndex, toSharyoIndex)

          console.log('DOM Edited dr is', this.dr, this.filteredRows)
        } else {
          var hitDrv2
          if (fromType === 'main') {
            hitDrv2 = this.getDriverFromDriverID(self.filteredRows[fromSharyoIndex].driver.id)
          } else {
            hitDrv2 = this.getDriverFromDriverID(self.filteredRows[fromSharyoIndex].subDriver.id)
          }
          // var hitDrv3 = this.getDriverFromID(self.filteredRows[toSharyoIndex].driver.id)
          var toRowId2 = self.filteredRows[toSharyoIndex].id
          // swap するのではなく先の行を一つ増やす
          if (!copyMode) {
            // 便宜的にfromのドライバをトレイに戻す
            if (fromSharyoIndex === toSharyoIndex) {
              this.returnToTrayDriver(self.filteredRows[fromSharyoIndex].id, fromType, true)
              toRowId2 = self.filteredRows[toSharyoIndex].id
            } else {
              this.returnToTrayDriver(self.filteredRows[fromSharyoIndex].id, fromType, false, toRowId2)
            }
          }
          // その後追加
          this.addToGridFromTrayDriver(hitDrv2, toRowId2, false, toType)
          this.setDriverOnTray(hitDrv2, false)
        }
        this.redrawDriverTray()
      } else if (fromPos === 'grid' && toPos === 'tray') {
        // gridからtrayに戻されたとき
        // if (!copyMode) {
        this.returnToTrayDriver(self.filteredRows[fromSharyoIndex].id, fromType)
        // } else {
        //   this.redrawSharyo1Line(fromSharyoIndex)
        // }
        // var hitDrx = this.keikakuJininList.find(function (elem) {
        //   return (fromType === 'main' && elem.id === self.filteredRows[fromSharyoIndex].driver.id) || (fromType === 'sub' && elem.id === self.filteredRows[fromSharyoIndex].subDriver.id)
        // })
        // self.filteredRows[fromSharyoIndex].driver = {}
        // hitDrx.isOnTray = true
        // this.filteredRows.splice(0, 0)
        // if (copyMode) {
        //   this.setDriverOnTray(hitDrx, true)
        // }
        this.redrawDriverTray()
      }
    },
    onEndCarDrag: function (originalEvent) {
      // 車両のD＆Dはなくなったので、使われない
    },
    // #endregion
    // #region DOM操作関連
    getDataIdFromChilds: function (node) {
      const self = this
      if (typeof node === 'undefined') {
        return undefined
      }
      if (typeof node.dataset !== 'undefined') {
        if (typeof node.dataset.id !== 'undefined') {
          return node.dataset.id
        }
      }
      var n = node.getElementsByTagName('div')
      if (n === undefined) {
        return undefined
      }
      const len = n.length
      for (let i = 0; i < len; i++) {
        console.log('Text: ' + n.item(i).textContent)
        const ret = self.getDataIdFromChilds(n[i])
        if (ret !== undefined) {
          return ret
        }
      }
      return undefined
    },
    getOrderIDFromClickedElement (ele) {
      if (ele.dataset && ele.dataset.id) {
        return ele.dataset.id
      }
      var pele = ele.closest('div')
      if (pele.dataset && pele.dataset.id) {
        return pele.dataset.id
      }
      return undefined
    },
    /**
     * 指定したエレメントがグリッドかトレイかを判別する
     * (トレイはsectionタグで囲むようにしたが他で囲んでもいいかも)
     * @param {} elem エレメント
     * @returns 'tray' or 'grid'
     */
    getPostionTrayOrGrid (elem) {
      var pos
      pos = elem.closest('tr')
      if (!pos) {
        pos = elem.closest('section')
      }
      return pos.dataset.position
    },
    /**
     * TRタグに書いてあるはずの、行番号（filteredRowsかfiltersRow2の）を取得する
     * @param {} elem エレメント
     * @returns 行番号(たぶんstring)
     **/
    getDisplayIndexFromElement (elem) {
      var pos
      pos = elem.closest('tr')
      if (pos) {
        if (pos.dataset) {
          if (pos.dataset.id) {
            return pos.dataset.id
          }
        }
      }
      return null
    },
    getHourGridPos (elem) {
      var pos
      pos = elem.closest('td')
      if (pos) {
        if (pos.dataset) {
          if (pos.dataset.hour) {
            return Number(pos.dataset.hour)
          }
        }
      }
      return null
    },
    getDriverType (elem) {
      var pos
      pos = elem.closest('td')
      if (pos) {
        if (pos.dataset) {
          if (pos.dataset.driver) {
            return pos.dataset.driver
          }
        }
      }
      return null
    },
    // #endregion
    // #region オーダ詳細ダイアログ関連
    onAddOrderButtonClick: function (e, rowId = -1, stDate = null) {
      // const today = dayjs()
      // if (stDate === null) {
      //   stDate = this.tekiyoYmdDayjs
      // }
      const odate = (stDate ?? (this.tekiyoYmdDayjs.date() ? this.tekiyoYmdDayjs : dayjs())).format('YYYY/MM/DD')
      var ticket = {
        id: 'NEW',
        hatsuchiYmd: odate,
        hatsuchiHms: (stDate !== null ? stDate.format('HH:mm') : ''),
        uriageBunruiSbt: this.conditions.haishaShashuSbt
      }

      this.orderDialogTekiyoYmd = (this.tekiyoYmdDayjs.date() ? this.tekiyoYmdDayjs : dayjs()).format('YYYY/MM/DD')
      this.isNotOrderNew = false
      this.recOrderInfo = Object.assign({}, ticket)
      this.orderTicketReadOnlyMode = false
      this.isRequiredHms = false
      this.orderTicketEditDialog = true
      this.editingGridRowIndex = rowId
    },
    onOrderTicketOpenButtonClick: function (item, boxFlag = undefined) {
      var ticketid
      this.isNotOrderNew = true
      if (boxFlag === true) {
        ticketid = item
      } else {
        console.log('click!', item)
        ticketid = this.getOrderIDFromClickedElement(item.srcElement)
        if (ticketid === undefined) {
          console.log('id not fond!', item)
          return
        }
      }
      var ticket = this.getOrderFromOrderID(ticketid)
      if (ticket.isWork) {
        return this.onSagyoTicketOpenButtonClick(item, boxFlag)
      }
      this.recOrderInfo = Object.assign({}, ticket)
      if (this.viewMode === 0) {
        this.editingGridRowIndex = this.getCarDisplayIndexFromOrderID(ticketid)
        if (this.isReadonlyKengen || (this.editingGridRowIndex !== -1 && (this.filteredRows[this.editingGridRowIndex].keikakuKakuteiFlg || ticket.kakuteiFlg))) {
          this.orderTicketReadOnlyMode = true
        } else {
          this.orderTicketReadOnlyMode = false
        }
      } else {
        this.editingGridRowIndex = this.getDriverDisplayIndexFromOrderID(ticketid)
        this.orderTicketReadOnlyMode = true
      }
      if (this.editingGridRowIndex === -1) {
        this.isRequiredHms = false
      } else {
        this.isRequiredHms = true
      }
      this.orderDialogTekiyoYmd = this.tekiyoYmdDayjs.format('YYYY/MM/DD')
      this.orderTicketEditDialog = true
    },
    onOrderTicketCloseButtonClick: function () {
      this.orderTicketEditDialog = false
      this.setEnableViewScroll(false)
    },
    onOrderTicketSaveButtonClick: function (e) {
      // const self = this
      console.log('dialog param value', e)
      this.recOrderInfo = e
      console.log('dialog return value before', this.recOrderInfo, this.editingGridRowIndex)
      if (this.recOrderInfo.id === 'NEW') {
        // 採番
        this.recOrderInfo.id = this.getNewOrderId()
      }
      // 初期表示時の追加はチケットを表示しない
      if (this.useSearchOnLoad === false && this.afterSearch === false) {
        var retTicket = {}
        if (this.isNotOrderNew) {
          retTicket = this.getOrderFromOrderID(this.recOrderInfo.id)
          this.copyTicketInfo(this.recOrderInfo, retTicket)
        } else {
          this.copyTicketInfo(this.recOrderInfo, retTicket)
          this.keikakuSagyoMeisai.push(retTicket)
        }
        return
      }
      console.log('dialog param value', this.isNotOrderNew)
      this.isNotOrderNew = !this.recOrderInfo.newEditMode
      var ticket
      if (!this.isNotOrderNew) {
        var newTicket = {}
        this.recOrderInfo.isWork = false
        this.copyTicketInfo(this.recOrderInfo, newTicket)
        if (this.editingGridRowIndex !== -1) {
          newTicket.isOnTray = false
          this.setStartHourOrderTicket(newTicket, 0)
          var fromIndex = this.getCarDataIndexFromLineID(this.filteredRows[this.editingGridRowIndex].id)
          const saveId = this.recCar[fromIndex].id
          this.recCar[fromIndex].orderD.push(newTicket)
          if (this.recCar[fromIndex].isEqualUnkouYmdAndTekiyoYmd === null) {
            this.recCar[fromIndex].isEqualUnkouYmdAndTekiyoYmd = this.tekiyoYmdDayjs.isSame(dayjs(newTicket.sagyoYmd), 'd')
          }
          ticket = newTicket
          this.setUpdateFlg(fromIndex, USE_DATAINDEX)
          // orderDにpushしたところでsortが起こるのでindexを探しなおす
          for (fromIndex = 0; fromIndex < this.filteredRows.length; fromIndex++) {
            if (this.filteredRows[fromIndex].id === saveId) {
              break
            }
          }
          this.editingGridRowIndex = fromIndex
        }
        this.keikakuSagyoMeisai.push(newTicket)
      } else {
        ticket = this.getOrderFromOrderID(this.recOrderInfo.id)
        if (this.editingGridRowIndex !== -1) {
          fromIndex = this.getCarDataIndexFromLineID(this.filteredRows[this.editingGridRowIndex].id)
          this.setUpdateFlg(fromIndex, USE_DATAINDEX)
        }
        this.copyTicketInfo(this.recOrderInfo, ticket)
      }
      // ticket.updateFlg = true
      if (this.editingGridRowIndex !== -1) {
        // 安全のため、hmsが空にされたら値を入れておく
        this.fixHms(ticket)
        // 時間が長くなったことによって他のorderにかぶったらそれはトレイに戻す
        this.changeTimeOrderTicketSharyo(ticket, this.editingGridRowIndex)
      }
      // this.onOrderTicketCloseButtonClick()
    },
    onOrderTicketDeleteButtonClick: function (e) {
      console.log('dialog param value', e)
      this.orderTicketEditDialog = false
      const order = this.getOrderFromOrderID(e.id)
      order.delFlg = true
      this.deselectAll()
      if (this.editingGridRowIndex !== -1) {
        this.returnToTrayOrder(order, this.filteredRows[this.editingGridRowIndex].id)
        // this.redrawSharyo1Line(this.editingGridRowIndex)
      } else {
        this.redrawOrderTray()
      }
      this.recOrderInfo = e
    },
    validatePrivate: function (ref) {
      if (ref[this.Ctrls.VALIDATE_METHOD] === undefined) { return }
      if (ref[this.Ctrls.GET_INVALID_METHOD] === undefined) { return }
      ref[this.Ctrls.VALIDATE_METHOD]()
      var res = ref[this.Ctrls.GET_INVALID_METHOD]()
      return res === undefined
    },
    // #endregion
    // #region 作業ダイアログ関連
    onAddSagyoButtonClick: function (e, rowId = -1, stDate = null) {
      // // const today = dayjs()
      // if (stDate === null) {
      //   stDate = this.tekiyoYmdDayjs
      // }
      const odate = (stDate ?? (this.tekiyoYmdDayjs.date() ? this.tekiyoYmdDayjs : dayjs())).format('YYYY/MM/DD')
      var ticket = {
        id: 'NEW',
        startYmd: odate,
        startHms: (stDate !== null ? stDate.format('HH:mm') : '')
      }

      this.orderDialogTekiyoYmd = (this.tekiyoYmdDayjs.date() ? this.tekiyoYmdDayjs : dayjs()).format('YYYY/MM/DD')
      this.isNotOrderNew = false
      this.recOrderInfo = Object.assign({}, ticket)
      this.sagyoTicketReadOnlyMode = false
      this.isRequiredHms = false
      this.sagyoTicketEditDialog = true
      this.editingGridRowIndex = rowId
    },
    onSagyoTicketOpenButtonClick: function (item, boxFlag = undefined) {
      var ticketid
      this.isNotOrderNew = true
      if (boxFlag === true) {
        ticketid = item
      } else {
        console.log('click!', item)
        ticketid = this.getOrderIDFromClickedElement(item.srcElement)
        if (ticketid === undefined) {
          console.log('id not fond!', item)
          return
        }
      }
      var ticket = this.getOrderFromOrderID(ticketid)
      // if (ticket.isWork) {
      //   return this.onSagyoTicketOpenButtonClick(ticket)
      // }
      this.recOrderInfo = Object.assign({}, ticket)
      if (this.viewMode === 0) {
        this.editingGridRowIndex = this.getCarDisplayIndexFromOrderID(ticketid)
        if (this.isReadonlyKengen || (this.editingGridRowIndex !== -1 && this.filteredRows[this.editingGridRowIndex].keikakuKakuteiFlg)) {
          this.sagyoTicketReadOnlyMode = true
        } else {
          this.sagyoTicketReadOnlyMode = false
        }
      } else {
        this.editingGridRowIndex = this.getDriverDisplayIndexFromOrderID(ticketid)
        if (this.isReadonlyKengen || (this.editingGridRowIndex !== -1 && this.filteredRows2[this.editingGridRowIndex].keikakuKakuteiFlg)) {
          this.sagyoTicketReadOnlyMode = true
        } else {
          this.sagyoTicketReadOnlyMode = false
        }
      }
      if (this.editingGridRowIndex === -1) {
        this.isRequiredHms = false
      } else {
        this.isRequiredHms = true
      }
      this.orderDialogTekiyoYmd = this.tekiyoYmdDayjs.format('YYYY/MM/DD')
      this.sagyoTicketEditDialog = true
    },
    onSagyoTicketCloseButtonClick: function () {
      this.sagyoTicketEditDialog = false
    },
    onSagyoTicketSaveButtonClick: function (e) {
      this.sagyoTicketEditDialog = false
      this.recOrderInfo = e
      this.recOrderInfo.isWork = true
      console.log('dialog return value before', this.recOrderInfo, this.editingGridRowIndex)
      if (this.recOrderInfo.id === 'NEW') {
        // 採番
        this.recOrderInfo.id = this.getNewOrderId()
      }
      // 初期表示時の追加はチケットを表示しない
      if (this.useSearchOnLoad === false && this.afterSearch === false) {
        var retTicket = {}
        if (this.isNotOrderNew) {
          retTicket = this.getWorkFromWorkID(this.recOrderInfo.id)
          this.copyTicketInfo(this.recOrderInfo, retTicket)
        } else {
          this.copyTicketInfo(this.recOrderInfo, retTicket)
          this.keikakuSagyoMeisai2.push(retTicket)
        }
        return
      }
      var ticket
      if (!this.isNotOrderNew) {
        var newTicket = {}
        this.copyTicketInfo(this.recOrderInfo, newTicket)
        if (this.editingGridRowIndex !== -1) {
          newTicket.isOnTray = false
          this.setStartHourWorksTicket(newTicket, 0)
          if (this.viewMode === 0) {
            var fromIndex = this.getCarDataIndexFromLineID(this.filteredRows[this.editingGridRowIndex].id)
            // 202204111 受注の行で作業作った場合は、作業を探すか、なかったら新しい作業の行を作る
            if (this.recCar[fromIndex].orderD.length > 0 && !this.isWorksLine(this.recCar[fromIndex].orderD)) {
              fromIndex = this.searchSameLineOfWorksOnSharyo(fromIndex, newTicket)
              var saveId = this.recCar[fromIndex].id
            } else {
              saveId = this.recCar[fromIndex].id
              if (this.isMasterDriverThisPostion(this.recCar[fromIndex], 'sub')) {
                this.setDriverOnTray(this.recCar[fromIndex].subDriver, true)
              }
              this.recCar[fromIndex].subDriver = null
            }
            this.recCar[fromIndex].orderD.push(newTicket)
            if (this.recCar[fromIndex].isEqualUnkouYmdAndTekiyoYmd === null) {
              this.recCar[fromIndex].isEqualUnkouYmdAndTekiyoYmd = this.tekiyoYmdDayjs.isSame(dayjs(newTicket.sagyoYmd), 'd')
            }
            // orderDにpushしたところでsortが起こるのでindexを探しなおす
            for (fromIndex = 0; fromIndex < this.filteredRows.length; fromIndex++) {
              if (this.filteredRows[fromIndex].id === saveId) {
                break
              }
            }
            this.editingGridRowIndex = fromIndex
          } else {
            fromIndex = this.getDriverDataIndexFromLineID(this.filteredRows2[this.editingGridRowIndex].id)
            const saveId = this.recDriver[fromIndex].id
            this.recDriver[fromIndex].orderD.push(newTicket)
            if (this.recDriver[fromIndex].isEqualUnkouYmdAndTekiyoYmd === null) {
              this.recDriver[fromIndex].isEqualUnkouYmdAndTekiyoYmd = this.tekiyoYmdDayjs.isSame(dayjs(newTicket.sagyoYmd), 'd')
            }
            // orderDにpushしたところでsortが起こるのでindexを探しなおす
            for (fromIndex = 0; fromIndex < this.filteredRows2.length; fromIndex++) {
              if (this.filteredRows2[fromIndex].id === saveId) {
                break
              }
            }
            this.editingGridRowIndex = fromIndex
          }
          this.setUpdateFlg(fromIndex, USE_DATAINDEX)
          ticket = newTicket
        }
        this.keikakuSagyoMeisai2.push(newTicket)
      } else {
        if (this.editingGridRowIndex !== -1) {
          if (this.viewMode === 0) {
            fromIndex = this.getCarDataIndexFromLineID(this.filteredRows[this.editingGridRowIndex].id)
          } else {
            fromIndex = this.getDriverDataIndexFromLineID(this.filteredRows2[this.editingGridRowIndex].id)
          }
          this.setUpdateFlg(fromIndex, USE_DATAINDEX)
        }
        ticket = this.getWorkFromWorkID(this.recOrderInfo.id)
        this.copyTicketInfo(this.recOrderInfo, ticket)
      }

      if (this.editingGridRowIndex !== -1) {
        // 安全のため、hmsが空にされたら値を入れておく
        this.fixHms(ticket)
        // 時間が長くなったことによって他のorderにかぶったらそれはトレイに戻す
        if (this.viewMode === 0) {
          this.changeTimeOrderTicketSharyo(ticket, this.editingGridRowIndex)
        } else {
          this.changeTimeOrderTicketDriver(ticket, this.editingGridRowIndex)
        }
      }
    },
    onSagyoTicketDeleteButtonClick: function (e) {
      this.sagyoTicketEditDialog = false
      const order = this.getWorkFromWorkID(e.id)
      order.delFlg = true
      this.deselectAll()
      if (this.editingGridRowIndex !== -1) {
        this.returnToTrayWork(order, this.filteredRows[this.editingGridRowIndex].id)
        // this.redrawSharyo1Line(this.editingGridRowIndex)
      } else {
        this.redrawWorksTray()
      }
      this.recOrderInfo = e
    },
    // #region 作業ダイアログ関連
    // #region vuetify用強制redrawなど
    redrawSharyo1Line: function (lineIndex, orig = false) {
      // 行書き直し
      console.log('redraw sharyo 1 line', lineIndex, this.recCar)
      var copy
      var saveId

      if (orig) {
        copy = Object.assign({}, this.recCar[lineIndex])
        saveId = this.recCar[lineIndex].id
      } else {
        copy = Object.assign({}, this.filteredRows[lineIndex])
        saveId = this.filteredRows[lineIndex].id
      }
      copy.id = this.getNewLineIdCar()
      console.log('new line insert DOM builded')
      const idx = this.getCarDataIndexFromLineID(saveId)
      this.recCar.splice(idx, 1, copy)
      // this.filteredRows.splice(0, 0)
      console.log('old line delete')

      return copy.id
    },
    redrawDriver1Line: function (lineIndex, orig = false) {
      // 行書き直し
      console.log('redraw sdriver 1 line', lineIndex, this.recDriver)
      var copy
      var saveId

      if (orig) {
        copy = Object.assign({}, this.recDriver[lineIndex])
        saveId = this.recDriver[lineIndex].id
      } else {
        copy = Object.assign({}, this.filteredRows2[lineIndex])
        saveId = this.filteredRows2[lineIndex].id
      }
      copy.id = this.getNewLineIdDriver()
      // const saveId = this.filteredRows[lineIndex].id
      // this.filteredRows.splice(lineIndex, 0, copy)
      // this.recDriver.splice(0, 0, copy)
      // this.$nextTick().then(() => {
      //   const idx = this.getDriverDataIndexFromLineID(saveId)
      //   this.recDriver.splice(idx, 1)
      //   // this.filteredRows.splice(0, 0)
      // })
      const idx = this.getDriverDataIndexFromLineID(saveId)
      this.recDriver.splice(idx, 1, copy)
      return copy.id
    },
    redrawOrderTray () {
      console.log('redraw owder')
      this.orderRedrawFlag = false
      this.keikakuSagyoMeisai = [...this.keikakuSagyoMeisai]
      this.$nextTick().then(() => {
        // すきまに入ったorderを消す
        var ordertray = document.getElementById('ORDERTRAY')
        if (ordertray) {
          const elementsToRemove = ordertray.getElementsByClassName('handle')
          // 'handle' クラスを持つ要素がなくなるまでループ
          while (elementsToRemove.length > 0) {
            // 常にコレクションの先頭要素を、その親ノードから削除する
            elementsToRemove[0].parentNode.removeChild(elementsToRemove[0])
          }
        }
        this.orderRedrawFlag = true
      })
    },
    redrawDriverTray () {
      console.log('redraw driver')
      this.driverRedrawFlag = false
      this.$nextTick().then(() => {
        this.driverRedrawFlag = true
      })
    },
    redrawCarTray () {
      console.log('redraw car')
      this.carRedrawFlag = false
      this.$nextTick().then(() => {
        this.carRedrawFlag = true
      })
    },
    redrawWorksTray () {
      console.log('redraw works')
      this.worksRedrawFlag = false
      this.$nextTick().then(() => {
        // すきまに入ったorderを消す
        var ordertray = document.getElementById('WORKSTRAY')
        if (ordertray) {
          const strs = ordertray.getElementsByClassName('handle')
          if (strs) {
            strs.forEach(function (e) {
              console.log('erase noneed ticket')
              ordertray.removeChild(e)
            })
          }
        }
        // filteredOrdersが再計算されないのの対処
        var t = []
        t = t.concat(this.keikakuSagyoMeisai2)
        this.keikakuSagyoMeisai2 = t
        this.worksRedrawFlag = true
      })
    },
    // #endregion
    // #region 伸び縮み関連
    onMouseDown4Strech: function (item) {
      this.onStereching = true
      this.calcWidthTable()
      window.addEventListener('mousemove', this.onMouseMove4Strech)
      window.addEventListener('mouseup', this.onMouseUp4Strech)
      this.makeCloneOrder(item)
    },
    onMouseDown4Strech2: function (item) {
      this.onStereching = true
      this.calcWidthTable()
      window.addEventListener('mousemove', this.onMouseMove4Strech2)
      window.addEventListener('mouseup', this.onMouseUp4Strech2)
      this.makeCloneOrder(item)
    },
    makeCloneOrder: function (item) {
      console.log(' mouse down ', item)
      var rect
      const relPos = this.getRelaitivePosition()
      var navHeight = relPos.relTop
      var navWidth = relPos.relLeft

      const copyfrom = item.srcElement.closest('.mi')
      const cloned = copyfrom.cloneNode(true)
      rect = copyfrom.getBoundingClientRect()

      console.log('copy!', copyfrom.style, cloned, rect)
      var element = document.getElementById('dummy')
      cloned.style.position = 'absolute'
      cloned.style.top = (rect.top - navHeight) + 'px'
      cloned.style.top = (rect.top + document.documentElement.scrollTop - navHeight) + 'px'
      // cloned.style.bottom = (rect.bottom - hdRect.height) + 'px'
      cloned.style.left = (rect.left + document.documentElement.scrollLeft - navWidth) + 'px'
      // cloned.style.right = rect.right + 'px'
      cloned.style.width = rect.width + 'px'
      cloned.style.height = rect.height + 'px'
      // cloned.style.x = rect.x + 'px'
      // cloned.style.y = (rect.left + document.documentElement.scrollLeft - hdRectNav.width) + 'px'
      cloned.style.y = (rect.y) + 'px'
      cloned.style.zIndex = 8000
      console.log('copying!', rect)

      cloned.style.minWidth = 'auto'
      console.log('clone', cloned)

      // strechのdivを消す
      var strs = cloned.getElementsByClassName('strecharea')
      strs.forEach(function (e) {
        cloned.removeChild(e)
      })
      element.appendChild(cloned)

      console.log(cloned)
      copyfrom.style.opacity = 0.5
      this.clonedObject = cloned
      this.orgObject = copyfrom
      // ticketidを保存しておく
      if (item.srcElement.parentNode.dataset.id !== undefined) {
        this.saveTicketId = item.srcElement.parentNode.dataset.id
      } else {
        this.saveTicketId = this.getDataIdFromChilds(item.srcElement.parent)
      }
      console.log('ticket', this.saveTicketId)
    },
    onMouseMove4Strech: function (e) {
      const relPos = this.getRelaitivePosition()
      var navWidth = relPos.relLeft

      // console.log('moving', e)
      var rect = this.orgObject.getBoundingClientRect()
      console.log(' mouse strech--', rect, e)
      if (rect.right - e.clientX <= 0) {
        return
      }
      if (e.clientX < this.widthOfHours[0].left) {
        return
      }
      this.clonedObject.style.left = (e.clientX - navWidth) + 'px'
      this.clonedObject.style.width = (rect.right - e.clientX) + 'px'
    },
    onMouseMove4Strech2: function (e) {
      const relPos = this.getRelaitivePosition()
      var navWidth = relPos.relLeft

      // console.log('moving', e)
      var rect = this.orgObject.getBoundingClientRect()
      if (e.clientX - rect.left <= 0) {
        return
      }
      if (e.clientX > this.widthOfHours[this.widthOfHours.length - 1].right) {
        return
      }
      this.clonedObject.style.right = (e.clientX - navWidth) + 'px'
      this.clonedObject.style.width = (e.clientX - rect.left) + 'px'
    },
    onMouseUp4Strech: function (e) {
      const self = this
      console.log('uped', e)
      window.removeEventListener('mousemove', this.onMouseMove4Strech)
      window.removeEventListener('mouseup', this.onMouseUp4Strech)
      this.onStereching = false

      var element = document.getElementById('dummy')
      element.removeChild(this.clonedObject)
      this.orgObject.style.opacity = 1

      var times = this.calcTimeFromClickedPoint(e.clientX)
      var odr = this.getOrderFromOrderID(this.saveTicketId)
      var hhx = odr.hatsuchiDayjs.clone()
      hhx = hhx.hour(times.hour)
      hhx = hhx.minute(times.minute)
      var selectedDay = dayjs(this.conditions.tekiyoYmd).add(times.addDay, 'day')
      hhx = hhx.year(selectedDay.year())
      hhx = hhx.month(selectedDay.month())
      hhx = hhx.date(selectedDay.date())
      // 終始が同じ時間なら30分前に固定
      if (odr.chakuchiDayjs.isSameOrBefore(hhx)) {
        hhx = odr.chakuchiDayjs.add(-30, 'minute')
      }
      // 書き戻す
      if (!odr.isWork) {
        odr.hatsuchiDayjs = hhx.clone()
        odr.hatsuchiYmd = hhx.format('YYYY/MM/DD')
        odr.hatsuchiHms = hhx.format('HH:mm')
      } else {
        odr.startDayjs = hhx.clone()
        odr.startYmd = hhx.format('YYYY/MM/DD')
        odr.startHms = hhx.format('HH:mm')
        odr.hatsuchiDayjs = hhx.clone()
      }

      if (this.viewMode === 0) {
        var rIndex = this.getCarDisplayIndexFromOrderID(this.saveTicketId)
        // 表示上のチケットを検索
        var dispOrder = this.filteredRows[rIndex].orderD.find(function (e) {
          return e.id === Number(self.saveTicketId)
        })
        // this.filteredRows[rIndex].updateFlg = true
        this.setUpdateFlg(rIndex, USE_DISPLAYINDEX)
      } else {
        rIndex = this.getDriverDisplayIndexFromOrderID(this.saveTicketId)
        // 表示上のチケットを検索
        dispOrder = this.filteredRows2[rIndex].orderD.find(function (e) {
          return e.id === Number(self.saveTicketId)
        })
        // this.filteredRows2[rIndex].updateFlg = true
        this.setUpdateFlg(rIndex, USE_DISPLAYINDEX)
      }
      if (!dispOrder.isWork) {
        dispOrder.hatsuchiDayjs = odr.hatsuchiDayjs.clone()
        dispOrder.hatsuchiYmd = odr.hatsuchiYmd
        dispOrder.hatsuchiHms = odr.hatsuchiHms
      } else {
        dispOrder.startDayjs = odr.startDayjs.clone()
        dispOrder.startYmd = odr.startYmd
        dispOrder.startHms = odr.startHms
        dispOrder.hatsuchiDayjs = odr.hatsuchiDayjs.clone()
      }
      dispOrder.updateFlg = true
      if (this.viewMode === 0) {
        this.changeTimeOrderTicketSharyo(dispOrder, rIndex)
      } else {
        this.changeTimeOrderTicketDriver(dispOrder, rIndex)
        // this.redrawSharyo1Line(rIndex)
      }
    },
    onMouseUp4Strech2: function (e) {
      const self = this
      console.log('uped', e)
      window.removeEventListener('mousemove', this.onMouseMove4Strech2)
      window.removeEventListener('mouseup', this.onMouseUp4Strech2)
      this.onStereching = false

      var element = document.getElementById('dummy')
      element.removeChild(this.clonedObject)
      this.orgObject.style.opacity = 1

      var times = this.calcTimeFromClickedPoint(e.clientX)
      var odr = this.getOrderFromOrderID(this.saveTicketId)
      var hhx = odr.chakuchiDayjs.clone()
      hhx = hhx.set('hour', times.hour)
      hhx = hhx.minute(times.minute)
      var selectedDay = dayjs(this.conditions.tekiyoYmd).add(times.addDay, 'days')

      console.log('today', this.conditions.tekiyoYmd, selectedDay, times.addDay)
      hhx = hhx.year(selectedDay.year())
      hhx = hhx.month(selectedDay.month())
      hhx = hhx.date(selectedDay.date())

      // 終始が同じ時間なら30分前に固定
      if (odr.hatsuchiDayjs.isSameOrAfter(hhx)) {
        hhx = hhx.add(30, 'minute')
      }

      // 書き戻す
      console.log('calced time', hhx)
      if (!odr.isWork) {
        odr.chakuchiDayjs = hhx.clone()
        odr.chakuchiYmd = hhx.format('YYYY/MM/DD')
        odr.chakuchiHms = hhx.format('HH:mm')
      } else {
        odr.endDayjs = hhx.clone()
        odr.endYmd = hhx.format('YYYY/MM/DD')
        odr.endHms = hhx.format('HH:mm')
        odr.chakuchiDayjs = hhx.clone()
      }
      if (this.viewMode === 0) {
        var rIndex = this.getCarDisplayIndexFromOrderID(this.saveTicketId)
        // 表示上のチケットを検索
        var dispOrder = this.filteredRows[rIndex].orderD.find(function (e) {
          return e.id === Number(self.saveTicketId)
        })
        // this.filteredRows[rIndex].updateFlg = true
        this.setUpdateFlg(rIndex, USE_DISPLAYINDEX)
      } else {
        rIndex = this.getDriverDisplayIndexFromOrderID(this.saveTicketId)
        // 表示上のチケットを検索
        dispOrder = this.filteredRows2[rIndex].orderD.find(function (e) {
          return e.id === Number(self.saveTicketId)
        })
        // this.filteredRows2[rIndex].updateFlg = true
        this.setUpdateFlg(rIndex, USE_DISPLAYINDEX)
      }
      if (!dispOrder.isWork) {
        dispOrder.chakuchiDayjs = odr.chakuchiDayjs.clone()
        dispOrder.chakuchiYmd = odr.chakuchiYmd
        dispOrder.chakuchiHms = odr.chakuchiHms
      } else {
        dispOrder.endDayjs = odr.endDayjs.clone()
        dispOrder.endYmd = odr.endYmd
        dispOrder.endHms = odr.endHms
        dispOrder.chakuchiDayjs = odr.chakuchiDayjs.clone()
      }
      dispOrder.updateFlg = true

      if (this.viewMode === 0) {
        this.changeTimeOrderTicketSharyo(dispOrder, rIndex)
      } else {
        this.changeTimeOrderTicketDriver(dispOrder, rIndex)
        // this.redrawSharyo1Line(rIndex)
      }
      // this.redrawSharyo1Line(rIndex)
      // console.log('disped', this.filteredRows, odr, dispOrder, hhx)
    },
    // #endregion
    // #region context menu 関連
    clearAllEmptyContext () {
      this.contextMenuContextEmpty3 = []
      this.contextMenuContextEmpty = []
      this.orderTicketContextMenuEmpty = []
      this.TicketContextMenuContextEmpty = []
      this.contextMenuContextEmpty2 = []
    },
    onRightClickField2 (e, item, rowIndex, type) {
      console.log('right click filed2', e, item)
      this.clearAllEmptyContext()
      if (!item.keikakuKakuteiFlg && this.isReadonlyKengen !== true) {
        if (this.viewMode === 0) {
          if (this.getSelectedDriverCount() > 0) {
            if (this.getSelectedDriverCount() === 1) {
              this.contextMenuContextEmpty3.push(this.ticketItemsPasteDriver2)
            } else {
              this.contextMenuContextEmpty3.push(this.ticketItemsPasteDriverNo1)
              if (type === 'main') {
                this.contextMenuContextEmpty3.push(this.ticketItemsPasteDriverSeq)
              }
            }

            this.$refs.fieldContextMenu2.showMenu(e, { rowIndex, type })
            this.justifyContextMenuPosition(e, item, 'fieldContextMenu2')
          }
        }
      }
    },
    onRightClickField (e, item, rowIndex, hourIndex) {
      console.log('right click filed', e, item)
      this.clearAllEmptyContext()
      if (!item.keikakuKakuteiFlg && this.isReadonlyKengen !== true) {
        if (this.viewMode === 0) {
          if (this.getSelectedCount() > 0) {
            this.contextMenuContextEmpty.push(this.ticketItemsPasteOrder)
          }
          this.contextMenuContextEmpty.push(this.ticketItemsNewOrder)
          this.contextMenuContextEmpty.push(this.ticketItemsNewWork)
          this.$refs.fieldContextMenu.showMenu(e, { rowIndex, hourIndex })
          this.justifyContextMenuPosition(e, item, 'fieldContextMenu')
        } else {
          if (this.getSelectedCount() > 0) {
            this.contextMenuContextEmpty.push(this.ticketItemsPasteOrder)
          }
          this.contextMenuContextEmpty.push(this.ticketItemsNewWork)
          this.$refs.fieldContextMenu.showMenu(e, { rowIndex, hourIndex })
          this.justifyContextMenuPosition(e, item, 'fieldContextMenu')
        }
      }
    },
    onRightClickOrder (e, item, row) {
      console.log('right click order', e, item)
      this.clearAllEmptyContext()
      const o = this.getOrderFromOrderID(item)
      if (this.viewMode === 0) {
        if (row.keikakuKakuteiFlg || this.isReadonlyKengen || o.kakuteiFlg) {
          this.orderTicketContextMenuEmpty.push(this.ticketItemsShowDatailReadonly)
        } else {
          this.orderTicketContextMenuEmpty.push(this.ticketItemsShowDetail)
          this.orderTicketContextMenuEmpty.push(this.ticketItemsReturnTray)
        }
        if (!row.keikakuKakuteiFlg && !this.isReadonlyKengen) {
          this.isThisItemKakutei = o.kakuteiFlg
          if (o.kakuteiFlg) {
            if ((row.jissekiStatus === '9' || row.jissekiStatus === '1') && (o.trSagyoJissekiId !== null && o.trSagyoJissekiId !== 0)) {
              const ele = { ...this.ticketItemsToUnLock }
              ele.class = 'contextmenuseletedlockreadonly'
              this.orderTicketContextMenuEmpty.push(ele)
            } else {
              this.orderTicketContextMenuEmpty.push(this.ticketItemsToUnLock)
            }
          } else {
            this.orderTicketContextMenuEmpty.push(this.ticketItemsToLock)
          }
        }
        this.$refs.orderTicketContextMenu.showMenu(e, item)
        this.justifyContextMenuPosition(e, item, 'orderTicketContextMenu')
      } else {
        if (o.isWork && !row.keikakuKakuteiFlg && !this.isReadonlyKengen && !o.kakuteiFlg) {
          this.orderTicketContextMenuEmpty.push(this.ticketItemsShowDetail)
          this.orderTicketContextMenuEmpty.push(this.ticketItemsReturnTray)
          this.isThisItemKakutei = o.kakuteiFlg
          if (o.kakuteiFlg) {
            this.orderTicketContextMenuEmpty.push(this.ticketItemsToUnLock)
          } else {
            this.orderTicketContextMenuEmpty.push(this.ticketItemsToLock)
          }
        } else {
          this.orderTicketContextMenuEmpty.push(this.ticketItemsShowDatailReadonly)
          if (o.isWork) {
            this.isThisItemKakutei = o.kakuteiFlg
            if (o.kakuteiFlg) {
              this.orderTicketContextMenuEmpty.push(this.ticketItemsToUnLock)
            } else {
              this.orderTicketContextMenuEmpty.push(this.ticketItemsToLock)
            }
          }
        }
        this.$refs.orderTicketContextMenu.showMenu(e, item)
        this.justifyContextMenuPosition(e, item, 'orderTicketContextMenu')
      }
    },
    onRightClickDriver (e, item) {
      console.log('right click driver', e, item)
      if (item.keikakuKakuteiFlg || this.isReadonlyKengen) {
        return
      }
      if (this.viewMode === 1) {
        if (this.getSelectedCount() > 0 && this.isReadonlyKengen !== true) {
          this.clearAllEmptyContext()
          this.contextMenuContextEmpty.push(this.ticketItemsPasteOrder)
          const rowIndex = this.getDriverDisplayIndexFromLineID(item.id)
          this.$refs.fieldContextMenu.showMenu(e, { rowIndex, hourIndex: 0 })
          this.justifyContextMenuPosition(e, item, 'fieldContextMenu')
        }
        return
      }
      const xType = this.getDriverType(e.target)
      console.log('driver right clicked', xType)
      this.clearAllEmptyContext()
      // if ((xType === 'main' && item.driver.masterFlg === true) || (xType === 'sub' && item.subDriver.masterFlg === true)) {
      if (this.isMasterDriverThisPostion(item, xType)) {
        if ((xType === 'main' && !item.jomuinKakuteiFlg) || (xType === 'sub' && !item.dojoshaKakuteiFlg)) {
          this.TicketContextMenuContextEmpty.push(this.ticketItemsReturnTray)
        }
      } else {
        if ((xType === 'main' && !item.jomuinKakuteiFlg) || (xType === 'sub' && !item.dojoshaKakuteiFlg)) {
          this.TicketContextMenuContextEmpty.push(this.ticketItemsDeleteTicket)
        }
      }
      this.TicketContextMenuContextEmpty.push(this.ticketItemsToCopyMode)
      if ((xType === 'main' && item.jomuinKakuteiFlg) || (xType === 'sub' && item.dojoshaKakuteiFlg)) {
        this.isThisItemKakutei = true
        if (item.jissekiStatus === '9' || item.jissekiStatus === '1') {
          const ele = { ...this.ticketItemsToUnLock }
          ele.class = 'contextmenuseletedlockreadonly'
          this.TicketContextMenuContextEmpty.push(ele)
        } else {
          this.TicketContextMenuContextEmpty.push(this.ticketItemsToUnLock)
        }
      } else {
        this.isThisItemKakutei = false
        this.TicketContextMenuContextEmpty.push(this.ticketItemsToLock)
      }
      this.$refs.driverTicketContextMenu.showMenu(e, { item: item, type: xType })
      this.justifyContextMenuPosition(e, item, 'driverTicketContextMenu')
    },
    onRightClickCar (e, item) {
      this.clearAllEmptyContext()
      if (item.keikakuKakuteiFlg || this.isReadonlyKengen) {
        return
      }
      if (this.viewMode === 0) {
        if (this.getSelectedCount() > 0) {
          this.contextMenuContextEmpty2.push(this.ticketItemsPasteOrder)
        }
        if (this.getSelectedDriverCount() > 0 && item.car.hacchusakiFlg === false) {
          if (this.getSelectedDriverCount() === 1) {
            this.contextMenuContextEmpty2.push(this.ticketItemsPasteDriver)
            this.contextMenuContextEmpty2.push(this.ticketItemsPasteSubDriver)
          } else {
            this.contextMenuContextEmpty2.push(this.ticketItemsPasteDriverNo1onCar)
            this.contextMenuContextEmpty2.push(this.ticketItemsPasteSubDriverNo1onCar)
            if (!this.isValidDriver(item.driver)) {
              this.contextMenuContextEmpty2.push(this.ticketItemsPasteDriverSeq)
            }
          }
        }
        if (item.car.jomuinId && this.getDriverFromDriverID(item.car.jomuinId) && !this.isValidDriver(item.driver) && item.car.hacchusakiFlg === false) {
          this.contextMenuContextEmpty2.push(this.ticketItemsDefaultDriver)
        }
        if (!this.isAllOrderAndDriverEmpty(item.car.id)) {
          if (this.isOneOfOrderAndDriverFixed(item.car.id)) {
            this.contextMenuContextEmpty2.push(this.ticketItemsToUnLockAll)
          }
          if (this.isOneOfOrderAndDriverNotFixed(item.car.id)) {
            this.contextMenuContextEmpty2.push(this.ticketItemsToLockAll)
          }
        }
        if (this.contextMenuContextEmpty2.length > 0) {
          this.$refs.carTicketContextMenu.showMenu(e, item)
          this.justifyContextMenuPosition(e, item, 'carTicketContextMenu')
        }
      }
    },
    onOrderTicketContextMenuClicked (e) {
      console.log('ordder right clicked', e)
      if (e.option.slug === 'showDetail') {
        this.onOrderTicketOpenButtonClick(e.item, true)
      } else if (e.option.slug === 'showDetailReadonly') {
        this.onOrderTicketOpenButtonClick(e.item, true)
      } else if (e.option.slug === 'toLock' || e.option.slug === 'toUnLock') {
        if (e.option.class === 'contextmenuseletedlockreadonly') {
          return
        }
        const ticket = this.getOrderFromOrderID(e.item)
        ticket.kakuteiFlg = !ticket.kakuteiFlg
        ticket.updateFlg = true
        if (this.viewMode === 0) {
          var fromIndex = this.getCarDisplayIndexFromOrderID(e.item)
          this.filteredRows[fromIndex].updateFlg = true
        } else {
          fromIndex = this.getDriverDisplayIndexFromOrderID(e.item)
          this.filteredRows2[fromIndex].updateFlg = true
        }
        console.log(ticket)
      } else if (e.option.slug === 'returnTray') {
        if (this.viewMode === 0) {
          // 車両別の場合
          console.log('item', e.item)
          var fromTicket = this.getOrderFromOrderID(e.item)
          fromIndex = this.getCarDisplayIndexFromOrderID(e.item)

          this.returnToTrayOrder(fromTicket, this.filteredRows[fromIndex].id)

          this.setOrderOnTray(fromTicket, true)
          this.redrawOrderTray()
          // this.redrawSharyo1Line(fromCarIndexReal, true)
        } else if (this.viewMode === 1) {
          // ドライバー別の場合
          fromTicket = this.getOrderFromOrderID(e.item)
          fromIndex = this.getDriverDisplayIndexFromOrderID(e.item)

          this.returnToTrayOrder(fromTicket, this.filteredRows2[fromIndex].id)

          this.setOrderOnTray(fromTicket, true)
        }
        console.log('grid swap ', this.filteredRows, this.order)
      }
    },
    onDriverTicketContextMenuClicked (e) {
      console.log('driver right clicked', e)
      if (e.option.slug === 'returnTray' || e.option.slug === 'deleteChip') {
        this.returnToTrayDriver(e.item.item.id, e.item.type)
      } else if (e.option.slug === 'selectCopyMode') {
        this.isCopyMode = !this.isCopyMode
        console.log('copymode:', this.isCopyMode)
      } else if (e.option.slug === 'toLock' || e.option.slug === 'toUnLock') {
        if (e.option.class === 'contextmenuseletedlockreadonly') {
          return
        }
        const ldata = this.getCarDataIndexFromLineID(e.item.item.id)
        const lines = this.getSameDriverAndCar(this.recCar[ldata], this.recCar, null, true, e.item.type)
        if (e.item.type === 'main') {
          const flg = !this.recCar[ldata].jomuinKakuteiFlg
          lines.forEach((e) => {
            e.jomuinKakuteiFlg = flg
            e.updateFlg = true
          })
        } else {
          const flg = !this.recCar[ldata].dojoshaKakuteiFlg
          lines.forEach((e) => {
            e.dojoshaKakuteiFlg = flg
            e.updateFlg = true
          })
        }
      }
    },
    onCarTicketContextMenuClicked (e) {
      // const self = this
      console.log(e)
      if (e.option.slug === 'defaultDriver') {
        const hitCar = this.getCarFromCarid(e.item.car.id)
        const driver = this.getDriverFromDriverID(hitCar.jomuinId)
        if (this.isValidDriver(driver)) {
          this.addToGridFromTrayDriver(driver, e.item.id, false, 'main')
        }
      } else if (e.option.slug === 'pasteOrder') {
        // viewmode 1 のときは driverの場合も呼ばれる
        const orders = this.getSelectedOrders()
        const rowIndex = (this.viewMode === 0) ? this.getCarDisplayIndexFromLineID(e.item.id) : this.getDriverDisplayIndexFromLineID(e.item.id)
        orders.forEach((ex) => {
          this.setStartHourOrderTicket(ex, 0)
          if (this.viewMode === 0) {
            this.addToGridFromTrayOrder(ex, this.filteredRows[rowIndex].id)
          } else {
            this.addToGridFromTrayOrder(ex, this.filteredRows2[rowIndex].id)
          }
          ex.isOnTray = false
        })
        this.deselectAll()
      } else if (e.option.slug === 'pasteDriver') {
        const driver = this.getSelectedDriver()
        if (driver && driver.length > 0) {
          this.addToGridFromTrayDriver(driver[0], e.item.id, false, 'main', true)
          driver[0].isOnTray = false
          this.deselect1Drivers(driver[0])
        }
      } else if (e.option.slug === 'pasteSubDriver') {
        const driver = this.getSelectedDriver()
        if (driver && driver.length > 0) {
          this.addToGridFromTrayDriver(driver[0], e.item.id, false, 'sub', true)
          driver[0].isOnTray = false
          this.deselect1Drivers(driver[0])
        }
      } else if (e.option.slug === 'pasteSeqDriver') {
        const driver = this.getSelectedDriver()
        if (driver && driver.length > 0) {
          var i
          var pushCounter = 0
          for (i = this.getCarDisplayIndexFromLineID(e.item.id); i < this.filteredRows.length; i++) {
            if (!this.isValidDriver(this.filteredRows[i].driver) && !this.isYousha(this.filteredRows[i])) {
              this.addToGridFromTrayDriver(driver[pushCounter], this.filteredRows[i].id, false, 'main')
              driver[pushCounter].isOnTray = false
              this.deselect1Drivers(driver[pushCounter])
              pushCounter += 1
              if (pushCounter >= driver.length) {
                break
              }
            }
          }
        }
      } else if (e.option.slug === 'toLockAll') {
        this.setFixAllOnCar(e.item.car.id)
      } else if (e.option.slug === 'toUnLockAll') {
        this.setNotFixAllOnCar(e.item.car.id)
      }
    },
    onFieldContextMenuClicked (e) {
      // const self = this
      console.log('filed context menu clicked', e)

      const startDayjs = this.tekiyoYmdDayjs.add((e.item.hourIndex - 1) * this.hoursInterval, 'h')
      if (e.option.slug === 'newOrder') {
        this.onAddOrderButtonClick(e, e.item.rowIndex, startDayjs)
        // $emitされたときにその受注を 時間 e.item.index 行の内容 e.item.item(.id) に作る
      } else if (e.option.slug === 'newWork') {
        this.onAddSagyoButtonClick(e, e.item.rowIndex, startDayjs)
      } else if (e.option.slug === 'pasteOrder') {
        if (IS_PRIORITY_ORDER_TIME_ON_CONTEXTMENU) {
          // 指定された時間に貼らないようにhourIndex -> 0 に変更
          var xhourIndex = 0
        } else {
          xhourIndex = e.item.hourIndex
        }
        const orders = this.getSelectedOrders()
        var row
        if (this.viewMode === 0) {
          row = this.filteredRows[e.item.rowIndex]
        } else {
          row = this.filteredRows2[e.item.rowIndex]
        }
        const marker = dayjs().valueOf()
        row.marker = marker
        var rows
        if (this.viewMode === 0) {
          rows = this.filteredRows
        } else {
          rows = this.filteredRows2
        }

        orders.forEach((ex) => {
          this.setStartHourOrderTicket(ex, xhourIndex)
          if (this.viewMode === 0) {
            rows = this.filteredRows
          } else {
            rows = this.filteredRows2
          }
          row = rows.find((e) => {
            return e.marker === marker
          })
          if (row) {
            this.addToGridFromTrayOrder(ex, row.id)
          }
          ex.isOnTray = false
        })
        row = rows.find((e) => {
          return e.marker === marker
        })
        if (row) {
          // マーカーを消しておく
          delete row.marker
        }
        this.deselectAll()
      } else if (e.option.slug === 'pasteDriver') {
        const driver = this.getSelectedDriver()
        if (driver && driver.length > 0) {
          this.addToGridFromTrayDriver(driver[0], this.filteredRows[e.item.rowIndex].id, false, e.item.type)
          driver[0].isOnTray = false
          this.deselect1Drivers(driver[0])
        }
      } else if (e.option.slug === 'pasteSeqDriver') {
        const driver = this.getSelectedDriver()
        if (driver && driver.length > 0) {
          var i
          var pushCounter = 0
          for (i = e.item.rowIndex; i < this.filteredRows.length; i++) {
            if (!this.isValidDriver(this.filteredRows[i].driver) && !this.isYousha(this.filteredRows[i])) {
              this.addToGridFromTrayDriver(driver[pushCounter], this.filteredRows[i].id, false, 'main')
              driver[pushCounter].isOnTray = false
              this.deselect1Drivers(driver[pushCounter])
              pushCounter += 1
              if (pushCounter >= driver.length) {
                break
              }
            }
          }
        }
      }
    },
    onRightClickTrayOrder (e, item) {
      var element
      if (this.getSelectedCount() > 0) {
        this.$refs.trayOrderTicketContextMenu.showMenu(e, item)
        element = 'trayOrderTicketContextMenu'
        this.justifyContextMenuPosition(e, item, element)
      }
    },
    onRightClickTrayDriver (e, item) {
      var element
      if (this.getSelectedDriverCount() > 0) {
        this.$refs.trayDriverTicketContextMenu.showMenu(e, item)
        element = 'trayDriverTicketContextMenu'
        this.justifyContextMenuPosition(e, item, element)
      }
    },
    onTrayOrderContextMenuClicked (e) {
      // const self = this
      console.log('tray order context menu clicked', e)
      if (e.option.slug === 'deselectAll') {
        this.deselectAll()
      }
    },
    onTrayDriverContextMenuClicked (e) {
      // const self = this
      console.log('tray driver context menu clicked', e)
      if (e.option.slug === 'deselectAll') {
        this.deselectAllDrivers()
      }
    },
    /**
     * simple-context-menu用の座標補正処理
     * @param {} e poinetr event 現状使用しない
     * @param {*} item 表示アイテム 現状使用しない
     * @param {*} ele 表示するコンテクストメニューのID名
     * @returns none
    **/
    justifyContextMenuPosition (e, item, ele) {
      console.log('context menu display', e, item, ele)
      const relPos = this.getRelaitivePosition()
      var navHeight = relPos.relTop
      var navWidth = relPos.relLeft
      var menu = document.getElementById(ele)
      if (!menu) {
        return
      }
      console.log('menu.style before', menu.style.left, menu.style.top, relPos)
      menu.style.left = (parseInt(menu.style.left) - navWidth) + 'px'
      menu.style.top = (parseInt(menu.style.top) - navHeight) + 'px'
      menu.style.userSelect = 'none'
      console.log('menu.style after', parseInt(menu.style.left), menu.style.left, menu.style.top, relPos)
      // hoverでフロテーィングテキストだすのをやってみる
      this.$nextTick(() => {
        const ritems = document.getElementsByClassName('contextmenuseletedlockreadonly')
        if (ritems && ritems.length > 0) {
          this.readonlyArea = []
          ritems.forEach((e) => {
            var rect = e.getBoundingClientRect()
            this.readonlyArea.push({ left: rect.left, top: rect.top, right: rect.right, bottom: rect.bottom })
          })
          window.addEventListener('mousemove', this.checkHover)
        }
      })
    },
    onContextMenuClosed (e) {
      // console.log('contetxt menu closed', e)
      window.removeEventListener('mousemove', this.checkHover)
      if (this.isDisplayHover) {
        this.isDisplayHover = false
        const e = document.getElementById('readonlyhover')
        e.classList.add('fade-transition-leave-active')
        e.classList.add('fade-transition-leave-to')
        this.$nextTick(() => {
          e.classList.remove('fade-transition-leave-active')
          e.classList.remove('fade-transition-leave-to')
          e.classList.remove('menuable__context__active')
          e.style.display = 'none'
        })
        // e.style.display = 'none'
      }
    },
    checkHover (ev) {
      const ele = this.readonlyArea.find((e) => {
        return ev.clientX >= e.left && ev.clientX < e.right && ev.clientY >= e.top && ev.clientY <= e.bottom
      })
      if (ele) {
        if (!this.isDisplayHover) {
          this.isDisplayHover = true
          console.log('hitele')
          const relPos = this.getRelaitivePosition()
          var navHeight = relPos.relTop
          var navWidth = relPos.relLeft
          const e = document.getElementById('readonlyhover')
          e.onanimationend = this.onAnimEnd
          e.style.left = (parseInt(ele.left) + 10 - navWidth) + 'px'
          e.style.top = (ele.bottom + 7 - navHeight) + 'px'
          this.$nextTick(() => {
            e.classList.add('scale-transition-enter-active')
            e.classList.add('scale-transition-enter-to')
            e.classList.add('menuable__context__active')
            e.style.display = ''
            e.style.display = 'inline-block'
            this.$nextTick(() => {
              e.classList.remove('scale-transition-enter-active')
              e.classList.remove('scale-transition-enter-to')
            })
          })
        }
      } else {
        if (this.isDisplayHover) {
          this.isDisplayHover = false
          const e = document.getElementById('readonlyhover')
          e.classList.add('fade-transition-leave-active')
          e.classList.add('fade-transition-leave-to')
          this.$nextTick(() => {
            e.classList.remove('fade-transition-leave-active')
            e.classList.remove('fade-transition-leave-to')
            e.classList.remove('menuable__context__active')
            e.style.display = 'none'
          })
          // e.style.display = 'none'
        }
      }
    },
    onAimEnd () {
      console.log('anum end')
      const e = document.getElementById('readonlyhover')
      e.classList.remove('scale-transition-enter-active')
      e.classList.remove('scale-transition-enter-to')
      e.classList.remove('fade-transition-leave-active')
      e.classList.remove('fade-transition-leave-to')
      if (!this.isDisplayHover) {
        e.style.display = 'none'
      }
    },
    // #endregion
    // #region pixel計算関係
    calcWidthTable () {
      var i
      var key
      this.widthOfHours = []
      for (i = 1; i <= this.hours / this.hoursInterval; i++) {
        key = 'tableHeader' + i
        var ele = document.getElementById(key)
        var rect = ele.getBoundingClientRect()
        rect.index = i
        this.widthOfHours.push(rect)
        // console.log('rect', i + this.tableStartHour - 1, rect)
      }
    },
    calcWidthLineHeader () {
      var i
      var key
      var tw = 0
      const t = new Array(6) // this.widthOfLineHeader = []
      for (i = 1; i <= 6; i++) {
        key = 'tableLineHeader' + i
        var ele = document.getElementById(key)
        if (ele) {
          var rect = ele.getBoundingClientRect()
          tw += rect.width
        } else {
          // this.widthOfLineHeader.push(tw)
        }
        t[i - 1] = tw
      }
      if (t.toString() !== this.widthOfLineHeader.toString()) {
        console.log('width changed')
        this.widthOfLineHeader = t
      }
    },
    calcTimeFromClickedPoint (x) {
      var ret = {}
      ret.minute = 0
      ret.addDay = 0
      if (x <= this.widthOfHours[0].left) {
        ret.hour = this.tableStartHour
        return ret
      }
      console.log('wh', this.widthOfHours[this.widthOfHours.length - 1])
      if (x >= this.widthOfHours[this.widthOfHours.length - 1].right) {
        ret.hour = (this.tableStartHour + this.hours) % 24
        ret.addDay = Math.floor((this.tableStartHour + this.hours) / 24)
        return ret
      }
      var rect = this.widthOfHours.find(function (e) {
        return e.right >= x && e.left <= x
      })
      console.log('return rect:', rect, x)
      // 分を計算する: とりあえず30分単位
      // 0-25% 0min 25%-75% 30min 75%- hour+1:0min
      var widthDiv = (x - rect.left) / rect.width * this.hoursInterval
      ret.hour = this.tableStartHour + (rect.index - 1) * this.hoursInterval + Math.floor(widthDiv)
      widthDiv = widthDiv - Math.floor(widthDiv)
      if (widthDiv <= 0.25) {
        ret.minute = 0
      } else if (widthDiv < 0.75) {
        ret.minute = 30
      } else {
        ret.hour++
        ret.minute = 0
      }
      console.log('return time p:', ret)
      ret.addDay = Math.floor(ret.hour / 24)
      ret.hour = ret.hour % 24
      console.log('return time:', ret)
      return ret
    },
    /**
     * 指定カラムの分に対応する幅を計算する
     * @param {object:dayjs} djs - dayjs
     * @param {number} index - 時間に対応したindex
     * @returns {{minPx:number,minModPx:number}} {minPx: 分の幅 , minModPx: 60-分の幅}
     */
    getMinWidthPx (djs, index) {
      var ret
      var minute = djs.minute()
      var fullTime = 60 * this.hoursInterval
      var h = djs.diff(this.tekiyoYmdDayjs, 'hour')
      if (h < 0) {
        // 表開始前の時間は全部０
        ret = {
          minPx: 0,
          minModPx: 0
        }
        return ret
      }
      var mod = h % this.hoursInterval
      minute = minute + (mod) * 60
      // ヘッダのwidthを取得
      const key = 'tableHeader' + index
      var ele = document.getElementById(key)
      // console.log('px', minute, index)
      if (ele === null) {
        console.log('before draw')
        // 描画前はnullが帰ってくるようだ
        ret = {
          minPx: 0,
          minModPx: 0
        }
        return ret
      }
      var rect = ele.getBoundingClientRect()
      if (minute <= 0) {
        ret = {
          minPx: 0,
          minModPx: 0
        }
        return ret
      }
      ret = {
        minPx: Math.floor(minute / fullTime * rect.width)
      }
      ret.minModPx = rect.width - ret.minPx
      // console.log('calced', ret)
      return ret
    },
    /**
     * ヘッダ及びナビゲーションドロワのサイズを取得する
     * 普通にdocument座標系で描画するとそのぶんずれるため
     * @returns {{relTop: number, relLeft:number}} - { relTop: ヘッダの高さ, relLeft: ドロワの幅（ずらす量）}
     **/
    getRelaitivePosition () {
      var hdRect, hdRectNav
      // ヘッダ部分のサイズを計る
      var hd = document.getElementsByTagName('header')
      for (var i = 0; i < hd.length; i++) {
        hdRect = hd[i].getBoundingClientRect()
        // console.log('append after rect header', i, hdRect)
        break
      }

      // ナビゲーションドロワーのサイズを計る
      var nav = document.getElementsByTagName('nav')
      for (i = 0; i < nav.length; i++) {
        hdRectNav = nav[i].getBoundingClientRect()
        // console.log('append after rect header', i, hdRectNav)
        break
      }
      var navwidth = hdRectNav.width + hdRectNav.x

      return { relTop: hdRect.height, relLeft: navwidth }
    },
    // #endregion
    // #region 画面データ更新・反映
    /**
     * 画面に表示する情報をorderから作り上げる
     * 車両が縦軸
     */
    createCarRecords () {
      const self = this
      this.recCar = []
      // isOnTrayの初期化
      this.keikakuJininList = this.keikakuJininList.map(function (e) {
        e.isOnTray = true
        return e
      })
      // this.keikakuSagyoMeisai = this.keikakuSagyoMeisai.map(function (e) {
      //   e.isOnTray = true
      //   return e
      // })
      // this.keikakuSagyoMeisai2 = this.keikakuSagyoMeisai2.map(function (e) {
      //   e.isOnTray = true
      //   return e
      // })

      this.sagyoKeikaku.forEach((e) => {
        if (e.sharyoId === null) {
          // 表示されないオーダはonTrayをオフにする
          if (e.trSagyoMeisaiIdArrayList && e.trSagyoMeisaiIdArrayList.length > 0) {
            e.trSagyoMeisaiIdArrayList.forEach((e) => {
              const odr = self.getOrderFromOrderID(e)
              if (odr) {
                odr.isOnTray = false
              }
            })
          }
          if (e.trSagyoMeisaiId2ArrayList && e.trSagyoMeisaiId2ArrayList.length > 0) {
            e.trSagyoMeisaiId2ArrayList.forEach((e) => {
              const wrk = self.getWorkFromWorkID(e)
              if (wrk) {
                wrk.isOnTray = false
              }
            })
          }
        }
      })
      // if (this.usePager) {
      //   var pageSharyo = this.keikakuSharyoList.slice((this.page - 1) * this.linesPerPage, (this.page - 1) * this.linesPerPage + this.linesPerPage)
      // } else {
      var pageSharyo = this.keikakuSharyoList
      // }
      pageSharyo.forEach(function (e) {
        var sagyoKeikakuList = self.getSagyoKeikakuFromCarId(e.id)
        // var odrList = self.mergeArraySagyoMeisaiId(sagyoKeikakuList)
        // if ((!sagyoKeikakuList) || sagyoKeikakuList.length === 0 || odrList.length === 0) {
        if ((!sagyoKeikakuList) || sagyoKeikakuList.length === 0) {
          // オーダーが割り当てられていない車両
          // indexedDBから読んだデータが削除になっているとき
          const updFlg = self.getSagyoKeikakuUpdFlgFromCarIdAsDeleted(e.id)
          var l = self.setNewRecords({})
          l.car = e
          l.driver = {}
          l.subDriver = {}
          l.updateFlg = updFlg
          // l.masterFlg = true
          // var l = {
          //   id: self.getNewLineIdCar(),
          //   trSKKId: null,
          //   car: e,
          //   orderD: [],
          //   driver: {},
          //   subDriver: {},
          //   masterFlg: true,
          //   keikakuKakuteiFlg: false,
          //   jissekiStatus: '0',
          //   updateFlg: updFlg,
          //   jomuinKakuteiFlg: false,
          //   dojoshaKakuteiFlg: false
          // }
          self.recCar.push(l)
        } else {
          sagyoKeikakuList.forEach(function (ex) {
            const odrList = self.getSagyoMeisaiFromSagyoMeisaiIdList(ex.trSagyoMeisaiIdArrayList, ex.trSagyoMeisaiId2ArrayList)
            var ndriver = e.hacchusakiFlg ? null : self.getDriverFromDriverID(ex.jomuinId)
            var nSubdriver = e.hacchusakiFlg ? null : self.getDriverFromDriverID(ex.dojoshaId)
            if (ndriver) {
              ndriver.isOnTray = false
              // if (self.recCar.find(function (ec) {
              //   // return ec.car.id !== ex.sharyoId && ((self.isValidDriver(ec.driver) && ec.driver.id === ndriver.id) || (self.isValidDriver(ec.subDriver) && ec.subDriver.id === ndriver.id))
              //   return ec.car.id !== ex.sharyoId && (self.compareSameDriver(ec.driver, ndriver) || self.compareSameDriver(ec.subDriver, ndriver))
              // })) {
              //   // const newRec = Object.assign({}, ndriver)
              //   // ndriver = newRec
              //   // ndriver.masterFlg = false
              // }
            } else {
              ndriver = null
            }
            if (nSubdriver) {
              nSubdriver.isOnTray = false
              // if (self.recCar.find(function (ec) {
              //   // return ec.car.id !== ex.sharyoId && ((self.isValidDriver(ec.driver) && ec.driver.id === nSubdriver.id) || (self.isValidDriver(ec.subDriver) && ec.subDriver.id === nSubdriver.id))
              //   return (ec.car.id !== ex.sharyoId || !self.compareSameDriver(ec.driver, nSubdriver)) && self.compareSameDriver(ec.subDriver, nSubdriver)
              // })) {
              //   const newRec = Object.assign({}, nSubdriver)
              //   nSubdriver = newRec
              //   // nSubdriver.masterFlg = false
              // }
            } else {
              nSubdriver = null
            }
            if (odrList.length === 0) {
              if (!self.recCar.find((ez) => {
                return ez.car.id === e.id && self.compareSameDriver(ez.driver, ndriver) && self.compareSameDriver(ez.subDriver, nSubdriver)
              })) {
                // indexedDBから読んだデータが削除になっているとき
                // or 乗務員だけ設定された計画を読んだとき
                const updFlg = self.getSagyoKeikakuUpdFlgFromCarIdAsDeleted(e.id)
                var l = self.setNewRecords({})
                l.car = e
                l.driver = ndriver
                l.subDriver = nSubdriver
                l.updateFlg = updFlg
                // l.masterFlg = true
                l.jomuinKakuteiFlg = ex.jomuinKakuteiFlg
                l.dojoshaKakuteiFlg = ex.dojoshaKakuteiFlg
                l.trSagyoKeikakuKihonInsDateDayjs = ex.trSagyoKeikakuKihonInsDateDayjs
                l.trSagyoKeikakuKihonInsUserNm = ex.trSagyoKeikakuKihonInsUserNm
                l.trSagyoKeikakuKihonUpdDateDayjs = ex.trSagyoKeikakuKihonUpdDateDayjs
                l.trSagyoKeikakuKihonUpdUserNm = ex.trSagyoKeikakuKihonUpdUserNm
                // var l = {
                //   id: self.getNewLineIdCar(),
                //   trSKKId: null,
                //   car: e,
                //   orderD: [],
                //   driver: ndriver,
                //   subDriver: nSubdriver,
                //   masterFlg: true,
                //   keikakuKakuteiFlg: false,
                //   jissekiStatus: '0',
                //   updateFlg: updFlg,
                //   trSagyoKeikakuKihonInsDateDayjs: ex.trSagyoKeikakuKihonInsDateDayjs,
                //   trSagyoKeikakuKihonInsUserNm: ex.trSagyoKeikakuKihonInsUserNm,
                //   trSagyoKeikakuKihonUpdDateDayjs: ex.trSagyoKeikakuKihonUpdDateDayjs,
                //   trSagyoKeikakuKihonUpdUserNm: ex.trSagyoKeikakuKihonUpdUserNm,
                //   jomuinKakuteiFlg: ex.jomuinKakuteiFlg,
                //   dojoshaKakuteiFlg: ex.dojoshaKakuteiFlg
                // }
                self.recCar.push(l)
              }
              return
            }
            var i
            for (i = 0; i < odrList.length; i++) {
              var sIndex = self.searchSameLineOnCar(odrList[i], e.id, ex.jomuinId, ex.dojoshaId, ex.jomuinKakuteiFlg, ex.dojoshaKakuteiFlg)
              if (sIndex === -1) {
                odrList[i].isOnTray = false
                // 20220401s
                // if (ndriver && ndriver.masterFlg && self.isHasMasterCar(ndriver)) {
                //   const newRec = Object.assign({}, ndriver)
                //   ndriver = newRec
                //   ndriver.masterFlg = false
                // }
                // if (nSubdriver && nSubdriver.masterFlg && self.isHasMasterCar(nSubdriver)) {
                //   const newRec = Object.assign({}, nSubdriver)
                //   nSubdriver = newRec
                //   nSubdriver.masterFlg = false
                // }
                // 20220401e
                // ドライバのマスタフラグを立てる処理
                // 最初に出てきたのにマスタフラグを付ける
                // if (ndriver) {
                //   if (self.recCar.find(function (ec) {
                //     return ec.car.id !== ex.sharyoId && ((self.isValidDriver(ec.driver) && ec.driver.id === ndriver.id) || (self.isValidDriver(ec.subDriver) && ec.subDriver.id === ndriver.id))
                //   })) {
                //     const newRec = Object.assign({}, ndriver)
                //     ndriver = newRec
                //     ndriver.masterFlg = false
                //   }
                // } else {
                //   ndriver = null
                // }
                // if (nSubdriver) {
                //   if (self.recCar.find(function (ec) {
                //     return ec.car.id !== ex.sharyoId && ((self.isValidDriver(ec.driver) && ec.driver.id === nSubdriver.id) || (self.isValidDriver(ec.subDriver) && ec.subDriver.id === nSubdriver.id))
                //   })) {
                //     const newRec = Object.assign({}, nSubdriver)
                //     nSubdriver = newRec
                //     nSubdriver.masterFlg = false
                //   }
                // } else {
                //   nSubdriver = null
                // }
                // if (self.recCar.find((ett) => {
                //   return ett.car.id === e.id
                // })) {
                //   var masterFlg = false
                // } else {
                //   masterFlg = true
                // }
                l = self.setNewRecords({})
                l.car = e
                l.driver = ndriver
                l.subDriver = nSubdriver
                // l.masterFlg = masterFlg
                l.jomuinKakuteiFlg = ex.jomuinKakuteiFlg
                l.dojoshaKakuteiFlg = ex.dojoshaKakuteiFlg
                l.orderD = [odrList[i]]
                l.keikakuKakuteiFlg = ex.keikakuKakuteiFlg
                l.jissekiStatus = ex.jissekiStatus
                l.updateFlg = ex.updateFlg
                l.trSagyoKeikakuKihonInsDateDayjs = ex.trSagyoKeikakuKihonInsDateDayjs
                l.trSagyoKeikakuKihonInsUserNm = ex.trSagyoKeikakuKihonInsUserNm
                l.trSagyoKeikakuKihonUpdDateDayjs = ex.trSagyoKeikakuKihonUpdDateDayjs
                l.trSagyoKeikakuKihonUpdUserNm = ex.trSagyoKeikakuKihonUpdUserNm
                l.isEqualUnkouYmdAndTekiyoYmd = self.tekiyoYmdDayjs.isSame(dayjs(odrList[i].sagyoYmd), 'd')
                // l = {
                //   id: self.getNewLineIdCar(),
                //   trSKKId: ex.id,
                //   car: e,
                //   orderD: [odrList[i]],
                //   driver: ndriver,
                //   subDriver: nSubdriver,
                //   masterFlg: masterFlg,
                //   keikakuKakuteiFlg: ex.keikakuKakuteiFlg,
                //   jissekiStatus: ex.jissekiStatus,
                //   updateFlg: ex.updateFlg,
                //   trSagyoKeikakuKihonInsDateDayjs: ex.trSagyoKeikakuKihonInsDateDayjs,
                //   trSagyoKeikakuKihonInsUserNm: ex.trSagyoKeikakuKihonInsUserNm,
                //   trSagyoKeikakuKihonUpdDateDayjs: ex.trSagyoKeikakuKihonUpdDateDayjs,
                //   trSagyoKeikakuKihonUpdUserNm: ex.trSagyoKeikakuKihonUpdUserNm,
                //   jomuinKakuteiFlg: ex.jomuinKakuteiFlg,
                //   dojoshaKakuteiFlg: ex.dojoshaKakuteiFlg
                // }
                self.recCar.push(l)
              } else {
                // const o = self.getOrderFromOrderID(odrList[i])
                // self.recCar.find(function (e) {
                //   if (e.orderD.find(function (el) {
                //     return el.id === odrList[sIndex].id
                //   })) {
                //     // self.getDriverFromDriverID(odrList[i].driverid).isOnTray = false
                //     odrList[i].isOnTray = false
                //     e.orderD.push(odrList[i])
                //   }
                // })
                if (!self.recCar[sIndex].orderD) {
                  self.recCar[sIndex].orderD = []
                }
                if (self.recCar[sIndex].orderD.length === 0) {
                  self.recCar[sIndex].driver = ndriver
                  self.recCar[sIndex].subDriver = nSubdriver
                  self.recCar[sIndex].trSagyoKeikakuKihonInsDateDayjs = ex.trSagyoKeikakuKihonInsDateDayjs
                  self.recCar[sIndex].trSagyoKeikakuKihonInsUserNm = ex.trSagyoKeikakuKihonInsUserNm
                  self.recCar[sIndex].trSagyoKeikakuKihonUpdDateDayjs = ex.trSagyoKeikakuKihonUpdDateDayjs
                  self.recCar[sIndex].trSagyoKeikakuKihonUpdUserNm = ex.trSagyoKeikakuKihonUpdUserNm
                  self.recCar[sIndex].isEqualUnkouYmdAndTekiyoYmd = self.tekiyoYmdDayjs.isSame(dayjs(odrList[i].sagyoYmd), 'd')
                }
                self.recCar[sIndex].keikakuKakuteiFlg = (self.recCar[sIndex].keikakuKakuteiFlg) ? self.recCar[sIndex].keikakuKakuteiFlg : ex.keikakuKakuteiFlg
                self.recCar[sIndex].jissekiStatus = (self.recCar[sIndex].jissekiStatus) ? self.recCar[sIndex].jissekiStatus : ex.jissekiStatus
                self.recCar[sIndex].updateFlg = (self.recCar[sIndex].updateFlg) ? (self.recCar[sIndex].updateFlg) : ex.updateFlg
                odrList[i].isOnTray = false
                self.recCar[sIndex].orderD.push(odrList[i])
              }
            }
          })
        }
      })
      console.log('disp cars', this.recCar)
      console.log('disp tray', this.filteredOrders)
      console.log('all order', this.keikakuSagyoMeisai)
      this.redrawOrderTray()
      this.redrawWorksTray()
    },
    /**
     * 画面の情報をオーダー情報に書き戻す
     * 車両別画面用
     */
    storeOrderInfoFromScreenSharyo (storePage = undefined) {
      const self = this
      // 保存する項目を探しておく
      var stLines
      // var skk
      if (this.usePager && storePage) {
        stLines = this.keikakuSharyoList.slice((storePage - 1) * this.linesPerPage, (storePage - 1) * this.linesPerPage + this.linesPerPage)
        var skk = self.sagyoKeikaku.filter((e) => {
          return stLines.some((et) => {
            return e.sharyoId === et.id
          })
        })

        var cars = self.recCar.filter((e) => {
          return stLines.some((et) => {
            return e.car.id === et.id
          })
        })
      } else {
        skk = self.sagyoKeikaku
        stLines = self.keikakuSharyoList
        cars = self.recCar
      }
      // まずは初期化
      // すべての計画のdelFlgを立てて削除したことにする
      skk.forEach(function (e) {
        if (e.sharyoId !== null && self.isSharyoInScreen(e.sharyoId)) {
          e.delFlg = true
          e.trSagyoMeisaiIdArrayList = []
          e.trSagyoMeisaiId2ArrayList = []
        }
      })
      cars.forEach(function (e) {
        // console.log(e)
        var plan
        if (e.orderD && e.orderD.length !== 0) {
          e.orderD.forEach(function (el) {
            plan = self.getSagyoPlanFromDataRowAndDate(e, e.subDriver, dayjs(el.sagyoYmd)) // 運行日に変更
            plan.delFlg = false
            plan.keikakuKakuteiFlg = e.keikakuKakuteiFlg
            plan.jomuinKakuteiFlg = e.jomuinKakuteiFlg
            plan.dojoshaKakuteiFlg = e.dojoshaKakuteiFlg
            plan.updateFlg = (plan.updateFlg ? true : (e.updateFlg ? true : el.updateFlg))
            if (el.isWork) {
              plan.trSagyoMeisaiId2ArrayList.push(el.id)
              if (plan.isWorksPlan === null) {
                plan.isWorksPlan = true
              }
            } else {
              plan.trSagyoMeisaiIdArrayList.push(el.id)
              if (plan.isWorksPlan === null) {
                plan.isWorksPlan = false
              }
            }
          })
        } else if (self.isValidDriver(e.driver) || self.isValidDriver(e.subDriver)) {
          plan = self.getSagyoPlanFromDataRowAndDate(e, e.subDriver, self.tekiyoYmdDayjs)
          plan.delFlg = false
          plan.keikakuKakuteiFlg = e.keikakuKakuteiFlg
          plan.jomuinKakuteiFlg = e.jomuinKakuteiFlg
          plan.dojoshaKakuteiFlg = e.dojoshaKakuteiFlg
          e.orderD = []
          e.isEqualUnkouYmdAndTekiyoYmd = true
        }
      })
      this.sagyoKeikaku = this.sagyoKeikaku.map(function (e) {
        e.trSagyoMeisaiIdArray = e.trSagyoMeisaiIdArrayList.join(',')
        e.trSagyoMeisaiId2Array = e.trSagyoMeisaiId2ArrayList.join(',')
        // 対応する行情報を探し更新フラグが立っていれば立てる
        const sameLines = self.getSameInfoRowsFromPlan(e, self.recCar)
        if (sameLines.find((x) => {
          return x.updateFlg
        })) {
          e.updateFlg = true
        }
        if (e.delFlg) {
          e.updateFlg = true
        }
        if (e.delFlg && e.keikakuKakuteiFlg) {
          console.log('★★★ why delete...', e)
          // 確定たっているのを外して別な行に付け替えたりするとなる
          // 確定フラグをオフにする
          e.keikakuKakuteiFlg = false
        }
        return e
      })
      // 行での出入りをフォローするために、updateFlgが立っている計画と同じ車両の計画は全てupdateFlgを立てる
      this.sagyoKeikaku.filter((es) => {
        return es.updateFlg
      }).forEach((es) => {
        self.sagyoKeikaku.filter((er) => {
          return er.sharyoId === es.sharyoId
        }).forEach((er) => {
          er.updateFlg = true
        })
      })
      this.adjustSagyoKeikakuEdaNo()
      console.log('saveed 作業計画', this.sagyoKeikaku)
    },
    adjustSagyoKeikakuEdaNo () {
      const self = this
      this.sagyoKeikaku.forEach((e) => {
        if (e.trSagyoKeikakuKihonEdaNo === null && e.jomuinId !== null) {
          // 補正処理
          // 同じ車で同じ日付の作業計画を探す
          // 乗務員IDがnullのは枝番はないので振りなおしを行わない
          var recs = this.sagyoKeikaku.filter((ef) => {
            return e.sagyoYoteiYmd === ef.sagyoYoteiYmd && e.sharyoId === ef.sharyoId
          })
          const noList = recs.filter((em) => {
            return em.trSagyoKeikakuKihonEdaNo !== null
          }).map((em) => {
            return em.trSagyoKeikakuKihonEdaNo
          })
          recs = recs.filter((ef) => {
            return ef.trSagyoKeikakuKihonEdaNo === null
          })
          var edano = 1
          recs.forEach((ex) => {
            edano = self.getEdano(noList, edano)
            ex.trSagyoKeikakuKihonEdaNo = edano
            edano++
            ex.updateFlg = true
          })
        }
      })
    },
    getEdano (noList, no) {
      for (;;) {
        if (noList.indexOf(no) === -1) {
          return no
        }
        no++
      }
    },
    getSameInfoRowsFromPlan (sk, rowList) {
      const self = this
      return rowList.filter((e) => {
        if ((sk.sharyoId === null && !self.isValidCar(e.car)) || (self.isValidCar(e.car) && sk.sharyoId === e.car.id)) {

        } else {
          return false
        }
        if ((sk.jomuinId === null && !self.isValidDriver(e.driver)) || (self.isValidDriver(e.driver) && sk.jomuinId === e.driver.id)) {

        } else {
          return false
        }
        if ((sk.dojoshaId === null && !self.isValidDriver(e.subDriver)) || (self.isValidDriver(e.subDriver) && sk.dojoshaId === e.subDriver.id)) {

        } else {
          return false
        }
        return true
      })
    },
    isSharyoInScreen (sharyoId) {
      return !!this.keikakuSharyoList.find((e) => {
        return sharyoId === e.id
      })
    },
    /**
     * 画面の情報をオーダー情報に書き戻す
     * ドライバー別画面用
     */
    storeOrderInfoFromScreenDriver (storePage = undefined) {
      const self = this

      var drLines
      // var skk
      if (this.usePager && storePage) {
        drLines = this.keikakuJininList.slice((storePage - 1) * this.linesPerPage, (storePage - 1) * this.linesPerPage + this.linesPerPage)
        var skk = self.sagyoKeikaku.filter((e) => {
          return drLines.some((et) => {
            return e.jomuinId === et.id || e.dojoshaId === et.id
          })
        })

        var drivers = self.recDriver.filter((e) => {
          return drLines.some((et) => {
            return e.driver.id === et.id || e.subDriverid === et.id
          })
        })
      } else {
        skk = self.sagyoKeikaku
        drLines = self.keikakuJininList
        drivers = self.recDriver
      }
      // すべての計画のdelFlgを立てて削除したことにする
      skk.forEach(function (e) {
        if (e.jomuinId !== null || e.dojoshaId !== null) {
          if (e.trSagyoMeisaiId2ArrayList.length > 0) {
            if (e.trSagyoMeisaiId2ArrayList.length === 1 && e.trSagyoMeisaiId2ArrayList[0] === '') {

            } else {
              e.delFlg = true
              e.trSagyoMeisaiId2ArrayList = []
            }
          }
        }
      })
      var plan
      drivers.forEach(function (e) {
        // console.log(e)
        if (e.orderD && e.orderD.length !== 0) {
          e.orderD.forEach(function (el) {
            if (el.isWork) {
              plan = self.getSagyoPlanFromDataRowAndDate(e, null, dayjs(el.sagyoYmd)) // 運行日に変更
              plan.delFlg = false
              plan.keikakuKakuteiFlg = e.keikakuKakuteiFlg
              plan.trSagyoMeisaiId2ArrayList.push(el.id)
            }
          })
        } else if (self.isValidCar(e.car)) {
          plan = self.getSagyoPlanFromDataRowAndDate(e, null, self.tekiyoYmdDayjs)
          plan.delFlg = false
          plan.keikakuKakuteiFlg = e.keikakuKakuteiFlg
          e.orderD = []
          e.isEqualUnkouYmdAndTekiyoYmd = true
        }
      })
      this.sagyoKeikaku = this.sagyoKeikaku.map(function (e) {
        e.trSagyoMeisaiId2Array = e.trSagyoMeisaiId2ArrayList.join(',')
        // 対応する行情報を探し更新フラグが立っていれば立てる
        const sameLines = self.getSameInfoRowsFromPlan(e, self.recDriver)
        if (sameLines.find((x) => {
          return x.updateFlg
        })) {
          e.updateFlg = true
        }
        if (e.delFlg) {
          e.updateFlg = true
        }
        return e
      })
      this.adjustSagyoKeikakuEdaNo()
      console.log('saveed 作業計画', this.sagyoKeikaku)
    },
    /**
     * 画面の情報をオーダ情報から作成する
     * ドライバー画面用
     */
    createDriverRecords () {
      console.log('order list', this.order)
      const self = this
      /* 画面に表示する情報をorderから作り上げる */
      /* ドライバが縦軸 */
      this.recDriver = []
      // isOnTrayの初期化
      this.keikakuSharyoList = this.keikakuSharyoList.map(function (e) {
        e.isOnTray = true
        return e
      })
      // this.keikakuSagyoMeisai = this.keikakuSagyoMeisai.map(function (e) {
      //   e.isOnTray = true
      //   return e
      // })
      // this.keikakuSagyoMeisai2 = this.keikakuSagyoMeisai2.map(function (e) {
      //   e.isOnTray = true
      //   return e
      // })
      this.sagyoKeikaku.forEach((e) => {
        if (e.dojoshaId === null && e.jomuinId === null) {
          // 表示されないオーダはonTrayをオフにする
          if (e.trSagyoMeisaiIdArrayList && e.trSagyoMeisaiIdArrayList.length > 0) {
            e.trSagyoMeisaiIdArrayList.forEach((e) => {
              const odr = self.getOrderFromOrderID(e)
              if (odr) {
                odr.isOnTray = false
              }
            })
          }
          if (e.trSagyoMeisaiId2ArrayList && e.trSagyoMeisaiId2ArrayList.length > 0) {
            e.trSagyoMeisaiId2ArrayList.forEach((e) => {
              const wrk = self.getWorkFromWorkID(e)
              if (wrk) {
                wrk.isOnTray = false
              }
            })
          }
        }
      })

      // if (this.usePager) {
      //   var pageDriver = this.keikakuJininList.slice((this.page - 1) * this.linesPerPage, (this.page - 1) * this.linesPerPage + this.linesPerPage)
      // } else {
      var pageDriver = this.keikakuJininList
      // }
      pageDriver.forEach(function (e) {
        var sagyoKeikakuList = self.getSagyoKeikakuFromDriverId(e.id)
        var odrList = self.mergeArraySagyoMeisaiId(sagyoKeikakuList)
        if ((!sagyoKeikakuList) || sagyoKeikakuList.length === 0 || odrList.length === 0) {
          // オーダーが割り当てられていないドライバ
          var l = self.setNewRecords({})
          l.driver = e
          l.updateFlg = false
          l.car = {}
          // var l = {
          //   id: self.getNewLineIdDriver(),
          //   trSKKId: null,
          //   car: {},
          //   orderD: [],
          //   driver: e,
          //   masterFlg: true,
          //   updateFlg: false,
          //   keikakuKakuteiFlg: false
          // }
          self.recDriver.push(l)
        } else {
          sagyoKeikakuList.forEach(function (ex) {
            if (e.id === ex.jomuinId) {
              var isMainDriver = true
            } else {
              isMainDriver = false
            }
            odrList = self.getSagyoMeisaiFromSagyoMeisaiIdList(ex.trSagyoMeisaiIdArrayList, ex.trSagyoMeisaiId2ArrayList)
            if (odrList.length === 0) {
              if (!self.recDriver.find((ez) => {
                return ez.driver.id === e.id
              })) {
                var l = self.setNewRecords({})
                l.driver = e
                l.updateFlg = false
                l.car = {}
                //       var l = {
                //   id: self.getNewLineIdDriver(),
                //   trSKKId: null,
                //   car: {},
                //   orderD: [],
                //   driver: e,
                //   masterFlg: true,
                //   updateFlg: false,
                //   keikakuKakuteiFlg: false
                // }
                self.recDriver.push(l)
              }
              return
            }
            var i
            var ncar = self.getCarFromCarid(ex.sharyoId)
            for (i = 0; i < odrList.length; i++) {
              var sIndex = self.searchSameLineOnDriver(odrList[i], e.id, ex.sharyoId)
              // var sIndex = self.searchSameLineOnDriver(i, odrList)
              if (isMainDriver) {
                odrList[i].mainDriverId = ex.jomuinId
              } else {
                odrList[i].subDriverId = ex.jomuinId
              }
              if (sIndex === -1) {
                odrList[i].isOnTray = false
                // var masterFlg = true
                // if (self.recDriver.find(function (ez) {
                //   return ez.driver.id === e.id
                // })) {
                //   masterFlg = false
                // }
                if (ncar) {
                  if (self.recDriver.find(function (ec) {
                    return (ec.driver.id !== e.id) && self.isValidCar(ec.car) && ec.car.id === ncar.id
                  })) {
                    const newRec = Object.assign({}, ncar)
                    ncar = newRec
                    // ncar.masterFlg = false
                  }
                  l = self.setNewRecords({})
                  l.driver = e
                  l.updateFlg = false
                  l.car = ncar
                  l.orderD = [odrList[i]]
                  // l.masterFlg = masterFlg
                  l.updateFlg = ex.updateFlg
                  l.keikakuKakuteiFlg = ex.keikakuKakuteiFlg
                  l.isEqualUnkouYmdAndTekiyoYmd = self.tekiyoYmdDayjs.isSame(dayjs(odrList[i].sagyoYmd), 'd')
                  //   l = {
                  //   id: self.getNewLineIdDriver(),
                  //   trSKKId: ex.id,
                  //   car: ncar,
                  //   orderD: [odrList[i]],
                  //   driver: e,
                  //   masterFlg: masterFlg,
                  //   updateFlg: ex.updateFlg,
                  //   keikakuKakuteiFlg: ex.keikakuKakuteiFlg
                  // }
                  self.recDriver.push(l)
                } else {
                  l = self.setNewRecords({})
                  l.driver = e
                  l.updateFlg = false
                  l.car = {}
                  l.orderD = [odrList[i]]
                  // l.masterFlg = masterFlg
                  l.updateFlg = ex.updateFlg
                  l.keikakuKakuteiFlg = ex.keikakuKakuteiFlg
                  l.isEqualUnkouYmdAndTekiyoYmd = self.tekiyoYmdDayjs.isSame(dayjs(odrList[i].sagyoYmd), 'd')
                  // l = {
                  //   id: self.getNewLineIdDriver(),
                  //   trSKKId: ex.id,
                  //   car: null,
                  //   orderD: [odrList[i]],
                  //   driver: e,
                  //   masterFlg: masterFlg,
                  //   updateFlg: ex.updateFlg,
                  //   keikakuKakuteiFlg: ex.keikakuKakuteiFlg
                  // }
                  self.recDriver.push(l)
                }
              } else {
                odrList[i].isOnTray = false
                self.recDriver[sIndex].orderD.push(odrList[i])
                if (self.recDriver[sIndex].updateFlg === false) {
                  self.recDriver[sIndex].updateFlg = ex.updateFlg
                }
                if (self.recDriver[sIndex].keikakuKakuteiFlg === false) {
                  self.recDriver[sIndex].keikakuKakuteiFlg = ex.keikakuKakuteiFlg
                }
                if (self.recDriver[sIndex].isEqualUnkouYmdAndTekiyoYmd === null) {
                  self.recDriver[sIndex].isEqualUnkouYmdAndTekiyoYmd = self.tekiyoYmdDayjs.isSame(dayjs(odrList[i].sagyoYmd), 'd')
                }
              }
            }
          })
        }
      })
      console.log('disp drivers', this.recDriver, this.keikakuSagyoMeisai)
      this.redrawWorksTray()
    },
    /**
     * recCarに同じ行（オーダーを入れる行）があるかを調べる
     */
    searchSameLineOnCar (odr, carId, driverId, subDriverId, jomuinKakuteiFlg, dojoshaKakuteiFlg) {
      const self = this
      // 表示時間外のオーダはマスタフラグが立っている行に入れる
      // マスタフラグは関係ないことに
      const dispStart = this.tekiyoYmdDayjs.clone()
      const dispEnd = dispStart.add(this.hours, 'h')
      if (odr.hatsuchiDayjs.isBefore(dispEnd) && dispStart.isBefore(odr.chakuchiDayjs)) {
      } else {
        // 表示時間外
        const target = this.recCar.find((e) => {
          var ret = false
          if (e.car.id === carId) {
            // 同じ行を探す
            if (self.isValidDriver(e.driver)) {
              if (e.driver.id === driverId && e.jomuinKakuteiFlg === jomuinKakuteiFlg) {
                ret = true
              }
            } else {
              if (driverId === null) {
                ret = true
              }
            }
            if (ret) {
              if (self.isValidDriver(e.subDriver)) {
                if (e.subDriver.id === subDriverId && e.dojoshaKakuteiFlg === dojoshaKakuteiFlg) {
                  ret = true
                } else {
                  ret = false
                }
              } else {
                if (subDriverId === null) {
                  ret = true
                } else {
                  ret = false
                }
              }
            }
          }
          if (ret) {
            if (odr.isWork !== self.isWorksLine(e.orderD)) {
              ret = false
            }
          }
          // 適用日と運行日と同じのは同じ行に
          if (ret) {
            if (self.tekiyoYmdDayjs.isSame(dayjs(odr.sagyoYmd), 'd')) {
              if (!e.isEqualUnkouYmdAndTekiyoYmd) {
                ret = false
              }
            } else {
              if (e.isEqualUnkouYmdAndTekiyoYmd) {
                ret = false
              }
            }
          }
          return ret
        // }).find((e) => {
        //   return e.masterFlg === true
        })
        if (target) {
          return self.getCarDataIndexFromLineID(target.id)
        } else {
          return -1
        }
      }

      // if (index === 0) {
      //   return -1
      // }
      // 1枠に1オーダにか入らないため配置枠の最初の時間と最後の時間に設定する
      const [hs, he] = this.adjustTimeForOverlop(odr)
      // varでないとダメ？
      var target = this.recCar.filter((e) => {
        var ret = false
        if (e.car.id === carId) {
          // 同じ行を探す
          if (self.isValidDriver(e.driver)) {
            if (e.driver.id === driverId && e.jomuinKakuteiFlg === jomuinKakuteiFlg) {
              ret = true
            }
          } else {
            if (driverId === null) {
              ret = true
            }
          }
          if (ret) {
            if (self.isValidDriver(e.subDriver)) {
              if (e.subDriver.id === subDriverId && e.dojoshaKakuteiFlg === dojoshaKakuteiFlg) {
                ret = true
              } else {
                ret = false
              }
            } else {
              if (subDriverId === null) {
                ret = true
              } else {
                ret = false
              }
            }
          }
          if (ret) {
            if (odr.isWork !== self.isWorksLine(e.orderD)) {
              ret = false
            }
          }
          // 適用日と運行日と同じのは同じ行に
          if (ret) {
            if (self.tekiyoYmdDayjs.isSame(dayjs(odr.sagyoYmd), 'd')) {
              if (!e.isEqualUnkouYmdAndTekiyoYmd) {
                ret = false
              }
            } else {
              if (e.isEqualUnkouYmdAndTekiyoYmd) {
                ret = false
              }
            }
          }
          if (ret === false) {
            // 完全に空いている行はある？
            if (!self.isValidDriver(e.driver) && !self.isValidDriver(e.subDriver) &&
                (!e.orderD || e.orderD.length === 0)) {
              return true
            }
          }
        }
        return ret
      })
      if (!target || target.length === 0) {
        return -1
      }
      var i
      for (i = 0; i < target.length; i++) {
        if (target[i].orderD.length === 0) {
          return this.getCarDataIndexFromLineID(target[i].id)
        }
        var noovFlg = true
        var j
        for (j = 0; j < target[i].orderD.length; j++) {
          if (this.checkTimeOverlap(target[i].orderD[j].hatsuchiDayjs, target[i].orderD[j].chakuchiDayjs, hs, he) === true) {
          } else {
            noovFlg = false
            break
          }
        }
        if (noovFlg === true) {
          return this.getCarDataIndexFromLineID(target[i].id)
        }
      }
      return -1
    },
    adjustTimeForOverlopTime (hsi, hei) {
      // 1枠に1オーダにか入らないため配置枠の最初の時間と最後の時間に設定する
      var hs = hsi.clone()
      hs = hs.minute(0)
      var hh = hs.hour()
      hh = hh - this.tableStartHour
      hh = (hh < 0) ? hh + 24 : hh
      var modh = hh % this.hoursInterval
      hh = hs.hour() - modh
      hs = hs.hour(hh)

      var he = hei.clone()
      if (he.minute() > 0) {
        he = he.hour(he.hour() + 1)
        he = he.minute(0)
      }

      hh = he.hour()
      hh = hh - this.tableStartHour
      hh = (hh < 0) ? hh + 24 : hh
      modh = hh % this.hoursInterval
      hh = he.hour() + ((modh === 0) ? 0 : (this.hoursInterval - modh))
      he = he.hour(hh)
      return [hs, he]
    },
    adjustTimeForOverlop (order) {
      return this.adjustTimeForOverlopTime(order.hatsuchiDayjs, order.chakuchiDayjs)
    },
    // searchSameLineOnDriver (index, odrList) {
    searchSameLineOnDriver (order, driverId, carId) {
      const [hs, he] = this.adjustTimeForOverlop(order)
      // if (index === 0) {
      //   return -1
      // }
      // var j
      // for (j = 0; j < index; j++) {
      //   // 時間が重なっているか、車両が違えば別の行
      //   // if (this.checkTimeOverlap(odrList[index].hatsuchiDayjs, odrList[index].chakuchiDayjs,
      //   //   odrList[j].hatsuchiDayjs, odrList[j].chakuchiDayjs) === true &&
      //   //   odrList[j].carid === odrList[index].carid) {
      //   //   return j
      //   // }
      //   if (this.checkTimeOverlap(odrList[index].hatsuchiDayjs, odrList[index].chakuchiDayjs,
      //     odrList[j].hatsuchiDayjs, odrList[j].chakuchiDayjs) === true) {
      //     return j
      //   }
      //   return -1
      // }
      // return this.searchSameLineOnCar(index, odrList)
      // recDriverから検索することに変更
      const self = this
      const target = this.recDriver.filter((e) => {
        var ret
        ret = e.driver.id === driverId &&
          ((self.isValidCar(e.car) && e.car.id === carId) ||
          (!self.isValidCar(e.car) && carId === null))
        if (ret) {
          if (order.isWork !== self.isWorksLine(e.orderD)) {
            ret = false
          }
        }
        // 適用日と運行日と同じのは同じ行に
        if (ret) {
          if (self.tekiyoYmdDayjs.isSame(dayjs(order.sagyoYmd), 'd')) {
            if (!e.isEqualUnkouYmdAndTekiyoYmd) {
              ret = false
            }
          } else {
            if (e.isEqualUnkouYmdAndTekiyoYmd) {
              ret = false
            }
          }
        }
        return ret
      })
      if (!target || target.length === 0) {
        return -1
      }
      var i
      for (i = 0; i < target.length; i++) {
        if (target[i].orderD.length === 0) {
          return this.getDriverDataIndexFromLineID(target[i].id)
        }
        var noovFlg = true
        var j
        for (j = 0; j < target[i].orderD.length; j++) {
          if (this.checkTimeOverlap(target[i].orderD[j].hatsuchiDayjs, target[i].orderD[j].chakuchiDayjs, hs, he) === true) {
          } else {
            noovFlg = false
            break
          }
        }
        if (noovFlg === true) {
          return this.getDriverDataIndexFromLineID(target[i].id)
        }
      }
      return -1
    },
    /**
     * DBから読みだした作業計画をindexedDBから読んだデータでマージする
     * TODO 検索条件もここで->仮対応
     * @param [{}] tempSavedData: indexedDBから読みだしたデータ
     */
    mergeSagyoKeikakuFromIndexedDb () {
      const self = this
      console.log('merging... ', this.tempSavedDataPlanFromIndexDb)
      if (this.tempSavedDataPlanFromIndexDb && this.tempSavedDataPlanFromIndexDb.length > 0) {
        this.tempSavedDataPlanFromIndexDb.forEach((e) => {
          e.useFlg = false
        })
        const tomerge = this.tempSavedDataPlanFromIndexDb.filter((e) => {
          const dt = dayjs(e.sagyoYoteiYmd)
          if (!dt.isBetween(self.conditions.sagyoYoteiYmdFrom,
            self.conditions.sagyoYoteiYmdTo, 'day', '[]')) {
            return false
          }
          if (e.haishaShashuSbt !== self.conditions.haishaShashuSbt) {
            return false
          }
          if (self.conditions.eigyoshoCd) {
            if (e.eigyoshoId !== this.getEigyoshoId(self.conditions.eigyoshoCd)) {
              return false
            }
          }
          // serchの100で行ってる絞込と同様なことを行う
          return true
        })
        var deleteWork = []
        tomerge.forEach((e) => {
          // 同じIDの行があるか調べる
          const r = this.sagyoKeikaku.find((eorig) => {
            return eorig.id === e.id
          })
          // 一時保存とDBを比べて新しいものを採用する
          if (r) {
            if (dayjs(e.updDateI).isAfter(dayjs(r.updDateI))) {
              // あった
              // 置き換える
              Object.assign(r, e)
              e.useFlg = true
              e.updateFlg = true
            } else {
              // サーバ側が新しいので一時保存から削除する
              deleteWork.push(e.id)
            }
          } else {
            e.useFlg = true
            // なかったら追加
            e.updateFlg = true
            this.sagyoKeikaku.push(e)
          }
        })
        this.tempSavedDataPlanFromIndexDb = this.tempSavedDataPlanFromIndexDb.filter((e) => {
          // 既にサーバに更新されたデータがあってindexedDBのはつかわなかったのなら削除しておく
          return deleteWork.indexOf(e.id) === -1
        })
      }
      if (this.tempSavedDataSagyoFromIndexDb && this.tempSavedDataSagyoFromIndexDb.length > 0) {
        console.log('WORK', this.tempSavedDataSagyoFromIndexDb)
        this.tempSavedDataSagyoFromIndexDb.forEach((e) => {
          // 同じIDの行があるか調べる
          const r = this.keikakuSagyoMeisai.find((eorig) => {
            return eorig.id === e.id
          })
          console.log('merging ', e)
          e.hatsuchiDayjs = dayjs(e.hatsuchiYmd + ' ' + e.hatsuchiHms)
          e.chakuchiDayjs = dayjs(e.chakuchiYmd + ' ' + e.chakuchiHms)
          if (r) {
            if (!r.updDateI || dayjs(e.updDateI).isAfter(dayjs(r.updDateI))) {
              // あった
              // 置き換える
              Object.assign(r, e)
            } else {
              e.updateFlg = false
              e.delFlg = true
            }
          } else {
            // なかったら追加 -- かならずあるはず。。。なかったら削除されている？
            // ない場合は他の計画で使われたので表示されなくていい
            // this.keikakuSagyoMeisai.push(e)
            e.updateFlg = false
            e.delFlg = true
          }
        })
        this.tempSavedDataSagyoFromIndexDb = this.tempSavedDataSagyoFromIndexDb.filter((e) => {
          return e.updateFlg === true || e.delFlg === false
        })
      }
      if (this.tempSavedDataWorkFromIndexDb && this.tempSavedDataWorkFromIndexDb.length > 0) {
        this.tempSavedDataWorkFromIndexDb.forEach((e) => {
          // 同じIDの行があるか調べる
          const r = this.keikakuSagyoMeisai2.find((eorig) => {
            return eorig.id === e.id
          })
          e.startDayjs = dayjs(e.startYmd + ' ' + e.startHms)
          e.endDayjs = dayjs(e.endYmd + ' ' + e.endHms)
          e.hatsuchiDayjs = e.startDayjs.clone()
          e.chakuchiDayjs = e.endDayjs.clone()
          if (r) {
            if (!r.updDateI || dayjs(e.updDateI).isAfter(dayjs(r.updDateI))) {
              // あった
              // 置き換える
              Object.assign(r, e)
            } else {
              e.updateFlg = false
              e.delFlg = true
            }
          } else {
            // なかったら追加 -- かならずあるはず。。。なかったら削除されている？
            e.updateFlg = false
            e.delFlg = true
            // this.keikakuSagyoMeisai2.push(e)
          }
        })
        this.tempSavedDataWorkFromIndexDb = this.tempSavedDataWorkFromIndexDb.filter((e) => {
          return e.updateFlg === true || e.delFlg === false
        })
      }
    },
    // #endregion
    // #region チップ操作関係
    returnToTrayDriver (rowId, xType, isnotDelete = false, toRowId = -1) {
      const self = this
      var fromIndex = this.getCarDataIndexFromLineID(rowId)
      // console.log('return tray -', rowId, fromIndex, self.recCar[fromIndex], self.recCar[fromIndex].driver)
      // console.log('return tray -', self.recCar[fromIndex].driver.id)
      var hitDrx = this.keikakuJininList.find(function (elem) {
        return (xType === 'main' && Number(elem.id) === Number(self.recCar[fromIndex].driver.id)) ||
               (xType === 'sub' && Number(elem.id) === Number(self.recCar[fromIndex].subDriver.id))
      })
      if (hitDrx === null) {
        // ありえないけど、画面に残骸のチケットがあるときになるかも
        console.log('buggy...')
        self.redrawSharyo1Line(fromIndex, true)
        return
      }
      var hitCar = self.recCar[fromIndex].car
      // console.log('right', this.filteredRows)
      // もし同じドライバーが他の車にもいたらそれも消す
      // var carOnDriverList = this.recCar.filter(function (e) {
      //   return Number(e.driver.id) === hitDrx.id
      // })
      console.log('return tray--', hitDrx)
      // if (hitDrx.masterFlg === true) {
      //   self.setDriverOnTray(hitDrx, true)
      // }
      var deleteList = []
      if (xType === 'main') {
        // const subDrx = self.recCar[fromIndex].subDriver
        for (var i = 0; i < self.recCar.length; i++) {
          if (self.isValidDriver(self.recCar[i].driver) && self.recCar[i].driver.id === hitDrx.id && self.recCar[i].car.id === hitCar.id) {
            // if (self.isWorksLine(self.recCar[i].orderD) === true && (self.isWorksLine(self.recCar[fromIndex].orderD) === true || !self.isValidDriver(subDrx))) {
            //   // 指定行が作業で、同じ車で、乗務員が同じで、作業の行か、受注の行で同乗者いない
            //   var doFlg = true
            // } else if (self.isWorksLine(self.recCar[i].orderD) === false && (self.isWorksLine(self.recCar[fromIndex].orderD) === false || !self.isValidDriver(self.recCar[i].subDriver))) {
            //   // 指定行が受注で、同じ車で、乗務員が同じで、受注の行か、作業の行で指定行に同乗者いない
            //   doFlg = true
            // } else {
            //   doFlg = false
            // }
            if (self.recCar[i].jomuinKakuteiFlg === self.recCar[fromIndex].jomuinKakuteiFlg && self.isWorksLine(self.recCar[i].orderD) === self.isWorksLine(self.recCar[fromIndex].orderD)) {
              var doFlg = true
            } else {
              doFlg = false
            }
            if (doFlg) {
              // 削除する

              self.recCar[i].driver = {}
              // if (!this.recCar[i].masterFlg && this.recCar[i].orderD.length === 0 && !self.isValidDriver(self.recCar[i].subDriver)) {
              if (!this.isOnlyLineSharyo(this.recCar[i]) && this.recCar[i].orderD.length === 0 && !self.isValidDriver(self.recCar[i].subDriver)) {
                // オーダもない行は行ごと消す
                deleteList.unshift({ index: i, delete: true })
              } else {
                deleteList.unshift({ index: i, delete: false })
              }
            }
          }
        }
      } else {
        var mainDriverId = null
        if (self.recCar[fromIndex].driver && self.recCar[fromIndex].driver.id) {
          mainDriverId = self.recCar[fromIndex].driver.id
        }
        for (i = 0; i < self.recCar.length; i++) {
          if ((mainDriverId === null || (self.isValidDriver(self.recCar[i].driver) && mainDriverId === self.recCar[i].driver.id)) && self.isValidDriver(self.recCar[i].subDriver) && self.recCar[i].subDriver.id === hitDrx.id && self.recCar[i].car.id === hitCar.id && self.recCar[i].dojoshaKakuteiFlg === self.recCar[fromIndex].dojoshaKakuteiFlg) {
            // 削除する
            self.recCar[i].subDriver = {}
            // if (!this.recCar[i].masterFlg && this.recCar[i].orderD.length === 0) {
            if (!this.isOnlyLineSharyo(this.recCar[i]) && this.recCar[i].orderD.length === 0) {
              if (!self.isValidDriver(self.recCar[i].driver)) {
                // オーダもない行は行ごと消す
                deleteList.unshift({ index: i, delete: true })
              } else {
                var hitf = false
                for (var j = 0; j < i; j++) {
                  if (this.recCar[i].car.id === this.recCar[j].car.id &&
                      this.isValidDriver(this.recCar[j].driver) && this.recCar[i].driver.id === this.recCar[j].driver.id) {
                    hitf = true
                    break
                  }
                }
                if (hitf) {
                  deleteList.unshift({ index: i, delete: true })
                } else {
                  deleteList.unshift({ index: i, delete: false })
                }
              }
            } else {
              deleteList.unshift({ index: i, delete: false })
            }
          }
        }
      }
      deleteList.forEach(function (e) {
        self.setUpdateFlg(e.index, USE_DATAINDEX)
        // あとで同一されそうな行の更新フラグは立てておく
        const x = self.getSameDriverAndCar(self.recCar[e.index], self.recCar, hitDrx)
        x.forEach((eh) => {
          eh.updateFlg = true
        })
        if (self.recCar[e.index].id !== toRowId) {
          // D＆Dで目的行が削除対象の場合は削除もredrawもしない
          if (e.delete && isnotDelete === false) {
            self.recCar.splice(e.index, 1)
          } else {
            self.redrawSharyo1Line(e.index, true)
          }
        }
      })
      // 20220401
      // if (!self.upgradeOtherDriver(hitDrx)) {
      //   self.setDriverOnTray(hitDrx, true)
      // }
      // 削除後にこの乗務員の配置数が０だったらトレイに戻す
      if (self.getCountDriver(null, self.recCar, hitDrx, 'main') === 0) {
        self.setDriverOnTray(hitDrx, true)
      }
      console.log('tar returned ', this.recCar, fromIndex)
    },
    /**
     * @deprecated 車両を戻す方法はない
     */
    returnToTrayCar (rowId) {
      // const self = this
      // var fromIndex = this.getDriverDataIndexFromLineID(rowId)
      // // console.log('return tray -', rowId, fromIndex, self.recCar[fromIndex], self.recCar[fromIndex].driver)
      // // console.log('return tray -', self.recCar[fromIndex].driver.id)
      // var hitCar = this.keikakuSharyoList.find(function (elem) {
      //   return Number(elem.id) === Number(self.recDriver[fromIndex].car.id)
      // })
      // console.log('return tray--', hitCar, self.recDriver[fromIndex].car.id, rowId, self.recDriver, this.sharyo)
      // if (hitCar.masterFlg === true) {
      //   self.setCarOnTray(hitCar, true)
      // }
      // var deleteList = []
      // for (var i = 0; i < self.recDriver.length; i++) {
      //   if (self.recDriver[i].car.id === hitCar.id) {
      //     // 削除する
      //     self.recDriver[i].car = {}
      //     if (!this.recDriver[i].masterFlg && this.recDriver[i].orderD.length === 0) {
      //       // オーダもない行は行ごと消す
      //       deleteList.unshift({ index: i, delete: true })
      //     } else {
      //       deleteList.unshift({ index: i, delete: false })
      //     }
      //   }
      // }
      // deleteList.forEach(function (e) {
      //   self.setUpdateFlg(e.index, USE_DATAINDEX)
      //   if (e.delete) {
      //     self.recDriver.splice(e.index, 1)
      //   } else {
      //     self.redrawDriver1Line(e.index, true)
      //   }
      // })
      // console.log('tar returned ', this.recCar, fromIndex)
    },
    /**
     * 受注または作業をトレイに戻す
     */
    returnToTrayOrder (orderTicket, rowId, noDeleteFlag = false) {
      const self = this
      var fromIndex
      var disp1rec
      var deleteIndex = []
      var i = 0
      if (this.viewMode === 0) {
        fromIndex = this.getCarDataIndexFromLineID(rowId)
        disp1rec = this.recCar[fromIndex]
      } else {
        fromIndex = this.getDriverDataIndexFromLineID(rowId)
        disp1rec = this.recDriver[fromIndex]
      }

      // オーダー情報がないときは無視
      if (!Array.isArray(disp1rec.orderD)) {
        return disp1rec.id
      } else {
        if (disp1rec.orderD.length === 0) {
          return disp1rec.id
        }
      }

      // オーダーがあったら削除する
      disp1rec.orderD.forEach(function (el) {
        if (el.id === orderTicket.id) {
          orderTicket.trSagyoKeikakuMeisaiId = null
          deleteIndex.unshift(i)
        }
        i++
      })
      console.log('will delete　id', deleteIndex)
      deleteIndex.forEach(function (e) {
        disp1rec.orderD.splice(e, 1)
      })

      var deleteFlg = false
      if (this.viewMode === 0) {
        // if (!this.recCar[fromIndex].masterFlg && this.recCar[fromIndex].orderD.length === 0) {
        if (!this.isOnlyLineSharyo(this.recCar[fromIndex]) && this.recCar[fromIndex].orderD.length === 0) {
          if (this.isValidDriver(this.recCar[fromIndex].driver)) {
            // 他の行に同じドライバがいたら削除
            var r = this.recCar.filter(function (e) {
              return self.isValidDriver(e.driver) && e.driver.id === self.recCar[fromIndex].driver.id && e.id !== self.recCar[fromIndex].id
            })
            if (r.length > 0) {
              deleteFlg = true
              r.forEach((x) => {
                x.updateFlg = true
              })
            }
          } else {
            // 行ごと削除
            deleteFlg = true
            this.recCar.filter((x) => {
              return x.car.id === self.recCar[fromIndex].car.id && x.id !== self.recCar[fromIndex].id
            }).forEach((x) => {
              x.updateFlg = true
            })
          }
        }
        self.setUpdateFlg(fromIndex, USE_DATAINDEX)
        if (deleteFlg && noDeleteFlag === false) {
          this.recCar.splice(fromIndex, 1)
        } else {
          return this.redrawSharyo1Line(fromIndex, true)
        }
      } else {
        // if (!this.recDriver[fromIndex].masterFlg && this.recDriver[fromIndex].orderD.length === 0) {
        if (!this.isOnlyLineDriver(this.recDriver[fromIndex]) && this.recDriver[fromIndex].orderD.length === 0) {
          if (this.isValidCar(this.recDriver[fromIndex].car)) {
            // 他の行に同じ車両がいたら削除
            r = this.recDriver.filter(function (e) {
              return e.car.id === self.recDriver[fromIndex].car.id && e.id !== self.recDriver[fromIndex].id
            })
            if (r.length > 0) {
              deleteFlg = true
              r.forEach((x) => {
                x.updateFlg = true
              })
            }
          } else {
            // 行ごと削除
            deleteFlg = true
            this.recDriver.filter((x) => {
              return x.driver.id === self.recDriver[fromIndex].driver.id && x.id !== self.recDriver[fromIndex].id
            }).forEach((x) => {
              x.updateFlg = true
            })
          }
        }
        console.log('will delete this line', fromIndex, deleteFlg)
        self.setUpdateFlg(fromIndex, USE_DATAINDEX)
        if (deleteFlg && noDeleteFlag === false) {
          this.recDriver.splice(fromIndex, 1)
        } else {
          return this.redrawDriver1Line(fromIndex, true)
        }
      }
      // orderTicket.carid = 0
      // orderTicket.driverid = 0
      return disp1rec.id
    },
    returnToTrayWork (orderTicket, rowId, noDeleteFlag = false) {
      return this.returnToTrayOrder(orderTicket, rowId, noDeleteFlag)
    },
    /**
     * 配車表に乗務員を割り付ける
     * @param {}} fromDriver 割り付ける乗務員
     * @param {*} toRowId 挿入先の行ID
     * @param {*} copyMode true: コピーモード
     * @param {*} xType 'main': 乗務員 'sub':同乗者
     * @param {*} carPasteMode true: 車両に対して貼り付け行った
     * @returns none
     */
    addToGridFromTrayDriver (fromDriver, toRowId, copyMode = false, xType, carPasteMode = false) {
      const self = this
      console.log('add grid from tray', self.recCar, toRowId)
      var sIndex = this.getCarDataIndexFromLineID(toRowId)
      const workLineFlg = this.isWorksLine(self.recCar[sIndex].orderD)
      var carList
      // carListには、同じドライバを設定する行が入る
      // 具体的には乗務員の場合、同じ車両で乗務員が空きの行
      if (xType === 'main') {
        carList = this.recCar.filter(function (e) {
          return e.car.id === self.recCar[sIndex].car.id && !self.isValidDriver(e.driver) && workLineFlg === self.isWorksLine(e.orderD)
        })
      } else {
        carList = this.recCar.filter(function (e) {
          if (!self.compareSameDriver(e.driver, self.recCar[sIndex].driver)) {
            return false
          } else {
            return e.car.id === self.recCar[sIndex].car.id && !self.isValidDriver(e.subDriver) && workLineFlg === self.isWorksLine(e.orderD)
          }
        })
      }
      var dataDriver = {}
      // 20220401
      dataDriver = fromDriver
      // if (copyMode || this.isHasMasterCar(fromDriver)) {
      //   dataDriver = Object.assign({}, fromDriver)
      //   // dataDriver.masterFlg = false
      // } else {
      //   dataDriver = fromDriver
      // }

      if (xType === 'main') {
        if (carPasteMode) {
          carList = this.recCar.filter(function (e) {
            return e.car.id === self.recCar[sIndex].car.id
          })
          // 指定の乗務員で同乗者がなしの行があればなにもしな
          if (carList.find((x) => {
            return self.isValidDriver(x.driver) && x.driver.id === dataDriver.id && !self.isValidDriver(x.subDriver)
          })) {
            // みつかった
            return
          }
          // 両方空の行があればそこに入れる
          const fl = carList.filter((x) => {
            return !self.isValidDriver(x.driver) && !self.isValidDriver(x.subDriver)
          })
          if (fl && fl.length > 0) {
            // if (!copyMode) {
            self.setDriverOnTray(fromDriver, false)
            // }
            // 空の行は普通一個しかないが一応
            for (var i = fl.length - 1; i >= 0; i--) {
              const dataIndex = self.getCarDataIndexFromLineID(fl[i].id)
              self.setUpdateFlg(dataIndex, USE_DATAINDEX)
              fl[i].driver = fromDriver
              self.redrawSharyo1Line(dataIndex, true)
            }
          } else {
            // 空の行がないので、挿入する
            var newRec = Object.assign({}, this.recCar[sIndex])
            newRec = this.setNewRecords(newRec)
            newRec.driver = dataDriver
            newRec.subDriver = {}
            // if (!copyMode) {
            this.setDriverOnTray(fromDriver, false)
            // }
            this.recCar.push(newRec)
            self.setUpdateFlg(sIndex, USE_DATAINDEX)
            this.redrawSharyo1Line(sIndex, true)
          }
        } else if (this.isValidDriver(this.recCar[sIndex].driver)) {
          if (!this.recCar[sIndex].jomuinKakuteiFlg) {
            if (fromDriver.id === this.recCar[sIndex].driver.id) {
              // 同じドライバがドロップされても何もしない
              this.redrawSharyo1Line(sIndex, true)
              return
            }
            // 同じ車にすでに同じドライバいて、入れた行の同乗者が同じならなにもしない
            const t = this.recCar.find((eu) => {
              return eu.car.id === self.recCar[sIndex].car.id && eu.driver.id === fromDriver.id && (
                self.compareSameDriver(eu.subDriver, self.recCar[sIndex].subDriver))
            })
            if (t) {
              this.redrawSharyo1Line(sIndex, true)
              return
            }
          }
          console.log('add new line', this.recCar[sIndex].driver)
          // 既にドライバが存在するときは行を増やす
          newRec = Object.assign({}, this.recCar[sIndex])
          var copy = { ...newRec.subDriver }
          // copy.masterFlg = false 20220401
          newRec = this.setNewRecords(newRec)
          newRec.driver = dataDriver
          newRec.subDriver = copy
          // newRec.id = this.getNewLineIdCar()
          // newRec.orderD = []
          // newRec.driver = dataDriver
          // newRec.subDriver = copy
          // newRec.masterFlg = false
          // newRec.keikakuKakuteiFlg = false
          // newRec.jissekiStatus = '0'
          // newRec.updateFlg = true
          // if (!copyMode) {
          this.setDriverOnTray(fromDriver, false)
          // }
          this.recCar.push(newRec)
          self.setUpdateFlg(sIndex, USE_DATAINDEX)
          this.redrawSharyo1Line(sIndex, true)
        } else {
          // 空のcarListにあるのには全部同じドライバを設定する
          console.log('change driver', carList)
          // if (!copyMode) {
          self.setDriverOnTray(fromDriver, false)
          // }
          // carList.reverse().forEach(function (e) {
          //   // 行的に後ろからやらないと前のDOMの書き換えが行われなくなる..
          for (i = carList.length - 1; i >= 0; i--) {
            const dataIndex = self.getCarDataIndexFromLineID(carList[i].id)
            self.setUpdateFlg(dataIndex, USE_DATAINDEX)
            if (i !== 0) {
              copy = { ...dataDriver }
              // copy.masterFlg = false 20220401
              carList[i].driver = copy
              copy = { ...carList[i].subDriver }
              // copy.masterFlg = false 20220401
              carList[i].subDriver = copy
            } else {
              copy = dataDriver
              carList[i].driver = copy
            }
            self.redrawSharyo1Line(dataIndex, true)
          }
        }
      } else {
        if (carPasteMode) {
          carList = this.recCar.filter(function (e) {
            return e.car.id === self.recCar[sIndex].car.id
          })
          // 指定の乗務員で同乗者がなしの行があればなにもしな
          if (carList.find((x) => {
            return self.isValidDriver(x.subDriver) && x.subDriver.id === dataDriver.id && !self.isValidDriver(x.driver)
          })) {
            // みつかった
            return
          }
          // 両方空の行があればそこに入れる
          const fl = carList.filter((x) => {
            return !self.isValidDriver(x.driver) && !self.isValidDriver(x.subDriver) && !self.isWorksLine(x.orderD)
          })
          if (fl && fl.length > 0) {
            // if (!copyMode) {
            self.setDriverOnTray(fromDriver, false)
            // }
            // 空の行は普通一個しかないが一応
            for (i = fl.length - 1; i >= 0; i--) {
              const dataIndex = self.getCarDataIndexFromLineID(fl[i].id)
              self.setUpdateFlg(dataIndex, USE_DATAINDEX)
              fl[i].subDriver = fromDriver
              self.redrawSharyo1Line(dataIndex, true)
            }
          } else {
            // 空の行がないので、挿入する
            newRec = Object.assign({}, this.recCar[sIndex])
            newRec = this.setNewRecords(newRec)
            newRec.subDriver = dataDriver
            newRec.driver = {}
            // if (!copyMode) {
            this.setDriverOnTray(fromDriver, false)
            // }
            this.recCar.push(newRec)
            self.setUpdateFlg(sIndex, USE_DATAINDEX)
            this.redrawSharyo1Line(sIndex, true)
          }
        } else if (this.isValidDriver(this.recCar[sIndex].subDriver)) {
          if (!this.recCar[sIndex].dojoshaKakuteiFlg) {
            if (fromDriver.id === this.recCar[sIndex].subDriver.id) {
              // 同じドライバがドロップされても何もしない
              this.redrawSharyo1Line(sIndex, true)
              return
            }
          }
          console.log('add new line', this.recCar[sIndex].subDriver)
          // 既にドライバが存在するときは行を増やす
          newRec = Object.assign({}, this.recCar[sIndex])
          copy = { ...newRec.driver }
          // copy.masterFlg = false 20220401
          newRec = this.setNewRecords(newRec)
          newRec.driver = copy
          newRec.subDriver = dataDriver
          // newRec.id = this.getNewLineIdCar()
          // newRec.orderD = []
          // newRec.masterFlg = false
          // newRec.keikakuKakuteiFlg = false
          // newRec.jissekiStatus = '0'
          // newRec.updateFlg = true
          // if (!copyMode) {
          this.setDriverOnTray(fromDriver, false)
          // }
          this.recCar.push(newRec)
          self.setUpdateFlg(sIndex, USE_DATAINDEX)
          this.redrawSharyo1Line(sIndex, true)
        } else {
          // 空のcarListにあるのには全部同じドライバを設定する
          console.log('change driver', carList)
          // if (!copyMode) {
          this.setDriverOnTray(fromDriver, false)
          // }
          carList.forEach(function (e) {
            if (!e.isWork) {
              const dataIndex = self.getCarDataIndexFromLineID(e.id)
              self.setUpdateFlg(dataIndex, USE_DATAINDEX)

              e.subDriver = dataDriver
              self.redrawSharyo1Line(dataIndex, true)
            }
          })
        }
      }
    },
    addToGridFromTrayCar (fromCar, toRowId) {
      const self = this
      console.log('add grid from tray')
      var sIndex = this.getDriverDataIndexFromLineID(toRowId)
      var driverList = this.recDriver.filter(function (e) {
        return e.driver.id === self.recDriver[sIndex].driver.id && !self.isValidCar(e.car)
      })
      if (this.isValidCar(this.recDriver[sIndex].car)) {
        console.log('add new line', this.recDriver[sIndex].car)
        // 既に車両が存在するときは行を増やす
        var newRec = Object.assign({}, this.recDriver[sIndex])
        newRec = this.setNewRecords(newRec)
        newRec.car = fromCar
        // newRec.id = this.getNewLineIdDriver()
        // newRec.orderD = []
        // newRec.masterFlg = false
        this.setCarOnTray(fromCar, false)
        this.recDriver.push(newRec)
        self.setUpdateFlg(sIndex, USE_DATAINDEX)
        this.redrawDriver1Line(sIndex, true)
      } else {
        // 空のcarListにあるのには全部同じドライバを設定する
        console.log('change car', driverList)
        driverList.forEach(function (e) {
          e.car = fromCar
          const dataIndex = self.getDriverDataIndexFromLineID(e.id)
          self.setUpdateFlg(dataIndex, USE_DATAINDEX)
          self.redrawDriver1Line(dataIndex, true)
        })
      }
      // var newRec = this.recCar[sIndex].clone()
    },
    addToGridFromTrayOrder (fromOrder, rowId) {
      // const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
      // dayjs.extend(isSameOrAfter)
      // const self = this
      var fromIndex
      var disp1rec
      var i = 0
      fromOrder.isSelected = false
      if (this.viewMode === 0) {
        fromIndex = this.getCarDataIndexFromLineID(rowId)
        disp1rec = this.recCar[fromIndex]
      } else {
        fromIndex = this.getDriverDataIndexFromLineID(rowId)
        disp1rec = this.recDriver[fromIndex]
        if (this.isValidCar(disp1rec.car)) {
          // ドラッグ先に車がある場合は空の車両の行の場所に
          disp1rec = { ...disp1rec }
          disp1rec.car = null
          const tr = this.getRowDataAsSameList(disp1rec)
          if (tr && tr.length > 0) {
            disp1rec = tr[0]
          } else {
            // なかったら作成
            disp1rec.id = this.getNewLineIdDriver()
            disp1rec.orderD = []
            disp1rec.isEqualUnkouYmdAndTekiyoYmd = true
            this.recDriver.push(disp1rec)
          }
          this.redrawDriver1Line(fromIndex, true)
          fromIndex = this.getDriverDataIndexFromLineID(disp1rec.id)
        }
      }

      if (!Array.isArray(disp1rec.orderD) || disp1rec.orderD.length === 0) {
        if (fromOrder.isWork) {
          // if (this.isValidDriver(disp1rec.subDriver) && disp1rec.subDriver.masterFlg) {
          if (this.isMasterDriverThisPostion(disp1rec, 'sub')) {
            this.setDriverOnTray(disp1rec.subDriver, true)
          }
          disp1rec.subDriver = null
        }
        disp1rec.orderD = [fromOrder]
        disp1rec.isEqualUnkouYmdAndTekiyoYmd = this.tekiyoYmdDayjs.isSame(dayjs(fromOrder.sagyoYmd), 'd')
        this.setUpdateFlg(fromIndex, USE_DATAINDEX)
        if (this.viewMode === 0) {
          this.redrawSharyo1Line(fromIndex, true)
        } else {
          this.redrawDriver1Line(fromIndex, true)
        }
        return disp1rec
      }
      // var tk1StTime = fromOrder.hatsuchiDayjs.clone()
      // var tk1EdTime = fromOrder.chakuchiDayjs.clone()
      var [tk1StTime, tk1EdTime] = this.adjustTimeForOverlop(fromOrder)

      // 一覧の中から同じ車で同じドライバのを抽出する
      var carList = this.getRowDataAsSameList(disp1rec)
      var overlapFlg = true
      for (i = 0; i < carList.length; i++) {
        var nooverlapFlg = true
        const isWork = this.isWorksLine(carList[i].orderD)
        carList[i].orderD.forEach(function (el) {
          var ex2StTime = el.hatsuchiDayjs.clone()
          var ex2EdTime = el.chakuchiDayjs.clone()
          if (fromOrder.isWork !== isWork || (tk1EdTime.isAfter(ex2StTime) && ex2EdTime.isAfter(tk1StTime))) {
            // console.log('overlap', tk1StTime.format('DD HH:mm') + '-' + tk1EdTime.format('DD HH:mm'), ex2StTime.format('DD HH:mm') + '-' + ex2EdTime.format('DD HH:mm'))
            // 重なっている
            nooverlapFlg = false
          } else {
            // console.log('no overlap', tk1StTime.format('DD HH:mm') + '-' + tk1EdTime.format('DD HH:mm'), ex2StTime.format('DD HH:mm') + '-' + ex2EdTime.format('DD HH:mm'))
          }
        })
        // 運行日が適用日と違うのも分ける
        if (nooverlapFlg && carList[i].isEqualUnkouYmdAndTekiyoYmd !== this.tekiyoYmdDayjs.isSame(dayjs(fromOrder.sagyoYmd), 'd')) {
          nooverlapFlg = false
        }
        var dataIndex
        if (nooverlapFlg === true) {
          // この行に指定のオーダーを入れ込む
          overlapFlg = false
          carList[i].orderD.push(fromOrder)
          if (carList[i].isEqualUnkouYmdAndTekiyoYmd === null) {
            carList[i].isEqualUnkouYmdAndTekiyoYmd = this.tekiyoYmdDayjs.isSame(dayjs(fromOrder.sagyoYmd), 'd')
          }
          console.log('redraw !', fromIndex, this.getCarDataIndexFromLineID(carList[i].id))
          if (this.viewMode === 0) {
            dataIndex = this.getCarDataIndexFromLineID(carList[i].id)
            this.setUpdateFlg(dataIndex, USE_DATAINDEX)
            this.redrawSharyo1Line(dataIndex, true)
            if (carList[i].id !== rowId) {
              dataIndex = this.getCarDataIndexFromLineID(rowId)
              this.setUpdateFlg(dataIndex, USE_DATAINDEX)
              this.redrawSharyo1Line(this.getCarDataIndexFromLineID(rowId), true)
            }
          } else {
            dataIndex = this.getDriverDataIndexFromLineID(carList[i].id)
            this.setUpdateFlg(dataIndex, USE_DATAINDEX)
            this.redrawDriver1Line(dataIndex, true)
            if (carList[i].id !== rowId) {
              dataIndex = this.getDriverDataIndexFromLineID(rowId)
              this.setUpdateFlg(dataIndex, USE_DATAINDEX)
              this.redrawDriver1Line(this.getDriverDataIndexFromLineID(rowId), true)
            }
          }
          break
        }
      }
      if (overlapFlg === true) {
        // 全部のオーダーが重なっている
        // 行を増やす
        disp1rec.updateFlg = true
        var newRec = Object.assign({}, disp1rec)
        if (fromOrder.isWork) {
          // if (this.isValidDriver(newRec.subDriver) && newRec.subDriver.masterFlg) {
          if (this.isMasterDriverThisPostion(newRec, 'sub')) {
            this.setDriverOnTray(newRec.subDriver, true)
          }
          newRec.subDriver = null
        }
        if (this.viewMode === 0) {
          if (disp1rec.driver) {
            newRec.driver = Object.assign({}, disp1rec.driver)
            // newRec.driver.masterFlg = false
          }
          if (disp1rec.subDriver) {
            newRec.subDriver = Object.assign({}, disp1rec.subDriver)
            // newRec.subDriver.masterFlg = false
          }
          newRec = this.setNewRecords(newRec)
          newRec.orderD = [fromOrder]
          newRec.jomuinKakuteiFlg = disp1rec.jomuinKakuteiFlg
          newRec.dojoshaKakuteiFlg = disp1rec.dojoshaKakuteiFlg
          newRec.isEqualUnkouYmdAndTekiyoYmd = this.tekiyoYmdDayjs.isSame(dayjs(fromOrder.sagyoYmd), 'd')
          // newRec.id = this.getNewLineIdCar()
          // newRec.masterFlg = false
          // newRec.updateFlg = true
          this.setOrderOnTray(fromOrder, false)
          this.recCar.push(newRec)
          this.redrawSharyo1Line(fromIndex, true)
        } else {
          newRec = this.setNewRecords(newRec)
          newRec.orderD = [fromOrder]
          newRec.isEqualUnkouYmdAndTekiyoYmd = this.tekiyoYmdDayjs.isSame(dayjs(fromOrder.sagyoYmd), 'd')
          // newRec.id = this.getNewLineIdDriver()
          // newRec.orderD = [fromOrder]
          // newRec.masterFlg = false
          // newRec.updateFlg = true
          this.setOrderOnTray(fromOrder, false)
          this.recDriver.push(newRec)
          this.redrawDriver1Line(fromIndex, true)
        }
      }
      // var newRec = this.recCar[sIndex].clone()
    },
    addToGridFromTrayWork (workData, rowId) {
      return this.addToGridFromTrayOrder(workData, rowId)
    },
    getRowDataAsSameList (rec, worksf = false) {
      const self = this
      // 一覧の中から同じ車で同じドライバのを抽出する
      var carList
      if (this.viewMode === 0) {
        carList = this.filteredRows.filter(function (e) {
          // return e.car.id === rec.car.id && ((!self.isValidDriver(e.driver) && !self.isValidDriver(rec.driver)) || (self.isValidDriver(e.driver) && self.isValidDriver(rec.driver) && e.driver.id === rec.driver.id)) && ((!self.isValidDriver(e.subDriver) && !self.isValidDriver(rec.subDriver)) || (self.isValidDriver(e.subDriver) && self.isValidDriver(rec.subDriver) && e.subDriver.id === rec.subDriver.id))
          return e.car.id === rec.car.id && self.compareSameDriver(e.driver, rec.driver) && self.compareSameDriver(e.subDriver, rec.subDriver) && e.jomuinKakuteiFlg === rec.jomuinKakuteiFlg && e.dojoshaKakuteiFlg === rec.dojoshaKakuteiFlg
        })
      } else {
        carList = this.filteredRows2.filter(function (e) {
          return ((!self.isValidCar(e.car) && !self.isValidCar(rec.car)) ||
                (self.isValidCar(e.car) && self.isValidCar(rec.car) && e.car.id === rec.car.id)) && e.driver.id === rec.driver.id && e.jomuinKakuteiFlg === rec.jomuinKakuteiFlg && e.dojoshaKakuteiFlg === rec.dojoshaKakuteiFlg
        })
      }
      if (worksf) {
        carList = carList.filter((e) => {
          return self.isWorksLine(rec.orderD) === self.isWorksLine(e.orderD)
        })
      }
      return carList
    },
    changeTimeOrderTicketSharyo (ticket, rowDisplayIndex) {
      const self = this
      // 時間が長くなったことによって他のorderにかぶったらそれは次の行とかに押し出す
      // var tk1StTime = ticket.hatsuchiDayjs
      // var tk1EdTime = ticket.chakuchiDayjs
      var [tk1StTime, tk1EdTime] = this.adjustTimeForOverlop(ticket)
      var i = 0
      var fromIndex = this.getCarDataIndexFromLineID(this.filteredRows[rowDisplayIndex].id)
      var deleteOrder = []
      // var saveThisRowId = this.filteredRows[rowDisplayIndex].id
      var saveRowId = this.filteredRows[rowDisplayIndex].id
      this.recCar[fromIndex].orderD.forEach(function (el) {
        if (el.id === ticket.id) {
          if (self.recCar[fromIndex].isEqualUnkouYmdAndTekiyoYmd !== self.tekiyoYmdDayjs.isSame(dayjs(el.sagyoYmd), 'd') || el.isWork !== self.recCar[fromIndex].isWorksPlan) {
            deleteOrder.unshift({ ele: el, index: i })
            // el.isOnTray = true
          } else {
            // 自分のチケットなので何もしない
            self.copyTicketInfo(ticket, el)
          }
        } else {
          var ex2StTime = el.hatsuchiDayjs.clone()
          var ex2EdTime = el.chakuchiDayjs.clone()
          if ((tk1EdTime.isAfter(ex2StTime) && ex2EdTime.isAfter(tk1StTime)) || el.isWork !== ticket.isWork || self.recCar[fromIndex].isEqualUnkouYmdAndTekiyoYmd !== self.tekiyoYmdDayjs.isSame(dayjs(el.sagyoYmd), 'd')) {
            deleteOrder.unshift({ ele: el, index: i })
            // el.isOnTray = true
          }
        }
      })
      const marker = dayjs().valueOf()
      this.recCar[this.getCarDataIndexFromLineID(saveRowId)].marker = marker
      const rows = this.recCar
      // var newid = this.recCar
      deleteOrder.forEach(function (e) {
        // console.log('押し出し', e.ele, self.recCar, saveCarId)
        var row = rows.find((e) => {
          return e.marker === marker
        })
        self.returnToTrayOrder(e.ele, row.id, true)
        // e.ele.isOnTray = true
        self.$nextTick().then(() => {
          e.ele.isOnTray = false
          row = rows.find((e) => {
            return e.marker === marker
          })
          self.addToGridFromTrayOrder(e.ele, row.id)
        })
        // row = rows.find((e) => {
        //   return e.marker === marker
        // })
        // if (row) {
        //   // マーカーを消しておく
        //   delete row.marker
        // }
        // self.addToGridFromTrayOrder(e.ele, self.getCarRecIdFromCarId(saveCarId))
        // this.filteredRows[this.editingGridRowIndex].orderD.splice(e, 1)
      })
      // 行書き直し
      // this.redrawSharyo1Line(self.getCarRecIdFromCarId(saveCarId), true)
    },
    changeTimeOrderTicketDriver (ticket, rowDisplayIndex) {
      const self = this
      // 時間が長くなったことによって他のorderにかぶったらそれは次の行とかに押し出す
      // var tk1StTime = ticket.hatsuchiDayjs
      // var tk1EdTime = ticket.chakuchiDayjs
      var [tk1StTime, tk1EdTime] = this.adjustTimeForOverlop(ticket)
      var i = 0
      var fromIndex = this.getDriverDataIndexFromLineID(this.filteredRows2[rowDisplayIndex].id)
      var deleteOrder = []
      // var saveThisRowId = this.filteredRows[rowDisplayIndex].id
      var saveRowId = this.filteredRows2[rowDisplayIndex].id
      this.recDriver[fromIndex].orderD.forEach(function (el) {
        if (el.id === ticket.id) {
          // 自分のチケットなので何もしない
          self.copyTicketInfo(ticket, el)
        } else {
          var ex2StTime = el.hatsuchiDayjs.clone()
          var ex2EdTime = el.chakuchiDayjs.clone()
          if (tk1EdTime.isAfter(ex2StTime) && ex2EdTime.isAfter(tk1StTime)) {
            deleteOrder.unshift({ ele: el, index: i })
            // el.isOnTray = true
          }
        }
      })
      deleteOrder.forEach(function (e) {
        // console.log('押し出し', e.ele, self.recCar, saveDriverId)
        var newid = self.returnToTrayOrder(e.ele, saveRowId, true)
        // e.ele.isOnTray = true
        self.$nextTick().then(() => {
          e.ele.isOnTray = false
          self.addToGridFromTrayOrder(e.ele, newid)
        })

        // self.addToGridFromTrayOrder(e.ele, self.getCarRecIdFromCarId(saveCarId))
        // this.filteredRows[this.editingGridRowIndex].orderD.splice(e, 1)
      })
      // 行書き直し
      // this.redrawSharyo1Line(self.getCarRecIdFromCarId(saveCarId), true)
    },
    setStartHourOrderTicket (order, hourgrid) {
      const timeLockFlg = (order.startLockFlg === true || order.endLockFlg === true) && ((!order.isWork && order.hatsuchiHms) || (order.isWork && order.startHms))

      // 既に終了時間が設定されていれば時間を引き継ぐ
      var hh
      if (order.chakuchiDayjs && order.hatsuchiDayjs) {
        hh = order.chakuchiDayjs.diff(order.hatsuchiDayjs, 'minute')
        if (hh < 1) {
          // 0またはマイナス時間が設定されているときは暫定1時間とする
          hh = DEFUALT_ORDER_LENGTH
        }
      } else {
        // 最初から時間が指定がないやつは1時間とする
        hh = DEFUALT_ORDER_LENGTH
      }
      var hour = (hourgrid === 0) ? 0 : (hourgrid - 1) * this.hoursInterval
      // if (hourgrid === 0 && ((!order.isWork && !order.hatsuchiHms) || (order.isWork && !order.startHms))) {
      //   // 時間指定なしで開始時間が入っていないのは、表の開始時間が指定されたものとする
      //   hour = 0
      // }
      if (timeLockFlg) {
        var hdjs = this.tekiyoYmdDayjs.add(hour, 'h').minute(0)
        // var hdjs = (hourgrid === 0) ? order.hatsuchiDayjs : this.tekiyoYmdDayjs.add(hour, 'h').minute(0)
        if (!order.isWork) {
          if (order.hatsuchiYmd !== hdjs.format('YYYY/MM/DD') || !order.chakuchiDayjs || !order.chakuchiHms) {
            order.hatsuchiYmd = hdjs.format('YYYY/MM/DD')
            if (!order.hatsuchiHms) {
              order.hatsuchiHms = hdjs.format('HH:mm')
            }
            order.hatsuchiDayjs = dayjs(order.hatsuchiYmd + ' ' + order.hatsuchiHms)
            // 画面の表の前に張り付くときは、24時間後とする
            if (order.hatsuchiDayjs.isBefore(this.tekiyoYmdDayjs, 'm')) {
              console.log('paste to before grid... slide 1day')
              order.hatsuchiDayjs = order.hatsuchiDayjs.add(1, 'd')
              order.hatsuchiYmd = order.hatsuchiDayjs.format('YYYY/MM/DD')
            }
            order.chakuchiDayjs = order.hatsuchiDayjs.add(hh, 'minute')
            order.chakuchiYmd = order.chakuchiDayjs.format('YYYY/MM/DD')
            order.chakuchiHms = order.chakuchiDayjs.format('HH:mm')
            order.updateFlg = true
          }
        } else {
          if (order.startYmd !== hdjs.format('YYYY/MM/DD') || !order.endDayjs || !order.endHms) {
            order.startYmd = hdjs.format('YYYY/MM/DD')
            if (!order.startHms) {
              order.startHms = hdjs.format('HH:mm')
            }
            order.startDayjs = dayjs(order.startYmd + ' ' + order.startHms)
            // 画面の表の前に張り付くときは、24時間後とする
            if (order.startDayjs.isBefore(this.tekiyoYmdDayjs, 'm')) {
              console.log('paste to before grid... slide 1day')
              order.startDayjs = order.startDayjs.add(1, 'd')
              order.startYmd = order.startDayjs.format('YYYY/MM/DD')
            }
            order.endDayjs = order.startDayjs.add(hh, 'minute')
            order.endYmd = order.endDayjs.format('YYYY/MM/DD')
            order.endHms = order.endDayjs.format('HH:mm')
            order.updateFlg = true
            order.hatsuchiDayjs = order.startDayjs.clone()
            order.chakuchiDayjs = order.endDayjs.clone()
          }
        }
      } else {
        if (!order.isWork) {
          console.log('time change ', hour, hh)
          if (hourgrid === 0) {
            if (order.hatsuchiHms) {
              order.hatsuchiHms = order.hatsuchiDayjs.format('HH:mm')
            } else {
              order.hatsuchiHms = this.tekiyoYmdDayjs.format('HH:mm')
            }
            order.hatsuchiYmd = this.tekiyoYmdDayjs.format('YYYY/MM/DD')
            order.hatsuchiDayjs = dayjs(order.hatsuchiYmd + ' ' + order.hatsuchiHms)
            // 画面の表の前に張り付くときは、24時間後とする
            if (order.hatsuchiDayjs.isBefore(this.tekiyoYmdDayjs, 'm')) {
              console.log('paste to before grid... slide 1day')
              order.hatsuchiDayjs = order.hatsuchiDayjs.add(1, 'd')
              order.hatsuchiYmd = order.hatsuchiDayjs.format('YYYY/MM/DD')
            }
          } else {
            order.hatsuchiDayjs = this.tekiyoYmdDayjs.add(hour, 'h').minute(0)
            order.hatsuchiYmd = order.hatsuchiDayjs.format('YYYY/MM/DD')
            order.hatsuchiHms = order.hatsuchiDayjs.format('HH:mm')
          }
          order.chakuchiDayjs = order.hatsuchiDayjs.add(hh, 'minute')
          order.chakuchiYmd = order.chakuchiDayjs.format('YYYY/MM/DD')
          order.chakuchiHms = order.chakuchiDayjs.format('HH:mm')
          order.updateFlg = true
          console.log('time change dayjs', order.hatsuchiDayjs, order.chakuchiDayjs)
          console.log('time change str', order.hatsuchiHms, order.chakuchiHms)
        } else {
          console.log('time change ', hour, hh)
          if (hourgrid === 0) {
            if (order.startHms) {
              order.startHms = order.hatsuchiDayjs.format('HH:mm')
            } else {
              order.startHms = this.tekiyoYmdDayjs.format('HH:mm')
            }
            // order.startHms = order.hatsuchiDayjs.format('HH:mm')
            order.startYmd = this.tekiyoYmdDayjs.format('YYYY/MM/DD')
            order.startDayjs = dayjs(order.startYmd + ' ' + order.startHms)
            // 画面の表の前に張り付くときは、24時間後とする
            if (order.startDayjs.isBefore(this.tekiyoYmdDayjs, 'm')) {
              console.log('paste to before grid... slide 1day')
              order.startDayjs = order.startDayjs.add(1, 'd')
              order.startYmd = order.startDayjs.format('YYYY/MM/DD')
            }
          } else {
            order.startDayjs = this.tekiyoYmdDayjs.add(hour, 'h').minute(0)
            order.startYmd = order.startDayjs.format('YYYY/MM/DD')
            order.startHms = order.startDayjs.format('HH:mm')
          }
          order.hatsuchiDayjs = order.startDayjs.clone()
          order.endDayjs = order.startDayjs.add(hh, 'minute')
          order.endYmd = order.endDayjs.format('YYYY/MM/DD')
          order.endHms = order.endDayjs.format('HH:mm')
          order.updateFlg = true
          order.chakuchiDayjs = order.endDayjs.clone()
        }
      }
    },
    setStartHourWorksTicket (order, hour) {
      this.setStartHourOrderTicket(order, hour)
    },
    /**
     * ドライバの削除などによりmaster_flgの行がなくなったときに、適切なものにmasterFlgを立てる
     * @param {*} driver driver
     * @returns boolean
     * @deprecated driverのmasterFlgは使用しなくなったので必要ないはず
     */
    upgradeOtherDriver (driver) {
      const self = this
      const rec = this.recCar.filter((e) => {
        return self.compareSameDriver(e.driver, driver) || self.compareSameDriver(e.subDriver, driver)
      })
      if (!rec || rec.length === 0) {
        return false
      }
      const hitrec = rec.filter((e) => {
        return (self.compareSameDriver(e.driver, driver) && e.driver.masterFlg) || (self.compareSameDriver(e.subDriver, driver) && e.subDriver.masterFlg)
      })
      if (hitrec && hitrec.length > 0) {
        return true
      }
      if (rec[0].driver.id === driver.id) {
        rec[0].driver = driver // masterFlgを立てる
      } else if (rec[0].subDriver.id === driver.id) {
        rec[0].subDriver = driver // masterFlgを立てる
      }
      return true
    },
    // #endregion
    // #region データ処理汎用
    /**
     * ドライバが有効かどうかを判定する
     **/
    isValidDriver: function (item) {
      if (!item) {
        return false
      }
      if (!item.id) {
        return false
      }
      return true
    },
    /**
     * 車両が有効かどうかを判定する
     **/
    isValidCar: function (car) {
      if (!car) {
        return false
      }
      if (!car.id) {
        return false
      }
      if (Number(car.id) <= 0) {
        return false
      }
      // var ret = this.recCar.find(function (e) {
      //   if (Number(e.car.id) === Number(car.id)) {
      //     return true
      //   }
      // })
      // if (ret !== undefined) {
      //   return true
      // }
      return true
    },
    /**
     * 車両別画面での新規の行IDを取得する
     **/
    getNewLineIdCar: function () {
      if (this.recCar.length === 0) {
        return 1
      }
      return 1 + Math.max.apply(null, this.recCar.map(function (o) {
        return o.id
      }))
    },
    /**
     * ドライバ別画面での新規の行IDを取得する
     **/
    getNewLineIdDriver: function () {
      if (this.recDriver.length === 0) {
        return 1
      }
      return 1 + Math.max.apply(null, this.recDriver.map(function (o) {
        return o.id
      }))
    },
    /**
     * 新規のオーダのIDを取得する
     * オーダー追加ダイアログより
     **/
    getNewOrderId: function () {
      if (this.keikakuSagyoMeisai.length === 0) {
        return -1
      }
      const ret = -1 + Math.min.apply(null, this.keikakuSagyoMeisai.map(function (o) {
        return o.id
      }))
      if (ret >= 0) {
        return -1
      }
      return ret
    },
    /**
     * 新規の作業計画基本のIDを取得する
     * -1から採番
     **/
    getNewIdPlan: function () {
      var newId
      var newPlanList = this.sagyoKeikaku.filter((e) => {
        return e.id < 0
      })
      if (newPlanList.length === 0) {
        newId = -1
      } else {
        newId = -1 + Math.min.apply(null, newPlanList.map(function (o) {
          return o.id
        }))
        if (newId >= 0) {
          newId = -1
        }
      }
      if (this.tempSavedDataPlanFromIndexDb && this.tempSavedDataPlanFromIndexDb.length > 0) {
        const nl = Math.min.apply(null, this.tempSavedDataPlanFromIndexDb.map((e) => {
          return Number(e.id)
        }))
        if (nl <= newId) {
          return nl - 1
        }
      }
      return newId
    },
    /**
     * 指定した時間に重なりがあるかを判別する
     * @returns {boolean} 重なりがなければ true
     * */
    checkTimeOverlap (fs, fe, ts, te) {
      // if (fs.isSameOrAfter(te) && fe.isSameOrAfter(ts)) {
      //   return true
      // }
      // return false
      const dispStart = this.tekiyoYmdDayjs.clone()
      const dispEnd = dispStart.add(this.hours, 'h')
      // 表示時間外のオーダーはいつでもどこでも入る
      if (fs.isBefore(dispEnd) && dispStart.isBefore(fe)) {
      } else {
        return true
      }
      if (ts.isBefore(dispEnd) && dispStart.isBefore(te)) {
      } else {
        return true
      }

      if (ts.isBefore(fe) && fs.isBefore(te)) {
        return false
      }
      return true
    },
    getOrderFromDriverId (driverid) {
      return this.keikakuSagyoMeisai.filter(function (e) {
        return e.driverid === Number(driverid) || e.subDriverid === Number(driverid)
      })
    },
    getOrderFromOrderID: function (id) {
      const r = this.keikakuSagyoMeisai.find(function (ele) {
        if (Number(ele.id) === Number(id)) return true
      })
      if (!r) {
        return this.keikakuSagyoMeisai2.find(function (ele) {
          if (Number(ele.id) === Number(id)) return true
        })
      }
      return r
    },
    getOrderFromTimeIndexAndOrderArray (timeIndex, orderInfo) {
      const self = this
      var ret
      const nt = this.tekiyoYmdDayjs.clone().add((timeIndex - 1) * this.hoursInterval, 'hour')
      if (orderInfo) {
        if (Array.isArray(orderInfo)) {
          orderInfo.forEach(function (ele) {
            var hhx = ele.hatsuchiDayjs.clone()
            const chx = ele.chakuchiDayjs.clone()
            hhx = self.adjustStartTimeByInterval(hhx)
            // if (nt.$H === hhx.$H) {
            //   console.log('same hour', nt, hhx)
            // }
            if (nt.isSame(hhx, 'hour')) {
              // console.log('hit!', ele)
              ret = ele
              return
            }
            if (timeIndex === 1) {
              if (nt.isAfter(hhx, 'h') && chx.isAfter(nt, 'm')) {
                // console.log('hit!', ele)
                ret = ele
              }
            }
          })
        }
      }
      // console.log('return', ret)
      return ret
    },
    adjustStartTimeByInterval (hhx, isAdjust = false) {
      const self = this
      hhx = hhx.minute(0)
      if (hhx.isBefore(self.tekiyoYmdDayjs)) {
        if (isAdjust) {
          hhx = self.tekiyoYmdDayjs
        }
      } else if (self.hoursInterval > 1) {
        // 1時間おきの表示でなければ開始時間を表示の時間に合わせる
        var h = hhx.hour()
        h = h - self.tableStartHour
        var mod = h % self.hoursInterval
        if (mod < 0) {
          mod += self.hoursInterval
        }
        hhx = hhx.add(mod * -1, 'h')
      }
      return hhx
    },
    adjustEndTimeByInterval (hhx, isAdjust = false) {
      const self = this
      if (hhx.minute() > 0) {
        hhx = hhx.hour(hhx.hour() + 1)
        hhx = hhx.minute(0)
      }
      if (self.hoursInterval > 1) {
        // 1時間おきの表示でなければ終了時間を表示の時間に合わせる
        var h = hhx.hour()
        h = h - self.tableStartHour
        var mod = h % self.hoursInterval
        if (mod < 0) {
          mod += self.hoursInterval
        }
        if (mod !== 0) {
          mod = self.hoursInterval - mod
        }
        hhx = hhx.add(mod, 'h')
      }
      if (hhx.isAfter(self.tekiyoYmdDayjs.add(this.hours, 'h'))) {
        if (isAdjust) {
          hhx = self.tekiyoYmdDayjs.add(this.hours, 'h')
        }
      }
      return hhx
    },
    getDriverFromDriverID: function (id) {
      return this.keikakuJininList.find(function (ele) {
        if (Number(ele.id) === Number(id)) return true
      })
    },
    getCarFromCarid (id) {
      var r = this.keikakuSharyoList.find(function (e) {
        if (!e.id) {
          return false
        }
        return e.id === Number(id)
      })
      return r
    },
    getCarDataIndexFromLineID: function (id) {
      var i
      for (i = 0; i < this.recCar.length; i++) {
        if (Number(this.recCar[i].id) === Number(id)) {
          return i
        }
      }
      return -1
    },
    getLineIdFromCarId (carid) {
      return this.recCar.find(function (e) {
        return e.car.id === carid
      }).id
    },
    getLineIdFromDriverId (driverid) {
      return this.recDriver.find(function (e) {
        return e.driver.id === driverid
      }).id
    },
    getDriverDataIndexFromLineID: function (id) {
      var i
      for (i = 0; i < this.recDriver.length; i++) {
        if (Number(this.recDriver[i].id) === Number(id)) {
          return i
        }
      }
      return -1
    },
    getCarDisplayIndexFromOrderID: function (id) {
      var i
      var ret = -1
      for (i = 0; i < this.filteredRows.length; i++) {
        if (!Array.isArray(this.filteredRows[i].orderD)) {
          continue
        }
        this.filteredRows[i].orderD.forEach(function (ele) {
          if (Number(ele.id) === Number(id)) {
            ret = i
          }
        })
      }
      return ret
    },
    getCarDisplayIndexFromLineID: function (id) {
      var i
      for (i = 0; i < this.filteredRows.length; i++) {
        if (Number(this.filteredRows[i].id) === Number(id)) {
          return i
        }
      }
      return 0
    },
    getDriverDisplayIndexFromOrderID: function (id) {
      var i
      var ret = -1
      for (i = 0; i < this.filteredRows2.length; i++) {
        if (!Array.isArray(this.filteredRows2[i].orderD)) {
          continue
        }
        this.filteredRows2[i].orderD.forEach(function (ele) {
          if (Number(ele.id) === Number(id)) {
            ret = i
          }
        })
      }
      return ret
    },
    getDriverDisplayIndexFromLineID: function (id) {
      var i
      for (i = 0; i < this.filteredRows2.length; i++) {
        if (Number(this.filteredRows2[i].id) === Number(id)) {
          return i
        }
      }
      return 0
    },
    getWorkFromWorkID: function (id) {
      return this.keikakuSagyoMeisai2.find(function (ele) {
        if (Number(ele.id) === Number(id)) return true
      })
    },
    getSagyoKeikakuFromCarId: function (id) {
      return this.sagyoKeikaku.filter((e) => {
        return (e) && e.sharyoId === id && e.delFlg !== true
      })
    },
    getSagyoKeikakuUpdFlgFromCarIdAsDeleted: function (id) {
      const ret = this.sagyoKeikaku.filter((e) => {
        return (e) && e.sharyoId === id && e.delFlg === true
      }).find((e) => {
        return e.updateFlg === true
      })
      if (ret) {
        return true
      } else {
        return false
      }
    },
    getSagyoKeikakuFromDriverId: function (id) {
      return this.sagyoKeikaku.filter((e) => {
        return (e.jomuinId === id || e.dojoshaId === id) && e.delFlg !== true
      })
    },
    mergeArraySagyoMeisaiId (sl) {
      var ret = []
      if (sl && sl.length !== 0) {
        sl.forEach(function (e) {
          ret = ret.concat(e.trSagyoMeisaiIdArrayList)
          ret = ret.concat(e.trSagyoMeisaiId2ArrayList) // works
        })
      }
      return ret
    },
    getSagyoMeisaiFromSagyoMeisaiIdList (sl, s2 = []) {
      const self = this
      var ret = []
      // var dispStart = this.tekiyoYmdDayjs.clone()
      // var dispEnd = dispStart.add(this.hours, 'h')
      if (sl && sl.length !== 0) {
        sl.forEach(function (e) {
          const odr = self.getOrderFromOrderID(e)
          if (odr) {
            // 表示時間外のものもorderDに入れることにする
            // if (odr.hatsuchiDayjs.isBefore(dispEnd) && dispStart.isBefore(odr.chakuchiDayjs)) {
            //   ret.push(odr)
            // }
            ret.push(odr)
          }
        })
      }
      if (s2 && s2.length !== 0) {
        s2.forEach(function (e) {
          const wrk = self.getWorkFromWorkID(e)
          if (wrk) {
            // if (wrk.hatsuchiDayjs.isBefore(dispEnd) && dispStart.isBefore(wrk.chakuchiDayjs)) {
            //   ret.push(wrk)
            // }
            ret.push(wrk)
          }
        })
      }
      return ret
    },
    setOrderOnTray (order, flags) {
      order.isOnTray = flags
      order.updateFlg = true
      if (flags) {
        order.sagyoYoteiYmd = null
        console.log('order tray', order)
      }
      // filteredOrdersが再計算されないのの対処
      var t = []
      if (order.isWork) {
        t = t.concat(this.keikakuSagyoMeisai2)
        this.keikakuSagyoMeisai2 = t
      } else {
        t = t.concat(this.keikakuSagyoMeisai)
        this.keikakuSagyoMeisai = t
      }
    },
    setDriverOnTray (driver, flags) {
      driver.isOnTray = flags
      // filteredDriversが再計算されないのの対処
      var t = []
      t = t.concat(this.keikakuJininList)
      this.keikakuJininList = t
    },
    setCarOnTray (car, flags) {
      car.isOnTray = flags
      // filteredDriversが再計算されないのの対処
      var t = []
      t = t.concat(this.keikakuSharyoList)
      this.keikakuSharyoList = t
    },
    setUpdateFlg (index, mode) {
      if (mode === USE_DISPLAYINDEX) {
        if (this.viewMode === 0) {
          index = this.getCarDataIndexFromLineID(this.filteredRows[index].id)
        } else {
          index = this.getDriverDataIndexFromLineID(this.filteredRows2[index].id)
        }
      }
      if (this.viewMode === 0) {
        var rowList = this.getRowDataAsSameList(this.recCar[index], true)
        rowList.forEach((e) => {
          e.updateFlg = true
        })
      } else {
        rowList = this.getRowDataAsSameList(this.recDriver[index], true)
        rowList.forEach((e) => {
          e.updateFlg = true
        })
      }
    },
    getSagyoPlanFromDataRowAndDate (row, subDriver, djs) {
      const self = this
      if (this.isValidCar(row.car)) {
        var sCarid = row.car.id
      } else {
        sCarid = null
      }
      if (this.isValidDriver(row.driver)) {
        var sDriverid = row.driver.id
      } else {
        sDriverid = null
      }
      if (this.isValidDriver(subDriver)) {
        var sSubDriverid = subDriver.id
      } else {
        sSubDriverid = null
      }
      var fPlan = this.sagyoKeikaku.find((e) => {
        const ret = e.sharyoId === sCarid && e.jomuinId === sDriverid && e.dojoshaId === sSubDriverid &&
                djs.isSame(dayjs(e.sagyoYoteiYmd), 'day') && (!sDriverid || e.jomuinKakuteiFlg === row.jomuinKakuteiFlg) &&
                (!sSubDriverid || e.dojoshaKakuteiFlg === row.dojoshaKakuteiFlg)
        if (ret) {
          // 作業の考慮もいれないと死ぬ
          if (e.isWorksPlan === null) {
            return true
          }
          if (self.isWorksLine(row.orderD) && e.isWorksPlan) {
            return true
          } else if (!self.isWorksLine(row.orderD) && e.isWorksPlan === false) {
            return true
          }
          return false
        }
        return false
        // ((self.isWorksLine(row.orderD) && e.trSagyoMeisaiId2ArrayList.length > 0 && e.trSagyoMeisaiIdArrayList.length === 0) ||
        //  (!self.isWorksLine(row.orderD) && e.trSagyoMeisaiId2ArrayList.length === 0 && e.trSagyoMeisaiIdArrayList.length > 0))
      })
      if (fPlan) {
        // 見つかったらそれを返す
        return fPlan
      }
      const x = {
        id: this.getNewIdPlan(),
        kaishaCd: this.currentKaishaCode,
        sagyoYoteiYmd: djs.format('YYYY/MM/DD'),
        haishaShashuSbt: this.conditions.haishaShashuSbt,
        eigyoshoId: this.getEigyoshoId(this.usersEigyosho),
        sagyoYoteiStartYmd: this.conditions.sagyoYoteiYmdFrom,
        sagyoYoteiEndYmd: this.conditions.sagyoYoteiYmdTo,
        keikakuKakuteiFlg: false,
        delFlg: false,
        trSagyoKeikakuSharyoId: null,
        sharyoId: sCarid,
        trSagyoKeikakuKihonEdaNo: null,
        trSagyoKeikakuJomuinId: null,
        jomuinId: sDriverid,
        jomuinKakuteiFlg: false,
        trSagyoKeikakuDojoshaId: null,
        dojoshaId: sSubDriverid,
        dojoshaKakuteiFlg: false,
        trSagyoMeisaiIdArray: '',
        trSagyoMeisaiIdArrayList: [],
        trSagyoMeisaiId2Array: '',
        trSagyoMeisaiId2ArrayList: [],
        updateFlg: true,
        isWorksPlan: null,
        unkoSeqNo: 1
        // trSagyoKeikakuKihonUpdDate: dayjs().toJSON(),
        // trSagyoKeikakuSharyoUpdDate: dayjs().toJSON(),
        // trSagyoKeikakuJomuinUpdDate: dayjs().toJSON()
      }
      this.sagyoKeikaku.push(x)
      return x
    },
    getrecDataFromPlan (plan) {
      const self = this
      return this.recCar.filter((e) => {
        if (plan.sharyoId === null) {
          if (!self.isValidCar(e.car)) {

          } else {
            return false
          }
        } else {
          if (self.isValidCar(e.car) && e.car.id === plan.sharyoId) {
          } else {
            return false
          }
        }
        if (plan.jomuinId === null) {
          if (!self.isValidDriver(e.driver)) {

          } else {
            return false
          }
        } else {
          if (self.isValidDriver(e.driver) && e.driver.id === plan.jomuinId) {
          } else {
            return false
          }
        }
        if (plan.dojoshaId === null) {
          if (!self.isValidDriver(e.subDriver)) {

          } else {
            return false
          }
        } else {
          if (self.isValidDriver(e.subDriver) && e.subDriver.id === plan.dojoshaId) {
          } else {
            return false
          }
        }
        if (plan.trSagyoMeisaiIdArray.length > 0 && plan.trSagyoMeisaiId2Array.length > 0) {

        } else if (plan.trSagyoMeisaiIdArray.length > 0) {
          if (self.isWorksLine(e.orderD)) {
            return false
          }
        } else if (plan.trSagyoMeisaiId2Array.length > 0) {
          if (!self.isWorksLine(e.orderD)) {
            return false
          }
        }
        return true
      })
    },
    getSagyoMeisaiMinDate (orders, sagyoYoteiYmd) {
      if (orders.length > 0) {
        var a = []
        orders.forEach((e) => {
          a.push(e.hatsuchiDayjs)
        })
        const t = dayjs.min(a)
        if (t) {
          // return t.toJSON()
          return t.format('YYYY/MM/DD HH:mm:ss')
        }
      }
      return sagyoYoteiYmd
    },
    getSagyoMeisaiMaxDate (orders, sagyoYoteiYmd) {
      if (orders.length > 0) {
        var a = []
        orders.forEach((e) => {
          a.push(e.chakuchiDayjs)
        })
        const t = dayjs.max(a)
        if (t) {
          // return t.toJSON()
          return t.format('YYYY/MM/DD HH:mm:ss')
        }
      }
      return sagyoYoteiYmd
    },
    /**
     * 同じドライバと車のなかにマスタのものがあるか検索する
     * （ソート時に上位にさせるため）
     * @param {driver} driver
     * @param {car} car
     * @param {rows*} rows
     * @returns true:マスタがある
     * @deprecated masterFlg廃止のため
     */
    hasMaster (driver, subDriver, car, rows) {
      const self = this
      var r = rows.find(function (e) {
        return self.compareSameDriver(e.driver, driver) &&
                self.compareSameDriver(e.subDriver, subDriver) &&
                self.compareSameCar(e.car, car) &&
                e.masterFlg === true
      })
      if (r) {
        return true
      }
      return false
    },
    /**
     * @param {} driver
     * @param {*} car
     * @param {*} rows
     * @returns
     * @deprecated masterFlg廃止のため
     */
    hasMasterDriverOnly (driver, car, rows) {
      const self = this
      var r = rows.find(function (e) {
        return self.compareSameDriver(e.driver, driver) &&
                self.compareSameCar(e.car, car) &&
                e.masterFlg === true
      })
      if (r) {
        return true
      }
      return false
    },
    /**
     * @deprecated driverのmasterFlgは使用しなくなった
     */
    isHasMasterCar (dr) {
      const self = this
      const rows = this.viewMode === 0 ? this.recCar : this.recDriver
      const r = rows.find((e) => {
        return (self.compareSameDriver(e.driver, dr) && e.driver.masterFlg === true) || (self.compareSameDriver(e.subDriver, dr) && e.subDriver.masterFlg === true)
      })
      if (r) {
        return true
      }
      return false
    },
    compareSameDriver (dr1, dr2) {
      const r1 = this.isValidDriver(dr1)
      const r2 = this.isValidDriver(dr2)
      return ((!r1 && !r2) ||
      (r1 && r2 && dr1.id === dr2.id))
    },
    compareSameDriverStructureAndId (dr1, dr2id) {
      const r1 = this.isValidDriver(dr1)
      return ((!r1 && dr2id === null) ||
      (r1 && dr1.id === dr2id))
    },
    compareSameCar (dr1, dr2) {
      const r1 = this.isValidCar(dr1)
      const r2 = this.isValidCar(dr2)
      return ((!r1 && !r2) ||
      (r1 && r2 && dr1.id === dr2.id))
    },
    getSameDriverAndCar (r, rList, drv = null, isWorksDiff = false, type = null, kakutei = true) {
      const self = this
      const xdrv = drv ?? r.driver
      return rList.filter((e) => {
        return self.compareSameDriver(e.driver, xdrv) &&
        (type === 'main' || (self.compareSameDriver(e.subDriver, r.subDriver) && (!kakutei || e.dojoshaKakuteiFlg === r.dojoshaKakuteiFlg))) &&
        self.compareSameCar(e.car, r.car) && (!kakutei || e.jomuinKakuteiFlg === r.jomuinKakuteiFlg) &&
        (isWorksDiff === false || self.isWorksLine(r.orderD) === self.isWorksLine(e.orderD))
      })
    },
    getCountDriver (row, rowList, driver = null, type = null) {
      const self = this
      const xdrv = driver ?? (type === 'main' ? row.driver : row.subDriver)
      if (!this.isValidDriver(xdrv)) {
        return 0
      }
      return rowList.filter((e) => {
        return self.compareSameDriver(e.driver, xdrv)
      }).length +
      rowList.filter((e) => {
        return self.compareSameDriver(e.subDriver, xdrv)
      }).length
    },
    isMasterDriverThisDriver (driver) {
      if (!this.isValidDriver(driver)) {
        return false
      }
      return (this.getCountDriver(null, this.recCar, driver, 'main') === 1)
    },
    isMasterDriverThisPostion (row, xType) {
      const rl = this.viewMode === 0 ? this.recCar : this.recDriver
      const x = this.getSameDriverAndCar(row, rl, null, true, xType)
      const ret = this.getCountDriver(row, rl, null, xType)
      if (!ret) {
        return false
      }
      return !(ret > x.length)
    },
    isOnlyLineSharyo (row) {
      const num = this.recCar.filter((e) => {
        return e.car.id === row.car.id
      }).length
      if (num === 1) {
        return true
      }
      return false
    },
    isOnlyLineDriver (row) {
      const num = this.recDriver.filter((e) => {
        return e.driver.id === row.driver.id
      }).length
      if (num === 1) {
        return true
      }
      return false
    },
    /**
     * 色コードが濃い色であれば白、薄い色であれば黒を返す
     * @param {string} hexcolor (#hhhhhh 形式)
     * @returns {string} 'white' or 'black'
     */
    blackOrWhite (hexcolor) {
      if (hexcolor.length < 7) {
        return 'black'
      }
      const r = parseInt(hexcolor.substring(1, 3), 16)
      const g = parseInt(hexcolor.substring(3, 5), 16)
      const b = parseInt(hexcolor.substring(5, 7), 16)
      const a = (hexcolor.length > 8) ? parseInt(hexcolor.substring(7, 9), 16) : 255
      const akarusa = (((r * 299) + (g * 587) + (b * 114)) / 1000)
      const akarusa2 = (akarusa + (255 - a)) - (akarusa * (255 - a)) / 256
      return akarusa2 < 128 ? 'white' : 'black'
    },
    copyTicketInfo (f, e) {
      const self = this
      Object.assign(e, f)
      if (!f.isWork) {
        self.shapeJyuchuData(e)
      } else {
        self.shapeSagyoData(e)
      }
      if (typeof e.isOnTray === 'undefined') {
        e.isOnTray = true
      }
      return e
    },
    searchSameLineOfWorksOnSharyo (index, order) {
      var i
      for (i = 0; i < this.recCar.length; i++) {
        if (this.compareSameDriver(this.recCar[index].driver, this.recCar[i].driver) &&
            !this.isValidDriver(this.recCar[i].subDriver) &&
            this.compareSameCar(this.recCar[index].car, this.recCar[i].car)) {
          if (this.recCar[i].orderD.length === 0) {
            this.recCar[i].isEqualUnkouYmdAndTekiyoYmd = this.tekiyoYmdDayjs.isSame(dayjs(order.sagyoYmd), 'd')
            return i
          }
          if (this.isWorksLine(this.recCar[i].orderD)) {
            // 適用日と運行日と同じのは同じ行に
            if (this.recCar[i].isEqualUnkouYmdAndTekiyoYmd === this.tekiyoYmdDayjs.isSame(dayjs(order.sagyoYmd), 'd')) {
              return i
            }
          }
        }
      }
      // 該当の作業の行がない場合は、新しく作る
      var t = { ...this.recCar[index] }
      t.subDriver = null
      t = this.setNewRecords(t)
      t.isEqualUnkouYmdAndTekiyoYmd = this.tekiyoYmdDayjs.isSame(dayjs(order.sagyoYmd), 'd')
      return this.recCar.push(t) - 1
    },
    /**
     * 指定したオーダと同じようなオーダを探し出す
     **/
    // getLikeOrder (origOdr, orderList) {
    //   return orderList.find(function (e) {
    //     return e.tokuisakiNm === origOdr.tokuisakiNm && e.hatsuchiNm === origOdr.hatsuchiNm &&
    //             e.hatsuchiHms === origOdr.hatsuchiHms && e.chakuchiNm === origOdr.chakuchiNm &&
    //             e.chakuchiHms === origOdr.chakuchiHms
    //   })
    // },
    // #endregion
    // #region タイマなどその他ダミー
    checkServerUpdated () {
      console.log('check server update')
      this.searchExec(true, true)
      return true
    },
    onReloadServerInfoClick () {
      console.log('update datas ...')
      // const self = this
      // まず画面の情報を保存する
      if (this.afterSearch) {
        if (this.viewMode === 0) {
          this.storeOrderInfoFromScreenSharyo(this.page)
        } else {
          this.storeOrderInfoFromScreenDriver(this.page)
        }
        this.searchExec(true)
      } else {
        this.loadJuchu()
      }
      this.isRecommendReload = false
    },
    // #endregion
    // #regitn 高野追加
    isSelectedFontBtn: function (size) {
      if (this.sizeType === size) {
        return 'selectedFontBtn'
      }
      return 'unselectFontBtn'
    },
    isSelectedFont: function (size) {
      if (this.sizeType === size) {
        return 'selectedFont'
      }
      return 'unselectFont'
    },
    onClickFont: function (size) {
      this.sizeType = size
    },
    isSelectedChipBtn: function (line) {
      if ((this.conditions.line1 && line === 1) || (!this.conditions.line1 && line === 2)) {
        return 'selectedFontBtn'
      }
      return 'unselectFontBtn'
    },
    isSelectedChip: function (line) {
      if ((this.conditions.line1 && line === 1) || (!this.conditions.line1 && line === 2)) {
        return 'selectedFont'
      }
      return 'unselectFont'
    },
    onClickChip: function (line) {
      if (line === 1) {
        this.conditions.line1 = true
      } else {
        this.conditions.line1 = false
      }
    },
    isSelectedSearchBtn: function (val) {
      if ((!this.showAll && val === 1) || (this.showAll && val === 2)) {
        return 'selectedFontBtn'
      }
      return 'unselectFontBtn'
    },
    isSelectedSearch: function (val) {
      if ((!this.showAll && val === 1) || (this.showAll && val === 2)) {
        return 'selectedFont'
      }
      return 'unselectFont'
    },
    onClickSelectSearch: function (val) {
      if (val === 2) {
        this.showAll = true
      } else {
        this.showAll = false
      }
    },
    isSelectedModeBtn: function (val) {
      if ((!this.isUseCheckbox && val === 1) || (this.isUseCheckbox && val === 2)) {
        return 'selectedFontBtn'
      }
      return 'unselectFontBtn'
    },
    isSelectedMode: function (val) {
      if ((!this.isUseCheckbox && val === 1) || (this.isUseCheckbox && val === 2)) {
        return 'selectedFont'
      }
      return 'unselectFont'
    },
    onClickSelectMode: function (val) {
      this.deselectAll()
      if (val === 2) {
        this.isUseCheckbox = true
        // this.isSelectSingleOnly = false
      } else {
        this.isUseCheckbox = false
        // this.isSelectSingleOnly = true
      }
    },
    chipBorderClass: function (order) {
      const bdr = (order && order.sagyoEigyoshoCd === '99') ? 'eigyosho_not_decided ' : ''
      return bdr
    },
    chipKindClass: function (orderId, item) {
      var order = this.getOrderFromOrderID(orderId)
      // console.log('chipkindclass ', orderId, order)
      if (order) {
        const bdr = this.chipBorderClass(order)
        if (order.isWork) {
          // if (item.keikakuKakuteiFlg !== true && order.startLockFlg === false && order.endLockFlg === false) {
          if (item.keikakuKakuteiFlg !== true) {
            return `${bdr}handle works_chip order_chip_on_glid`
          } else {
            return `${bdr}works_chip order_chip_on_glid`
          }
        } else {
          // if (this.viewMode === 0 && item.keikakuKakuteiFlg !== true && order.startLockFlg === false && order.endLockFlg === false) {
          if (this.viewMode === 0 && item.keikakuKakuteiFlg !== true) {
            // 固定時間でもD&Dできる（別な行にうつすのがある）ように
            return `${bdr}handle order_chip order_chip_on_glid`
          } else {
            return `${bdr}order_chip order_chip_on_glid`
          }
        }
      }
    },
    otherChipKindClass: function (item) {
      if (this.viewMode === 0 && item.keikakuKakuteiFlg !== true) {
        return 'handle'
      } else {
        return ''
      }
    },
    fontSizeClass: function () {
      // console.log('☆☆☆ fontSizeClass', this.sizeType)
      if (this.sizeType === -1) {
        return 'fontXsmall'
      } else if (this.sizeType === 1) {
        return 'fontMedium'
      }
      return 'fontSmall'
    },
    fontSizeClass0: function () {
      return 'font0'
    },
    fontSizeWidthClass: function () {
      // console.log('☆☆☆ fontSizeWidthClass', this.sizeType)
      if (this.sizeType === -1) {
        return 'fontXsmallWidth'
      } else if (this.sizeType === 1) {
        return 'fontMediumWidth'
      }
      return 'fontSmallWidth'
    },
    calcChipHeight (line1 = false) {
      var heightSize = 39
      if (line1) {
        heightSize = 19.5
        if (this.sizeType === -1) {
          heightSize = 15
        } else if (this.sizeType === 1) {
          heightSize = 24
        }
      } else {
        if (this.sizeType === -1) {
          heightSize = 30
        } else if (this.sizeType === 1) {
          heightSize = 48
        }
      }
      return heightSize
    },
    handleWorksClass (item) {
      if (this.isUseCheckbox || this.isReadonlyKengen) {
        return ''
      }
      return ' handle'
    },
    handleDriverClass (item) {
      if (this.isUseCheckbox || this.isReadonlyKengen) {
        return ''
      }
      return ' handle'
    },
    handleOrderClass (item) {
      if (this.isUseCheckbox || this.isReadonlyKengen) {
        return ''
      }
      return ' handle'
    },
    checkboxCtrlClass () {
      if (this.sizeType === -1) {
        return 'checkboxontraysmall'
      } else if (this.sizeType === 1) {
        return 'checkboxontraybig'
      }
      return 'checkboxontraymiddle'
    },
    // --------------------------------------------------
    // 実績編集ダイアログ
    // --------------------------------------------------
    onJissekiEditButtonClick: function (item) {
      const self = this
      // filtersRowから100の形のデータを取得する
      this.storeOrderInfoFromScreenSharyo(this.page)
      // todo 24時間以上の表で日付によってtr_sagyo_keikaku_kihonが変わるなら
      // なんか対処する必要があり かわるんだけど、どの日のがいいのか。。。全部渡すか->OK
      const plan = this.sagyoKeikaku.filter((f) => {
        return f.delFlg !== true
      }).filter((f) => {
        var ret = false
        if (item.car.id === f.sharyoId) {
          if (self.isValidDriver(item.driver) && f.jomuinId !== null) {
            if (item.driver.id === f.jomuinId) {
              ret = true
            }
          } else if (!self.isValidDriver(item.driver) && f.jomuinId === null) {
            ret = true
          }
          if (ret) {
            ret = false
            if (self.isValidDriver(item.subDriver) && f.dojoshaId !== null) {
              if (item.subDriver.id === f.dojoshaId) {
                ret = true
              }
            } else if (!self.isValidDriver(item.subDriver) && f.dojoshaId === null) {
              ret = true
            }
          }
          if (ret) {
            if (!(self.isWorksLine(item.orderD) === (f.trSagyoMeisaiId2Array.length > 0))) {
              ret = false
            }
          }
          if (ret) {
            if (!self.tekiyoYmdDayjs.isSame(dayjs(f.sagyoYoteiYmd), 'd')) {
              ret = false
            }
          }
        }
        return ret
      })
      // 保存の時と変わらない構造に変更
      var sm = []
      var ss = []
      plan.forEach((e) => {
        e.trSagyoMeisaiIdArrayList.forEach((es) => {
          const ee = self.keikakuSagyoMeisai.find((et) => {
            return Number(et.id) === Number(es)
          })
          if (ee) {
            sm.push(ee)
          }
        })
        e.trSagyoMeisaiId2ArrayList.forEach((es) => {
          const ee = self.keikakuSagyoMeisai2.find((et) => {
            return Number(et.id) === Number(es)
          })
          if (ee) {
            ss.push(ee)
          }
        })
      })
      const param = {
        vwCD2plmd00200: plan,
        vwCD2plmd00201: sm,
        vwCD2plmd00102: ss,
        // 配車年月日も渡すこととする 20220407
        haishaYmd: this.tekiyoYmdDayjs.format('YYYY/MM/DD')
      }
      console.log('jisseki edit dialog param', param)
      this.recJissekiInfo = param
      this.jissekiEditDialog = true
    },
    onJissekiCloseButtonClick: function () {
      this.jissekiEditDialog = false
      // 保存したときにアイコンの下の"未"が変わるなら何かもらわないと...
    },
    onJissekiSaveButtonClick: function (e) {
      // this.isRecommendReload = false
      // this.searchExec(false)

      const self = this
      // ToDo: e.vwCD2plmd00200の実績確認済みフラグでこちら側の値を更新
      console.log('jisseki kakunin result', e)
      // const flg = e.vwCD2plmd00200.jissekiKakuninZumiFlg
      e.vwCD2plmd00200.forEach((em) => {
        const rec = self.getrecDataFromPlan(em)
        rec.forEach((ef) => {
          ef.jissekiStatus = em.jissekiStatus // 画面表示用実績ステータス
        })
        const frec = self.sagyoKeikaku.find((eg) => {
          return em.id === eg.id
        })
        if (frec) {
          // 保存しているplm100の更新日付などを更新する
          const recvRec = self.shapePlanData(em)
          if (frec.updDateI < recvRec.updDateI) {
            // ぶら下がっている明細などは変わらない前提
            // かわるんであればObject.asignでコピーしてrecCarなどを作り直さないとならない
            frec.updDateI = recvRec.updDateI
            frec.trSagyoKeikakuKihonUpdDateDayjs = recvRec.trSagyoKeikakuKihonUpdDateDayjs
            frec.trSagyoKeikakuKihonUpdUserNm = recvRec.trSagyoKeikakuKihonUpdUserNm
            frec.trSagyoKeikakuSharyoUpdDate = recvRec.trSagyoKeikakuSharyoUpdDate
            frec.trSagyoKeikakuJomuinUpdDate = recvRec.trSagyoKeikakuJomuinUpdDate
            frec.trSagyoKeikakuDojoshaUpdDate = recvRec.trSagyoKeikakuDojoshaUpdDate
            frec.jissekiStatus = recvRec.jissekiStatus
          }
        } else {
          // ない場合はおかしい？
          console.log('nothing same plan ...', e.vwCD2plmd00200, self.sagyoKeikaku)
        }
      })
      e.vwCD2plmd00201.forEach((em) => {
        const frec = self.keikakuSagyoMeisai.find((eg) => {
          return eg.id === em.id
        })
        if (frec) {
          const recvRec = self.shapeJyuchuData(em)
          if (frec.updDateI < recvRec.updDateI) {
            console.log('new data comming..')
            const saveOnTray = frec.isOnTray
            Object.assign(frec, recvRec)
            frec.isOnTray = saveOnTray
          }
        } else {
          // ない場合はおかしい？
          console.log('nothing same juchu ...', e.vwCD2plmd00201, self.self.keikakuSagyoMeisai)
        }
      })
      e.vwCD2plmd00102.forEach((em) => {
        const frec = self.keikakuSagyoMeisai2.find((eg) => {
          return eg.id === em.id
        })
        if (frec) {
          const recvRec = self.shapeSagyoData(em)
          if (frec.updDateI < recvRec.updDateI) {
            const saveOnTray = frec.isOnTray
            Object.assign(frec, recvRec)
            frec.isOnTray = saveOnTray
          }
        } else {
          // ない場合はおかしい？
          console.log('nothing same sagyo ...', e.vwCD2plmd00102, self.self.keikakuSagyoMeisai2)
        }
      })
      this.jissekiEditDialog = false
    },
    // --------------------------------------------------
    // 絞り込み
    // --------------------------------------------------
    // 受注
    onClickOrderFilterOpen () {
      this.orderFilterDialog = true
    },
    // 受注絞り込みコンポーネント終了イベント
    onClickOrderFilterClose () {
      this.orderFilterDialog = false
    },
    onClickOrderFilterClear () {
      this.orderFilterDialog = false
    },
    // 受注絞り込みコンポーネントOKイベント
    onClickOrderFilterExec (value) {
      console.log(value)
      this.orderFilterConditions = Object.assign({}, value)
      this.orderFilterDialog = false
    },
    // 受注検索チェック
    isOrderSearchCheck (elem) {
      const self = this
      return (!self.orderFilterConditions.ninushiCd || elem.ninushiCd === self.orderFilterConditions.ninushiCd) &&
      (!self.orderFilterConditions.ninushiNm || elem.ninushiNm.indexOf(self.orderFilterConditions.ninushiNm) !== -1) &&
      (!self.orderFilterConditions.hatsuchiCd || elem.hatsuchiCd === self.orderFilterConditions.hatsuchiCd) &&
      (!self.orderFilterConditions.hatsuchiNm || (elem.hatsuchiNm.indexOf(self.orderFilterConditions.hatsuchiNm) !== -1 || elem.hatsuchiBiko.indexOf(self.orderFilterConditions.hatsuchiNm) !== -1)) &&
      (!self.orderFilterConditions.hatsuchiFromHms || elem.hatsuchiHms >= self.orderFilterConditions.hatsuchiFromHms) &&
      (!self.orderFilterConditions.hatsuchiToHms || elem.hatsuchiHms <= self.orderFilterConditions.hatsuchiToHms) &&
      (!self.orderFilterConditions.chakuchiCd || elem.chakuchiCd === self.orderFilterConditions.chakuchiCd) &&
      (!self.orderFilterConditions.chakuchiNm || (elem.chakuchiNm.indexOf(self.orderFilterConditions.chakuchiNm) !== -1 || elem.chakuchiBiko.indexOf(self.orderFilterConditions.chakuchiNm) !== -1)) &&
      (!self.orderFilterConditions.chakuchiFromHms || elem.chakuchiHms >= self.orderFilterConditions.chakuchiFromHms) &&
      (!self.orderFilterConditions.chakuchiToHms || elem.chakuchiHms <= self.orderFilterConditions.chakuchiToHms) &&
      (!self.orderFilterConditions.juchuEigyoshoCd || elem.juchuEigyoshoCd === self.orderFilterConditions.juchuEigyoshoCd) &&
      (!self.orderFilterConditions.juchuEigyoshoNm || elem.juchuEigyoshoNm.indexOf(self.orderFilterConditions.juchuEigyoshoNm) !== -1) &&
      (!self.orderFilterConditions.sagyoEigyoshoCd || elem.sagyoEigyoshoCd === self.orderFilterConditions.sagyoEigyoshoCd) &&
      (!self.orderFilterConditions.sagyoEigyoshoNm || elem.sagyoEigyoshoNm.indexOf(self.orderFilterConditions.sagyoEigyoshoNm) !== -1) &&
      (!self.orderFilterConditions.unkoYmd || (elem.hatsuchiDayjs.isSameOrBefore(dayjs(self.orderFilterConditions.unkoYmd), 'd') && dayjs(self.orderFilterConditions.unkoYmd).isSameOrBefore(elem.chakuchiDayjs, 'd'))) &&
      (!self.orderFilterConditions.freeWord || JSON.stringify(elem).indexOf(self.orderFilterConditions.freeWord) !== -1) &&
      (!self.orderFilterConditions.chumonNo || (elem.chumonNo && elem.chumonNo.indexOf(self.orderFilterConditions.chumonNo) !== -1))
    },
    // 乗務員
    onClickDriverFilterOpen () {
      // this.$modal.show('driver-filter-dialog')
      this.driverFilterDialog = true
    },
    // 乗務員絞り込みコンポーネント終了イベント
    onClickDriverFilterClose () {
      this.driverFilterDialog = false
    },
    onClickDriverFilterClear () {
      this.driverFilterDialog = false
    },
    // 乗務員絞り込みコンポーネントOKイベント
    onClickDriverFilterExec (value) {
      console.log(value)
      this.driverFilterConditions = Object.assign({}, value)
      this.driverFilterDialog = false
    },
    // 車両情報検索チェック
    isCarSearchCheck (elem) {
      const self = this
      return (!self.carFilterConditions.sharyoCd || elem.sharyoCd === self.carFilterConditions.sharyoCd) &&
      (!self.carFilterConditions.jidoshaHyojiNm || elem.jidoshaHyojiNm.indexOf(self.carFilterConditions.jidoshaHyojiNm) !== -1) &&
      (!self.carFilterConditions.shashuSbt || elem.shashuSbt === self.carFilterConditions.shashuSbt) &&
      (!self.carFilterConditions.eigyoshoCd || elem.eigyoshoCd === self.carFilterConditions.eigyoshoCd) &&
      (!self.carFilterConditions.eigyoshoNm || elem.eigyoshoNm.indexOf(self.carFilterConditions.eigyoshoNm) !== -1) &&
      (self.carFilterConditions.onDriver === 0 || self.isHasDriverOnCar(elem.id) === self.carFilterConditions.onDriver) &&
      (self.carFilterConditions.onYosha === 0 || ((elem.hacchusakiFlg === false) ? 1 : 2) === self.carFilterConditions.onYosha)
    },
    // 車両
    onClickCarFilterOpen () {
      this.carFilterDialog = true
    },
    onClickCarFilterClose () {
      this.carFilterDialog = false
    },
    onClickCarFilterClear () {
      this.carFilterDialog = false
    },
    onClickCarFilterExec (value) {
      console.log(value)
      this.carFilterConditions = Object.assign({}, value)
      this.carFilterDialog = false
    },
    // 乗務員検索チェック
    isDriverSearchCheck (elem) {
      const self = this
      return (!self.driverFilterConditions.jininCd || elem.jininCd === self.driverFilterConditions.jininCd) &&
      (!self.driverFilterConditions.jininNm || elem.jininNm.indexOf(self.driverFilterConditions.jininNm) !== -1) &&
      (!self.driverFilterConditions.eigyoshoCd || elem.eigyoshoCd === self.driverFilterConditions.eigyoshoCd) &&
      (!self.driverFilterConditions.eigyoshoNm || elem.eigyoshoNm.indexOf(self.driverFilterConditions.eigyoshoNm) !== -1) &&
      (self.driverFilterConditions.isOnlyJomuin === false || elem.jomuFlg === true)
    },
    // 実績フィルター
    onJissekiFilterOpen (elem) {
      this.jissekiFilterDialog = true
    },
    onClickJissekiFilterClose () {
      this.jissekiFilterDialog = false
    },
    onClickJissekiFilterClear () {
      this.jissekiFilterDialog = false
    },
    onClickJissekiFilterExec (value) {
      console.log(value)
      this.jissekiFilterConditions = Object.assign([], value)
      this.jissekiFilterDialog = false
    },
    isJissekiFilterCheck (elem) {
      if (this.isJissekiFilterOn === false) {
        return true
      }
      // true/falseの場合暫定
      /*
      if (elem.jissekiUmuFlg === true) {
        var code = '1'
      } else if (elem.jissekiUmuFlg === false) {
        code = '0'
      } else {
        code = elem.jissekiUmuFlg
      }
      */
      var code = elem.jissekiStatus

      const m = this.jissekiFilterConditions.find((e) => {
        return e.code === code
      })
      if (m) {
        return m.value
      }
      return true
    },
    /**
     * 指定された車両にドライバが設定されているかを調べる
     * @param {long} carid 車両ID
     * @returns 1: 乗務員設定あり 2:乗務員なし
     */
    isHasDriverOnCar (carid) {
      const self = this
      const rows = this.recCar.find((e) => {
        return e.car.id === carid && self.isValidDriver(e.driver)
      })
      if (rows) {
        return 1
      }
      return 2
    },
    // --------------------------------------------------
    // 並び替え
    // --------------------------------------------------
    // 受注
    onClickOrderSortOpen () {
      this.orderSortDialog = true
    },
    // 受注並び替えコンポーネント終了イベント
    onClickOrderSortClose () {
      this.orderSortDialog = false
    },
    onClickOrderSortClear () {
    },
    // 受注並び替えコンポーネントOKイベント
    onClickOrderSortExec (value) {
      console.log(value)
      const self = this
      self.orderSortArgs = Object.assign({}, value)
      self.orderSortDialog = false
    },
    sortOrder (elem1, elem2) {
      const self = this
      // 第一キーソート
      let ret = (self.orderSortArgs.orderSortKey1 === 'desc') ? -1 : 1
      switch (self.orderSortArgs.orderSortKeyValue1) {
        case 'ninushiCd':
          if (elem1.ninushiCd > elem2.ninushiCd) { return ret }
          if (elem1.ninushiCd < elem2.ninushiCd) { return ret * -1 }
          break
        case 'ninushiNm':
          if (elem1.ninushiNm > elem2.ninushiNm) { return ret }
          if (elem1.ninushiNm < elem2.ninushiNm) { return ret * -1 }
          break
        case 'hatsuchiCd':
          if (elem1.hatsuchiCd > elem2.hatsuchiCd) { return ret }
          if (elem1.hatsuchiCd < elem2.hatsuchiCd) { return ret * -1 }
          break
        case 'hatsuchiNm':
          if (elem1.hatsuchiNm > elem2.hatsuchiNm) { return ret }
          if (elem1.hatsuchiNm < elem2.hatsuchiNm) { return ret * -1 }
          break
        case 'hatsuchiHms':
          if (elem1.hatsuchiHms > elem2.hatsuchiHms) { return ret }
          if (elem1.hatsuchiHms < elem2.hatsuchiHms) { return ret * -1 }
          break
        case 'chakuchiCd':
          if (elem1.chakuchiCd > elem2.chakuchiCd) { return ret }
          if (elem1.chakuchiCd < elem2.chakuchiCd) { return ret * -1 }
          break
        case 'chakuchiNm':
          if (elem1.chakuchiNm > elem2.chakuchiNm) { return ret }
          if (elem1.chakuchiNm < elem2.chakuchiNm) { return ret * -1 }
          break
        case 'chakuchiHms':
          if (elem1.chakuchiHms > elem2.chakuchiHms) { return ret }
          if (elem1.chakuchiHms < elem2.chakuchiHms) { return ret * -1 }
          break
        default:
          break
      }

      // 第二キーソート
      ret = (self.orderSortArgs.orderSortKey2 === 'desc') ? -1 : 1
      switch (self.orderSortArgs.orderSortKeyValue2) {
        case 'ninushiCd':
          if (elem1.ninushiCd > elem2.ninushiCd) { return ret }
          if (elem1.ninushiCd < elem2.ninushiCd) { return ret * -1 }
          break
        case 'ninushiNm':
          if (elem1.ninushiNm > elem2.ninushiNm) { return ret }
          if (elem1.ninushiNm < elem2.ninushiNm) { return ret * -1 }
          break
        case 'hatsuchiCd':
          if (elem1.hatsuchiCd > elem2.hatsuchiCd) { return ret }
          if (elem1.hatsuchiCd < elem2.hatsuchiCd) { return ret * -1 }
          break
        case 'hatsuchiNm':
          if (elem1.hatsuchiNm > elem2.hatsuchiNm) { return ret }
          if (elem1.hatsuchiNm < elem2.hatsuchiNm) { return ret * -1 }
          break
        case 'hatsuchiHms':
          if (elem1.hatsuchiHms > elem2.hatsuchiHms) { return ret }
          if (elem1.hatsuchiHms < elem2.hatsuchiHms) { return ret * -1 }
          break
        case 'chakuchiCd':
          if (elem1.chakuchiCd > elem2.chakuchiCd) { return ret }
          if (elem1.chakuchiCd < elem2.chakuchiCd) { return ret * -1 }
          break
        case 'chakuchiNm':
          if (elem1.chakuchiNm > elem2.chakuchiNm) { return ret }
          if (elem1.chakuchiNm < elem2.chakuchiNm) { return ret * -1 }
          break
        case 'chakuchiHms':
          if (elem1.chakuchiHms > elem2.chakuchiHms) { return ret }
          if (elem1.chakuchiHms < elem2.chakuchiHms) { return ret * -1 }
          break
        default:
          break
      }

      // 第三キーソート
      ret = (self.orderSortArgs.orderSortKey3 === 'desc') ? -1 : 1
      switch (self.orderSortArgs.orderSortKeyValue3) {
        case 'ninushiCd':
          if (elem1.ninushiCd > elem2.ninushiCd) { return ret }
          if (elem1.ninushiCd < elem2.ninushiCd) { return ret * -1 }
          break
        case 'ninushiNm':
          if (elem1.ninushiNm > elem2.ninushiNm) { return ret }
          if (elem1.ninushiNm < elem2.ninushiNm) { return ret * -1 }
          break
        case 'hatsuchiCd':
          if (elem1.hatsuchiCd > elem2.hatsuchiCd) { return ret }
          if (elem1.hatsuchiCd < elem2.hatsuchiCd) { return ret * -1 }
          break
        case 'hatsuchiNm':
          if (elem1.hatsuchiNm > elem2.hatsuchiNm) { return ret }
          if (elem1.hatsuchiNm < elem2.hatsuchiNm) { return ret * -1 }
          break
        case 'hatsuchiHms':
          if (elem1.hatsuchiHms > elem2.hatsuchiHms) { return ret }
          if (elem1.hatsuchiHms < elem2.hatsuchiHms) { return ret * -1 }
          break
        case 'chakuchiCd':
          if (elem1.chakuchiCd > elem2.chakuchiCd) { return ret }
          if (elem1.chakuchiCd < elem2.chakuchiCd) { return ret * -1 }
          break
        case 'chakuchiNm':
          if (elem1.chakuchiNm > elem2.chakuchiNm) { return ret }
          if (elem1.chakuchiNm < elem2.chakuchiNm) { return ret * -1 }
          break
        case 'chakuchiHms':
          if (elem1.chakuchiHms > elem2.chakuchiHms) { return ret }
          if (elem1.chakuchiHms < elem2.chakuchiHms) { return ret * -1 }
          break
        default:
          break
      }

      return 0
    },
    // 乗務員
    onClickDriverSortOpen () {
      this.driverSortDialog = true
    },
    // 乗務員並び替えコンポーネント終了イベント
    onClickDriverSortClose () {
      this.driverSortDialog = false
    },
    onClickDriverSortClear () {
    },
    // 乗務員並び替えコンポーネントOKイベント
    onClickDriverSortExec (value) {
      console.log(value)
      const self = this
      self.driverSortArgs = Object.assign({}, value)
      self.driverSortDialog = false
      self.keikakuJininList.sort((elem1, elem2) => {
        return self.funcDriverSort(elem1, elem2)
      })
    },
    funcDriverSort (elem1, elem2) {
      const self = this
      // 第一キーソート
      var ret = (self.driverSortArgs.driverSortKey1 === 'desc') ? -1 : 1
      switch (self.driverSortArgs.driverSortKeyValue1) {
        case 'jininCd':
          if (elem1.jininCd > elem2.jininCd) { return ret }
          if (elem1.jininCd < elem2.jininCd) { return ret * -1 }
          break
        case 'jininNm':
          if (elem1.jininNmSei + elem1.jininNmMei > elem2.jininNmSei + elem2.jininNmMei) { return ret }
          if (elem1.jininNmSei + elem1.jininNmMei < elem2.jininNmSei + elem2.jininNmMei) { return ret * -1 }
          break
        case 'eigyoshoCd':
          if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return ret }
          if (elem1.eigyoshoCd < elem2.eigyoshoCd) { return ret * -1 }
          break
        case 'eigyoshoNm':
          if (elem1.eigyoshoNm > elem2.eigyoshoNm) { return ret }
          if (elem1.eigyoshoNm < elem2.eigyoshoNm) { return ret * -1 }
          break
        default:
          break
      }

      // 第二キーソート
      ret = (self.driverSortArgs.driverSortKey2 === 'desc') ? -1 : 1
      switch (self.driverSortArgs.driverSortKeyValue2) {
        case 'jininCd':
          if (elem1.jininCd > elem2.jininCd) { return ret }
          if (elem1.jininCd < elem2.jininCd) { return ret * -1 }
          break
        case 'jininNm':
          if (elem1.jininNmSei + elem1.jininNmMei > elem2.jininNmSei + elem2.jininNmMei) { return ret }
          if (elem1.jininNmSei + elem1.jininNmMei < elem2.jininNmSei + elem2.jininNmMei) { return ret * -1 }
          break
        case 'eigyoshoCd':
          if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return ret }
          if (elem1.eigyoshoCd < elem2.eigyoshoCd) { return ret * -1 }
          break
        case 'eigyoshoNm':
          if (elem1.eigyoshoNm > elem2.eigyoshoNm) { return ret }
          if (elem1.eigyoshoNm < elem2.eigyoshoNm) { return ret * -1 }
          break
        default:
          break
      }

      // 第三キーソート
      ret = (self.driverSortArgs.driverSortKey3 === 'desc') ? -1 : 1
      switch (self.driverSortArgs.driverSortKeyValue3) {
        case 'jininCd':
          if (elem1.jininCd > elem2.jininCd) { return ret }
          if (elem1.jininCd < elem2.jininCd) { return ret * -1 }
          break
        case 'jininNm':
          if (elem1.jininNmSei + elem1.jininNmMei > elem2.jininNmSei + elem2.jininNmMei) { return ret }
          if (elem1.jininNmSei + elem1.jininNmMei < elem2.jininNmSei + elem2.jininNmMei) { return ret * -1 }
          break
        case 'eigyoshoCd':
          if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return ret }
          if (elem1.eigyoshoCd < elem2.eigyoshoCd) { return ret * -1 }
          break
        case 'eigyoshoNm':
          if (elem1.eigyoshoNm > elem2.eigyoshoNm) { return ret }
          if (elem1.eigyoshoNm < elem2.eigyoshoNm) { return ret * -1 }
          break
        default:
          break
      }

      return 0
    },
    // チケットエリア表示切替
    onClickTicketVisibleChange () {
      this.ticketVisibleFlag = !this.ticketVisibleFlag
    },
    // --------------------------------------------------
    // CSV出力
    // --------------------------------------------------
    calcHours (str) {
      if (str) {
        if (str === '24時間') {
          return 24
        } else if (str === '48時間') {
          return 48
        } else if (str === '3日') {
          return 72
        } else if (str === '5日') {
          return 120
        } else if (str === '7日') {
          return 168
        } else {
          return 24
        }
      }
    },
    onCsvButtonClick () {
      this.csvSearchConditions.tekiyoYmd = this.conditions.tekiyoYmdInput
      var sdjs = dayjs(this.csvSearchConditions.tekiyoYmd).add(Number(String(this.conditions.tableStartHourDisp).replace(':00', '')), 'h')
      this.csvSearchConditions.sagyoYoteiYmdFrom = sdjs.format('YYYY/MM/DD HH:mm:ss')
      this.csvSearchConditions.sagyoYoteiYmdTo = sdjs.add(this.calcHours(this.conditions.rangeDisp), 'h').format('YYYY/MM/DD HH:mm:ss')
      this.csvSearchConditions.haishahyoCd = this.conditions.haishahyoCdDisp
      this.csvSearchConditions.eigyoshoCd = this.conditions.eigyoshoCdDisp
      this.isCsvDownloader = true
      this.HttpClient.post('/api/v1/VwCD2plmd00107/download', this.csvSearchConditions).then((data) => {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, data], { type: 'text/csv' })
        const elem = document.getElementById('download')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = '配車計画_' + this.getFormatDate(new Date()) + '.csv'
        this.isCsvDownloader = false
        elem.click()
      })
    },
    getFormatDate: function (date) {
      // const formatDate = new Date(date)
      // const Y = formatDate.getFullYear()
      // const M = ('00' + (formatDate.getMonth() + 1)).slice(-2)
      // const D = ('00' + formatDate.getDate()).slice(-2)
      // const h = ('00' + formatDate.getHours()).slice(-2)
      // const m = ('00' + formatDate.getMinutes()).slice(-2)
      // const s = ('00' + formatDate.getSeconds()).slice(-2)
      // return Y + M + D + '_' + h + m + s
      const djs = dayjs(date)
      return djs.format('YYYYMMDD_HHmmss')
    },
    // --------------------------------------------------
    // 配車複写
    // --------------------------------------------------
    onHaishaCopyButtonClick () {
      // パラメータ設定
      this.haishaCopyConditions.fromHaishaYmd = this.conditions.tekiyoYmdInput
      this.haishaCopyConditions.mstHaishaHyoId = this.conditions.haishahyoCdDisp
      this.haishaCopyConditions.startHM = this.conditions.tableStartHourDisp
      this.haishaCopyConditions.isScreenDataUpdated = this.hasUpdateDats()

      this.haishaCopyDialog = true
    },
    onHaishaCopyCloseClick (e) {
      this.haishaCopyDialog = false
      if (e !== false) {
        this.isRecommendReload = false
        this.searchExec(false)
      }
    },
    // --------------------------------------------------
    // 定型追加
    // --------------------------------------------------
    onAddTeikeiButtonClick () {
      this.teikeiCopyConditions.HaishaYmd = this.conditions.tekiyoYmdInput
      this.teikeiCopyConditions.startHM = this.conditions.tableStartHourDisp
      this.addTeikeiDialog = true
    },
    onAddTeikeiCloseClick (e) {
      this.addTeikeiDialog = false
      if (e !== false) {
        // 更新のみの受注読込処理
        this.loadJuchu(true)
      }
    },

    // --------------------------------------------------
    // 共通
    // --------------------------------------------------
    getEigyoshoId: function (pEigyoshoCd) {
      const target = filter.dateFormatter(new Date())
      // var eigyosho = this.eigyoshoList.filter((t) => {
      //   return t.eigyoshoCd === pEigyoshoCd && t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      // })
      // if (eigyosho.length > 0) {
      //   return eigyosho[0].id
      // }
      const r = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', pEigyoshoCd, target)
      if (r) {
        return r.id
      }
      return ''
    },
    getEigyoshoNmFromCd: function (pEigyoshoCd) {
      const target = filter.dateFormatter(new Date())
      // var eigyosho = this.eigyoshoList.filter((t) => {
      //   return t.eigyoshoCd === pEigyoshoCd && t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      // })
      // if (eigyosho.length > 0) {
      //   return eigyosho[0].eigyoshoNm
      // }
      const r = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', pEigyoshoCd, target)
      if (r) {
        return r.eigyoshoNm
      }
      return ''
    },
    getTorihikisakiNmFromId: function (pTorihikisakiId) {
      // var torihikisaki = this.torihikisakiList.filter((t) => {
      //   return t.id === pTorihikisakiId
      // })
      // if (torihikisaki.length > 0) {
      //   return torihikisaki[0].torihikisakiNm
      // }
      const r = indexeddb.getRecord(this.torihikisakiList, pTorihikisakiId)
      if (r) {
        return r.torihikisakiNm
      }
      return ''
    },
    getTorihikisakiColorCodeFromId: function (pTorihikisakiId) {
      // var torihikisaki = this.torihikisakiList.filter((t) => {
      //   return t.id === pTorihikisakiId
      // })
      // if (torihikisaki.length > 0) {
      //   return torihikisaki[0].color
      // }
      const r = indexeddb.getRecord(this.torihikisakiList, pTorihikisakiId)
      if (r) {
        return r.color
      }
      return null
    },
    getHacchakuchiFromId: function (pHacchakuchiId) {
      // var hacchakuchi = this.hacchakuchiList.find((t) => {
      //   return t.id === pHacchakuchiId
      // })
      // console.log('use hacchakuti', hacchakuchi, pHacchakuchiId)
      // return hacchakuchi
      return indexeddb.getRecord(this.hacchakuchiList, pHacchakuchiId)
    },
    getUriageBunruiSyubetsuFromCd: function (pSbtCd) {
      // var shubetsu = this.shubetsuList.filter((t) => {
      //   return t.sbtShuruiCd === 'SBT025' && t.sbtCd === pSbtCd
      // })
      // if (shubetsu.length > 0) {
      //   return shubetsu[0].sbtNm
      // }
      const r = indexeddb.getShubetsu(this.currentKaishaCode, this.shubetsuList, 'SBT025', pSbtCd)
      if (r) {
        return r.sbtNm
      }
      return ''
    },
    getShashuSbt: function (pSbtCd) {
      // var shubetsu = this.shubetsuList.filter((t) => {
      //   return t.sbtShuruiCd === 'GVI011' && t.sbtCd === pSbtCd
      // })
      // if (shubetsu.length > 0) {
      //   return shubetsu[0].sbtNm
      // }
      const r = indexeddb.getShubetsu(this.currentKaishaCode, this.shubetsuList, 'GVI011', pSbtCd)
      if (r) {
        return r.sbtNm
      }
      return ''
    },
    getJininId: function (pJininCd) {
      const target = filter.dateFormatter(new Date())
      // var jinin = this.eigyoshoJininList.find((t) => {
      //   return t.jininCd === pJininCd && t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      // })
      // if (jinin) {
      //   return jinin.id
      // }
      const r = indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoJininList, 'jininCd', pJininCd, target)
      if (r) {
        return r.id
      }
      return null
    },
    getJininNmFromId: function (pJininId) {
      // var jinin = this.eigyoshoJininList.find((t) => {
      //   return t.id === pJininId
      // })
      const r = indexeddb.getRecord(this.eigyoshoJininList, pJininId)
      if (r) {
        return r.jininNmSei
      }
      return ''
    },
    getSharyoColorFromId: function (pSharyoId) {
      const r = indexeddb.getRecord(this.sharyoList, pSharyoId)
      if (r) {
        return r.color
      }
      return null
    },
    listObject (obj) {
      var s = ''
      for (const [key, value] of Object.entries(obj)) {
        s += `${key}:${value};`
      }
      return s
    },
    // #endregion
    // #region デバッグ用
    onDebugging () {
      this.isDebugging = false
    },
    onChangePageData (n, o) {
      console.log('change page', n, o)
      if (this.viewMode === 0) {
        this.storeOrderInfoFromScreenSharyo(o)
        this.createCarRecords()
      } else {
        this.storeOrderInfoFromScreenDriver(o)
        this.createDriverRecords()
      }
    },
    // onChangePageDataI (e) {
    //   console.log('input', e)
    // },
    // #endregion
    // #region "データ整形"
    fixHms (order) {
      if (order.isWork) {
        if (order.startHms && order.endHms) {
          return
        }
        if (!order.startHms) {
          order.startHms = this.tekiyoYmdDayjs.format('HH:mm')
          order.hatsuchiDayjs = dayjs(order.startYmd + ' ' + order.startHms)
          order.startDayjs = order.hatsuchiDayjs.clone()
        }
        if (!order.endHms) {
          order.endDayjs = order.startDayjs.add(DEFUALT_ORDER_LENGTH, 'minute')
          order.endHms = order.endDayjs.format('HH:mm')
          order.endYmd = order.endDayjs.format('YYYY/MM/DD')
          order.chakutchiDayjs = order.endDayjs.clone()
        }
      } else {
        if (order.hatsuchiHms && order.chakuchiHms) {
          return
        }
        if (!order.hatsuchiHms) {
          order.hatsuchiHms = this.tekiyoYmdDayjs.format('HH:mm')
          order.hatsuchiDayjs = dayjs(order.hatsuchiYmd + ' ' + order.hatsuchiHms)
        }
        if (!order.chakuchiHms) {
          order.chakuchiDayjs = order.hatsuchiDayjs.add(DEFUALT_ORDER_LENGTH, 'minute')
          order.chakuchiHms = order.chakuchiDayjs.format('HH:mm')
          order.chakuchiYmd = order.chakuchiDayjs.format('YYYY/MM/DD')
        }
      }
    },
    shapeJyuchuData (e) {
      const self = this
      if (e.hatsuchiYmd) {
        e.hatsuchiDayjs = dayjs(e.hatsuchiYmd)
        e.hatsuchiYmd = e.hatsuchiDayjs.format('YYYY/MM/DD')
        e.hatsuchiDayjs = dayjs(e.hatsuchiYmd + ' ' + e.hatsuchiHms)
      } else {
        e.hatsuchiDayjs = self.tekiyoYmdDayjs
      }
      if (e.hatsuchiYmd) {
        e.chakuchiDayjs = dayjs(e.chakuchiYmd)
        e.chakuchiYmd = e.chakuchiDayjs.format('YYYY/MM/DD')
        e.chakuchiDayjs = dayjs(e.chakuchiYmd + ' ' + e.chakuchiHms)
      } else {
        e.chakuchiDayjs = self.tekiyoYmdDayjs
      }

      // 時間が設定されていないとき、、、
      if (e.chakuchiDayjs.isSameOrBefore(e.hatsuchiDayjs)) {
        e.chakuchiDayjs = e.hatsuchiDayjs.add(DEFUALT_ORDER_LENGTH, 'm')
        if (e.chakuchiHms) {
          e.chakuchiHms = e.chakuchiDayjs.format('HH:mm')
        }
      }
      // チップの色設定
      if (e.juchuYmd) {
        e.juchuYmd = dayjs(e.juchuYmd).format('YYYY/MM/DD')
      }
      if (e.sagyoYmd) {
        e.sagyoYmd = dayjs(e.sagyoYmd).format('YYYY/MM/DD')
      }
      if (e.seikyuYoteiYmd) {
        e.seikyuYoteiYmd = dayjs(e.seikyuYoteiYmd).format('YYYY/MM/DD')
      }
      if (e.hatsuchiHms) {
        e.hatsuchiHms = e.hatsuchiHms.slice(0, 5)
      }
      if (e.chakuchiHms) {
        e.chakuchiHms = e.chakuchiHms.slice(0, 5)
      }
      if (!e.hatsuchiNm) {
        e.hatsuchiNm = ''
      }
      if (!e.chakuchiNm) {
        e.chakuchiNm = ''
      }
      e.chakuchiColor = self.getTorihikisakiColorCodeFromId(e.ninushiId) ?? '#66cdaa'
      e.hatsuchiColor = self.getTorihikisakiColorCodeFromId(e.oroshisakiId) ?? '#ffffe0'
      if (e.color) {
        e.chakuchiColor = e.color
      }
      // if (typeof e.isOnTray === 'undefined') {
      //   // とりあえずsagyoYoteiYmdがnullのだけトレイに表示
      //   if (!e.sagyoYoteiYmd) {
      //   e.isOnTray = true
      //   }
      // }
      if (e.isOnTray !== false && e.isOnTray !== true) {
        e.isOnTray = true
        if (e.sagyoYoteiYmd) {
          e.isOnTray = false
        }
      }
      if (typeof e.updateFlg === 'undefined') {
        e.updateFlg = false
      }
      // e.chakuchi = self.getHacchakuchiFromId(e.chakuchiId)
      // e.hatsuchi = self.getHacchakuchiFromId(e.hatsuchiId)
      e.kamotsuKbnNm = self.getUriageBunruiSyubetsuFromCd(e.kamotsuKbn)
      e.seikyuShashuSbtNm = self.getShashuSbt(e.seikyuShashuSbt)
      e.isWork = false
      var a = []
      if (e.trJuchuKihonUpdDate) {
        a.push(dayjs(e.trJuchuKihonUpdDate))
      }
      if (e.trJuchuKihonKingakuUpdDate) {
        a.push(dayjs(e.trJuchuKihonKingakuUpdDate))
      }
      if (e.trJuchuMeisaiUpdDate) {
        a.push(dayjs(e.trJuchuMeisaiUpdDate))
      }
      if (e.trJuchuMeisaiKingakuUpdDate) {
        a.push(dayjs(e.trJuchuMeisaiKingakuUpdDate))
      }
      if (e.trSagyoMeisaiUpdDate) {
        a.push(dayjs(e.trSagyoMeisaiUpdDate))
      }
      if (e.trSagyoMeisaiKingakuUpdDate) {
        a.push(dayjs(e.trSagyoMeisaiKingakuUpdDate))
      }
      if (a.length > 0) {
        e.updDateI = dayjs.max(a).toJSON()
      }
      e.isSelected = false
      e.delFlg = false
      return e
    },
    shapeSagyoData (e) {
      const self = this
      e.isWork = true
      if (e.startYmd) {
        e.startDayjs = dayjs(e.startYmd)
        e.startYmd = e.startDayjs.format('YYYY/MM/DD')
        e.startDayjs = dayjs(e.startYmd + ' ' + e.startHms)
      } else {
        e.startDayjs = self.tekiyoYmdDayjs
      }
      if (e.endYmd) {
        e.endDayjs = dayjs(e.endYmd)
        e.endYmd = e.endDayjs.format('YYYY/MM/DD')
        e.endDayjs = dayjs(e.endYmd + ' ' + e.endHms)
      } else {
        e.endDayjs = e.startDayjs.add(1, 'h')
      }
      if (e.startDayjs.isAfter(e.endDayjs)) {
        e.endDayjs = e.startDayjs.add(1, 'h')
      }
      if (e.sagyoYmd) {
        e.sagyoYmd = dayjs(e.sagyoYmd).format('YYYY/MM/DD')
      }
      if (e.startHms) {
        e.startHms = e.startHms.slice(0, 5)
      }
      if (e.endHms) {
        e.endHms = e.endHms.slice(0, 5)
      }

      // 仮
      e.hatsuchiDayjs = e.startDayjs.clone()
      e.chakuchiDayjs = e.endDayjs.clone()
      // if (typeof e.isOnTray === 'undefined') {
      //   // とりあえずsagyoYoteiYmdがnullのだけトレイに表示
      //   if (!e.sagyoYoteiYmd) {
      //     e.isOnTray = true
      //   }
      // }
      if (e.isOnTray !== false && e.isOnTray !== true) {
        e.isOnTray = true
        if (e.sagyoYoteiYmd) {
          e.isOnTray = false
        }
      }
      if (typeof e.updateFlg === 'undefined') {
        e.updateFlg = false
      }
      e.updDateI = e.trSagyoMeisaiUpdDate
      e.isSelected = false
      e.delFlg = false
      return e
    },
    shapePlanData (e) {
      // const self = this
      e.isWorksPlan = null
      if (e.trSagyoMeisaiIdArray.length === 0) {
        e.trSagyoMeisaiIdArrayList = []
      } else {
        e.trSagyoMeisaiIdArrayList = e.trSagyoMeisaiIdArray.split(',')
        e.isWorksPlan = false
      }
      if (e.trSagyoMeisaiId2Array.length === 0) {
        e.trSagyoMeisaiId2ArrayList = []
      } else {
        e.trSagyoMeisaiId2ArrayList = e.trSagyoMeisaiId2Array.split(',')
        e.isWorksPlan = true
      }
      e.updateFlg = false
      e.jomuinKakuteiFlg = !!e.jomuinKakuteiFlg
      e.dojoshaKakuteiFlg = !!e.dojoshaKakuteiFlg

      var a = []
      if (e.trSagyoKeikakuKihonUpdDate) {
        a.push(dayjs(e.trSagyoKeikakuKihonUpdDate))
      }
      if (e.trSagyoKeikakuSharyoUpdDate) {
        a.push(dayjs(e.trSagyoKeikakuSharyoUpdDate))
      }
      if (e.trSagyoKeikakuJomuinUpdDate) {
        a.push(dayjs(e.trSagyoKeikakuJomuinUpdDate))
      }
      if (e.trSagyoKeikakuDojoshaUpdDate) {
        a.push(dayjs(e.trSagyoKeikakuDojoshaUpdDate))
      }
      if (a.length > 0) {
        e.updDateI = dayjs.max(a).toJSON()
      }
      e.trSagyoKeikakuKihonInsDateDayjs = dayjs(e.trSagyoKeikakuKihonInsDate)
      e.trSagyoKeikakuKihonInsUserNm = this.getJininNmFromId(e.trSagyoKeikakuKihonInsUserId)
      e.trSagyoKeikakuKihonUpdDateDayjs = dayjs(e.trSagyoKeikakuKihonUpdDate)
      e.trSagyoKeikakuKihonUpdUserNm = this.getJininNmFromId(e.trSagyoKeikakuKihonUpdUserId)

      return e
    },
    /**
     * recCar及びrecDriverの新規レコードを作る。driver,subDriver,carは設定しない
     * @param {} rec
     * @returns rec
     */
    setNewRecords (rec) {
      if (this.viewMode === 0) {
        rec.id = this.getNewLineIdCar()
      } else {
        rec.id = this.getNewLineIdDriver()
      }
      rec.orderD = []
      // rec.masterFlg = false
      rec.keikakuKakuteiFlg = false
      rec.jissekiStatus = '0'
      rec.updateFlg = true
      rec.jomuinKakuteiFlg = false
      rec.dojoshaKakuteiFlg = false
      rec.trSagyoKeikakuKihonInsDateDayjs = null
      rec.trSagyoKeikakuKihonInsUserNm = ''
      rec.trSagyoKeikakuKihonUpdDateDayjs = null
      rec.trSagyoKeikakuKihonUpdUserNm = ''
      rec.isEqualUnkouYmdAndTekiyoYmd = true
      return rec
    },
    // #endregion
    // #region 複数貼り付け関係
    getSelectedCount () {
      var count
      count = this.keikakuSagyoMeisai.filter((e) => {
        return e.isSelected === true
      }).length
      count += this.keikakuSagyoMeisai2.filter((e) => {
        return e.isSelected === true
      }).length
      return count
    },
    getSelectedDriverCount () {
      var count
      count = this.keikakuJininList.filter((e) => {
        return e.isSelected === true
      }).length
      return count
    },
    deselectAll () {
      this.keikakuSagyoMeisai.forEach((e) => {
        e.isSelected = false
      })
      this.keikakuSagyoMeisai2.forEach((e) => {
        e.isSelected = false
      })
      this.deselectAllDrivers()
    },
    deselectAllDrivers () {
      this.keikakuJininList.forEach((e) => {
        e.isSelected = false
        e.selectionNumber = 0
      })
    },
    deselect1Drivers (item) {
      const origNumber = item.selectionNumber
      item.selectionNumber = 0
      item.isSelected = false
      const drs = this.getSelectedDriver()
      drs.forEach((e) => {
        if (e.selectionNumber > origNumber) {
          e.selectionNumber = e.selectionNumber - 1
        }
      })
    },
    getSelectedOrders () {
      const r1 = this.keikakuSagyoMeisai.filter((e) => {
        return e.isSelected === true
      })
      const r2 = this.keikakuSagyoMeisai2.filter((e) => {
        return e.isSelected === true
      })
      return r1.concat(r2)
    },
    getSelectedDriver () {
      return this.keikakuJininList.filter((e) => {
        return e.isSelected === true && e.selectionNumber !== 0
      }).sort((d, s) => {
        return d.selectionNumber - s.selectionNumber
      })
    },
    getMaxSelctionNumber: function () {
      if (this.keikakuJininList.length === 0) {
        return 0
      }
      return Math.max.apply(null, this.keikakuJininList.map(function (o) {
        return o.selectionNumber
      }))
    },
    hasUpdateDats () {
      var t = this.recCar.find((e) => {
        return e.updateFlg === true
      })
      if (!t) {
        t = this.recDriver.find((e) => {
          return e.updateFlg === true
        })
      }
      if (t) {
        return true
      }
      return false
    },
    isAllOrderAndDriverEmpty (carid) {
      const self = this
      const plans = this.filteredRows.filter((e) => {
        return e.car.id === carid && (self.isValidDriver(e.driver) || self.isValidDriver(e.subDriver) || (e.orderD && e.orderD.length > 0))
      })
      if (!plans || plans.length === 0) {
        return true
      }
      return false
    },
    isOneOfOrderAndDriverFixed (carid) {
      const plan = this.filteredRows.filter((ex) => {
        return ex.car.id === carid && !(ex.jissekiStatus === '1' || ex.jissekiStatus === '9')
      }).find((e) => {
        return e.car.id === carid && (e.jomuinKakuteiFlg || e.dojoshaKakuteiFlg || (e.orderD && e.orderD.find((eo) => { return eo.kakuteiFlg })))
      })
      if (plan) {
        return true
      }
      return false
    },
    isOneOfOrderAndDriverNotFixed (carid) {
      const self = this
      const plan = this.filteredRows.find((e) => {
        return e.car.id === carid && ((self.isValidDriver(e.driver) && !e.jomuinKakuteiFlg) || (self.isValidDriver(e.subDriver) && !e.dojoshaKakuteiFlg) || (e.orderD && e.orderD.find((eo) => { return !eo.kakuteiFlg })))
      })
      return !!plan
    },
    setFixAllOnCar (carid) {
      const self = this
      this.filteredRows.filter((e) => {
        return e.car.id === carid
      }).forEach((e) => {
        if (self.isValidDriver(e.driver)) {
          e.jomuinKakuteiFlg = true
        }
        if (self.isValidDriver(e.subDriver)) {
          e.dojoshaKakuteiFlg = true
        }
        if (e.orderD) {
          e.orderD.forEach((eo) => {
            if (self.tekiyoYmdDayjs.isSame(eo.sagyoYmd, 'd')) {
              eo.kakuteiFlg = true
            }
          })
        }
        e.updateFlg = true
      })
    },
    setNotFixAllOnCar (carid) {
      const self = this
      this.filteredRows.filter((e) => {
        return e.car.id === carid && !(e.jissekiStatus === '1' || e.jissekiStatus === '9')
      }).forEach((e) => {
        e.jomuinKakuteiFlg = false
        e.dojoshaKakuteiFlg = false
        if (e.orderD) {
          e.orderD.forEach((eo) => {
            if (self.tekiyoYmdDayjs.isSame(eo.sagyoYmd, 'd')) {
              eo.kakuteiFlg = false
            }
          })
        }
        e.updateFlg = true
      })
    },
    // #endregion

    /**
     * 日計表出力画面別ウィンドウ起動
     */
    onOpenDailyTotalClick: function (e) {
      var url = location.href
      url = url.substring(0, url.indexOf('#/'))
      url = url + '#/bzm/nikkeihyo/list/'
      window.open(url, '_blank')
    },
    /**
     * サマリ表示切替
     */
    onShowSammary: function (e) {
      this.showSummary = !this.showSummary
    }
  }
}
